import {
  useMutation,
  useQuery,
  UseMutationOptions,
  UseQueryOptions,
} from "@tanstack/react-query";
import { fetcher } from "./fetcher";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type AdminConnectionStats = {
  __typename?: "AdminConnectionStats";
  byProvider: Array<AdminConnectionsByProvider>;
  connectedCount: Scalars["Int"]["output"];
  degradedCount: Scalars["Int"]["output"];
  disconnectedCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type AdminConnectionsByProvider = {
  __typename?: "AdminConnectionsByProvider";
  count: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
};

export type AdminDailyOrdersBreakdown = {
  __typename?: "AdminDailyOrdersBreakdown";
  count: Scalars["Int"]["output"];
  date: Scalars["String"]["output"];
  revenue: Scalars["Float"]["output"];
};

export type AdminDashboardInput = {
  lowStockThreshold?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminDashboardStats = {
  __typename?: "AdminDashboardStats";
  connections: AdminConnectionStats;
  listings: AdminListingStats;
  orders: AdminOrderStats;
  recentSync: AdminSyncStats;
  sellers: AdminSellerStats;
  subscriptions: AdminSubscriptionStats;
  users: AdminUserStats;
};

export type AdminFlipkartWebhookProvisioning = {
  __typename?: "AdminFlipkartWebhookProvisioning";
  approvedAt?: Maybe<Scalars["DateTime"]["output"]>;
  batchReference?: Maybe<Scalars["String"]["output"]>;
  connectionId: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  enabledAt?: Maybe<Scalars["DateTime"]["output"]>;
  exportedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  lastError?: Maybe<Scalars["String"]["output"]>;
  locationIds: Array<Scalars["String"]["output"]>;
  registeredEmail: Scalars["String"]["output"];
  sellerId?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type AdminListingStats = {
  __typename?: "AdminListingStats";
  activeCount: Scalars["Int"]["output"];
  byProvider: Array<AdminListingsByProvider>;
  dayOnDayActiveChangePct: Scalars["Float"]["output"];
  dayOnDayChangePct: Scalars["Float"]["output"];
  inactiveCount: Scalars["Int"]["output"];
  newToday: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type AdminListingsByProvider = {
  __typename?: "AdminListingsByProvider";
  activeCount: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type AdminMarketplace = {
  __typename?: "AdminMarketplace";
  code: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  syncStatus: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type AdminOrderItem = {
  __typename?: "AdminOrderItem";
  currency?: Maybe<Scalars["String"]["output"]>;
  externalOrderId: Scalars["String"]["output"];
  fulfillmentType?: Maybe<Scalars["String"]["output"]>;
  gmv?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["String"]["output"];
  issueCount: Scalars["Int"]["output"];
  itemCount?: Maybe<Scalars["Int"]["output"]>;
  lastUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  orderedAt: Scalars["String"]["output"];
  rawStatus?: Maybe<Scalars["String"]["output"]>;
  riskLevel: Scalars["String"]["output"];
  sellerName: Scalars["String"]["output"];
  sellerWorkspaceId: Scalars["String"]["output"];
  slaStatus: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type AdminOrderStats = {
  __typename?: "AdminOrderStats";
  avgOrderValue: Scalars["Float"]["output"];
  byProvider: Array<AdminOrdersByProvider>;
  byStatus: Array<AdminOrdersByStatus>;
  cancelledCount: Scalars["Int"]["output"];
  confirmedCount: Scalars["Int"]["output"];
  dailyBreakdown: Array<AdminDailyOrdersBreakdown>;
  dayOnDayChangePct: Scalars["Float"]["output"];
  dayOnDayRevenueChangePct: Scalars["Float"]["output"];
  deliveredCount: Scalars["Int"]["output"];
  pendingCount: Scalars["Int"]["output"];
  processedCount: Scalars["Int"]["output"];
  returnedCount: Scalars["Int"]["output"];
  sevenDayRevenue: Scalars["Float"]["output"];
  shippedCount: Scalars["Int"]["output"];
  todayCount: Scalars["Int"]["output"];
  todayRevenue: Scalars["Float"]["output"];
  totalCount: Scalars["Int"]["output"];
  totalRevenue: Scalars["Float"]["output"];
  yesterdayCount: Scalars["Int"]["output"];
};

export type AdminOrdersByProvider = {
  __typename?: "AdminOrdersByProvider";
  count: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
};

export type AdminOrdersByStatus = {
  __typename?: "AdminOrdersByStatus";
  count: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
};

export type AdminOrdersInput = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  riskLevel?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  slaStatus?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<Scalars["String"]["input"]>;
  sortDir?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminOrdersKpi = {
  __typename?: "AdminOrdersKpi";
  atRiskCount: Scalars["Int"]["output"];
  breachedCount: Scalars["Int"]["output"];
  cancelled30d: Scalars["Int"]["output"];
  gmv30d: Scalars["Float"]["output"];
  gmv30dChangePct: Scalars["Float"]["output"];
  pendingCount: Scalars["Int"]["output"];
  returnsOpen: Scalars["Int"]["output"];
  shippedTodayChangePct: Scalars["Float"]["output"];
  shippedTodayCount: Scalars["Int"]["output"];
  todayCount: Scalars["Int"]["output"];
  todayCountChangePct: Scalars["Float"]["output"];
};

export type AdminOrdersPayload = {
  __typename?: "AdminOrdersPayload";
  items: Array<AdminOrderItem>;
  kpi: AdminOrdersKpi;
  page: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
};

export type AdminSellerStats = {
  __typename?: "AdminSellerStats";
  activeCount: Scalars["Int"]["output"];
  closedCount: Scalars["Int"]["output"];
  dayOnDayChangePct: Scalars["Float"]["output"];
  newToday: Scalars["Int"]["output"];
  suspendedCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type AdminSellerStatus = {
  __typename?: "AdminSellerStatus";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type AdminSellersInput = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminSellersPayload = {
  __typename?: "AdminSellersPayload";
  items: Array<SellerListItem>;
  page: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
};

export type AdminSubscriptionStats = {
  __typename?: "AdminSubscriptionStats";
  byPlan: Array<AdminSubscriptionsByPlan>;
  pastDue: Scalars["Int"]["output"];
  totalActive: Scalars["Int"]["output"];
  trialing: Scalars["Int"]["output"];
};

export type AdminSubscriptionsByPlan = {
  __typename?: "AdminSubscriptionsByPlan";
  count: Scalars["Int"]["output"];
  plan: Scalars["String"]["output"];
};

export type AdminSyncJobSummary = {
  __typename?: "AdminSyncJobSummary";
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  itemsProcessed: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
  startedAt?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  syncType: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type AdminSyncStats = {
  __typename?: "AdminSyncStats";
  failedLast24h: Scalars["Int"]["output"];
  recentJobs: Array<AdminSyncJobSummary>;
  runningCount: Scalars["Int"]["output"];
};

export type AdminUserEdge = {
  __typename?: "AdminUserEdge";
  cursor: Scalars["String"]["output"];
  node: IamUser;
};

export type AdminUserPayload = {
  __typename?: "AdminUserPayload";
  message: Scalars["String"]["output"];
};

export type AdminUserStats = {
  __typename?: "AdminUserStats";
  activeCount: Scalars["Int"]["output"];
  dayOnDayChangePct: Scalars["Float"]["output"];
  inactiveCount: Scalars["Int"]["output"];
  newToday: Scalars["Int"]["output"];
  pendingCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type AdminUsersConnection = {
  __typename?: "AdminUsersConnection";
  edges: Array<AdminUserEdge>;
  pageInfo: PageInfo;
};

export type AdminUsersFilter = {
  createdFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdvanceOnboardingStepInput = {
  /** The step being completed (e.g. PLAN_SELECT). Backend advances to the next step. */
  completedStep: WorkspaceOnboardingStep;
  workspaceId: Scalars["ID"]["input"];
};

export type AdvanceOnboardingStepPayload = {
  __typename?: "AdvanceOnboardingStepPayload";
  currentStep: WorkspaceOnboardingStep;
  status: WorkspaceOnboardingStatus;
};

export type AgentAnswer = {
  __typename?: "AgentAnswer";
  confidence?: Maybe<Scalars["Float"]["output"]>;
  copy?: Maybe<Scalars["String"]["output"]>;
  kind?: Maybe<Scalars["String"]["output"]>;
  model: Scalars["String"]["output"];
  path?: Maybe<Scalars["String"]["output"]>;
  twin?: Maybe<Scalars["String"]["output"]>;
};

export type AgentAnswers = {
  __typename?: "AgentAnswers";
  agreed: Scalars["Boolean"]["output"];
  answers: Array<AgentAnswer>;
};

export type AmazonAuthSessionInput = {
  workspaceId: Scalars["String"]["input"];
};

export type AmazonAuthSessionPayload = {
  __typename?: "AmazonAuthSessionPayload";
  sessionId: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type AmazonConfirmShipmentInput = {
  carrierCode: Scalars["String"]["input"];
  carrierName?: InputMaybe<Scalars["String"]["input"]>;
  items?: InputMaybe<Array<AmazonConfirmShipmentItemInput>>;
  orderId: Scalars["String"]["input"];
  packageReferenceId?: InputMaybe<Scalars["String"]["input"]>;
  shipDate?: InputMaybe<Scalars["String"]["input"]>;
  shipFromSupplySourceId?: InputMaybe<Scalars["String"]["input"]>;
  shippingMethod?: InputMaybe<Scalars["String"]["input"]>;
  trackingNumber: Scalars["String"]["input"];
};

export type AmazonConfirmShipmentItemInput = {
  orderItemId: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  transparencyCodes?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AmazonConfirmShipmentPayload = {
  __typename?: "AmazonConfirmShipmentPayload";
  amazonOrderId: Scalars["String"]["output"];
  confirmationId: Scalars["String"]["output"];
  confirmedAt: Scalars["String"]["output"];
  marketplaceId: Scalars["String"]["output"];
  orderId: Scalars["String"]["output"];
  orderStatus: Scalars["String"]["output"];
  packageReferenceId: Scalars["String"]["output"];
  rawStatus: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  trackingNumber: Scalars["String"]["output"];
};

export enum AmazonEasyShipDocumentType {
  Invoice = "Invoice",
  ShippingLabel = "ShippingLabel",
  Warranty = "Warranty",
}

export type AmazonEasyShipDocumentsPayload = {
  __typename?: "AmazonEasyShipDocumentsPayload";
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  feedId?: Maybe<Scalars["String"]["output"]>;
  feedProcessingStatus?: Maybe<Scalars["String"]["output"]>;
  fileName?: Maybe<Scalars["String"]["output"]>;
  requestId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type AmazonEasyShipHandoverSlotsInput = {
  heightCm: Scalars["Float"]["input"];
  lengthCm: Scalars["Float"]["input"];
  orderId: Scalars["String"]["input"];
  packageIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  weightGrams: Scalars["Int"]["input"];
  widthCm: Scalars["Float"]["input"];
};

export type AmazonEasyShipHandoverSlotsPayload = {
  __typename?: "AmazonEasyShipHandoverSlotsPayload";
  slots: Array<EasyShipSlot>;
};

export type AmazonEasyShipPackageItemInput = {
  orderItemId: Scalars["String"]["input"];
};

export type AmazonEasyShipSlotInput = {
  endTime: Scalars["String"]["input"];
  handoverMethod?: InputMaybe<Scalars["String"]["input"]>;
  slotId: Scalars["String"]["input"];
  startTime: Scalars["String"]["input"];
};

export type AmazonGetProductTypeSchemaInput = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  marketplaceId?: InputMaybe<Scalars["String"]["input"]>;
  productType: Scalars["String"]["input"];
  requirements?: InputMaybe<Scalars["String"]["input"]>;
  requirementsEnforced?: InputMaybe<Scalars["String"]["input"]>;
};

export type AmazonProductTypeSchemaDigestInput = {
  canonicalTaxonId?: InputMaybe<Scalars["String"]["input"]>;
  languageTag?: InputMaybe<Scalars["String"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  marketplaceId?: InputMaybe<Scalars["String"]["input"]>;
  productType: Scalars["String"]["input"];
  requirements?: InputMaybe<Scalars["String"]["input"]>;
  requirementsEnforced?: InputMaybe<Scalars["String"]["input"]>;
};

export type AmazonProductTypeSchemaDigestPayload = {
  __typename?: "AmazonProductTypeSchemaDigestPayload";
  aiResponse: Scalars["JSON"]["output"];
  canonicalSchemaPayload: Scalars["JSON"]["output"];
  marketplaceId: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  schemaHost: Scalars["String"]["output"];
};

export type AmazonProductTypeSchemaPayload = {
  __typename?: "AmazonProductTypeSchemaPayload";
  marketplaceId: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  productTypeDefinition: Scalars["JSON"]["output"];
  requiredFields: Array<AmazonRequiredSchemaField>;
  schema: Scalars["JSON"]["output"];
  schemaHost: Scalars["String"]["output"];
};

export type AmazonProductTypeSearchItem = {
  __typename?: "AmazonProductTypeSearchItem";
  displayName?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  raw: Scalars["JSON"]["output"];
  synced: Scalars["Boolean"]["output"];
};

export type AmazonRefreshEasyShipDocumentsInput = {
  orderId: Scalars["String"]["input"];
};

export type AmazonRequestEasyShipDocumentsInput = {
  documentTypes?: InputMaybe<Array<AmazonEasyShipDocumentType>>;
  orderId: Scalars["String"]["input"];
};

export type AmazonRequiredSchemaField = {
  __typename?: "AmazonRequiredSchemaField";
  allowedValues: Array<Scalars["JSON"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  format?: Maybe<Scalars["String"]["output"]>;
  path: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["JSON"]["output"]>;
};

export type AmazonScheduleEasyShipPackageInput = {
  heightCm: Scalars["Float"]["input"];
  lengthCm: Scalars["Float"]["input"];
  orderId: Scalars["String"]["input"];
  packageIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  packageItems?: InputMaybe<Array<AmazonEasyShipPackageItemInput>>;
  slot: AmazonEasyShipSlotInput;
  weightGrams: Scalars["Int"]["input"];
  widthCm: Scalars["Float"]["input"];
};

export type AmazonScheduledEasyShipPackagePayload = {
  __typename?: "AmazonScheduledEasyShipPackagePayload";
  amazonOrderId: Scalars["String"]["output"];
  packageId?: Maybe<Scalars["String"]["output"]>;
  packageIdentifier?: Maybe<Scalars["String"]["output"]>;
  packageStatus?: Maybe<Scalars["String"]["output"]>;
  raw: Scalars["JSON"]["output"];
  slot: EasyShipSlot;
};

export type AmazonSearchProductTypesInput = {
  itemName?: InputMaybe<Scalars["String"]["input"]>;
  keyword: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  marketplaceId?: InputMaybe<Scalars["String"]["input"]>;
  requirements?: InputMaybe<Scalars["String"]["input"]>;
  requirementsEnforced?: InputMaybe<Scalars["String"]["input"]>;
  searchLocale?: InputMaybe<Scalars["String"]["input"]>;
};

export type AmazonSearchProductTypesPayload = {
  __typename?: "AmazonSearchProductTypesPayload";
  productTypes: Array<AmazonProductTypeSearchItem>;
  raw: Scalars["JSON"]["output"];
};

export type AmazonSystemCredentialStatus = {
  __typename?: "AmazonSystemCredentialStatus";
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  authorizedBy?: Maybe<Scalars["String"]["output"]>;
  configured: Scalars["Boolean"]["output"];
};

export type ApproveFlipkartWebhookProvisioningInput = {
  locationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  provisioningId: Scalars["String"]["input"];
  sellerId: Scalars["String"]["input"];
};

export type AttributeReviewApproveInput = {
  decision: Scalars["String"]["input"];
  fieldDecisions?: InputMaybe<Array<AttributeReviewFieldDecisionInput>>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  sessionId: Scalars["ID"]["input"];
  /**
   * Optional explicit per-value decisions. If omitted for a field, the field's
   * enumMappings dict is treated as implicit approve-all-values on the backend.
   */
  valueDecisions?: InputMaybe<Array<AttributeReviewValueDecisionInput>>;
};

export type AttributeReviewApprovePayload = {
  __typename?: "AttributeReviewApprovePayload";
  auditId?: Maybe<Scalars["String"]["output"]>;
  decision: Scalars["String"]["output"];
  mappingDefinitionIds: Array<Scalars["String"]["output"]>;
  mappingSessionId: Scalars["ID"]["output"];
  /**
   * True when an approval job was already running for this session and the
   * approve was filed as the next QUEUED job instead of executing immediately.
   */
  queued?: Maybe<Scalars["Boolean"]["output"]>;
  syncJobId?: Maybe<Scalars["ID"]["output"]>;
};

export type AttributeReviewApproveSelectedInput = {
  fieldDecisions?: InputMaybe<Array<AttributeReviewFieldDecisionInput>>;
  idempotencyKey?: InputMaybe<Scalars["String"]["input"]>;
  /** The governed marketplace_id, not product_type. */
  marketplaceId: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  sessionId: Scalars["ID"]["input"];
  valueDecisions?: InputMaybe<Array<AttributeReviewSelectedValueDecisionInput>>;
};

export type AttributeReviewApproveSelectedPayload = {
  __typename?: "AttributeReviewApproveSelectedPayload";
  approval?: Maybe<AttributeReviewApprovePayload>;
  approvedFieldCount: Scalars["Int"]["output"];
  approvedValueCount: Scalars["Int"]["output"];
  failedFieldCount: Scalars["Int"]["output"];
  failedValueCount: Scalars["Int"]["output"];
  fieldResults: Array<AttributeReviewBulkFieldResult>;
  mappingSessionId: Scalars["ID"]["output"];
  marketplaceSpecificValueCount: Scalars["Int"]["output"];
  pipelineId?: Maybe<Scalars["String"]["output"]>;
  queued: Scalars["Boolean"]["output"];
  retryable: Scalars["Boolean"]["output"];
  skippedFieldCount: Scalars["Int"]["output"];
  skippedValueCount: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  syncJobId?: Maybe<Scalars["ID"]["output"]>;
  valueResults: Array<AttributeReviewBulkValueResult>;
};

export type AttributeReviewBulkFieldResult = {
  __typename?: "AttributeReviewBulkFieldResult";
  code?: Maybe<Scalars["String"]["output"]>;
  inputIndex: Scalars["Int"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  sourceFieldId: Scalars["String"]["output"];
  /** QUEUED, RUNNING, APPROVED, SKIPPED, or FAILED. */
  status: Scalars["String"]["output"];
};

export type AttributeReviewBulkValueResult = {
  __typename?: "AttributeReviewBulkValueResult";
  canonicalPath?: Maybe<Scalars["String"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  decision?: Maybe<Scalars["String"]["output"]>;
  inputIndex: Scalars["Int"]["output"];
  marketplaceSpecificKey?: Maybe<Scalars["String"]["output"]>;
  marketplaceValue?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  sourceFieldId?: Maybe<Scalars["String"]["output"]>;
  /** QUEUED, RUNNING, APPROVED, MARKETPLACE_SPECIFIC, SKIPPED, or FAILED. */
  status: Scalars["String"]["output"];
  valueApprovalId?: Maybe<Scalars["String"]["output"]>;
};

export type AttributeReviewFieldDecisionInput = {
  canonicalPath?: InputMaybe<Scalars["String"]["input"]>;
  /** With CLEAR: the field on this form that asks the same fact; the row becomes a hidden copy of it. */
  copyOf?: InputMaybe<Scalars["String"]["input"]>;
  /** Field-level decision: "APPROVE", "IGNORE" or "CLEAR". An old "REJECT" is read as "IGNORE". */
  decision: Scalars["String"]["input"];
  /**
   * Reviewer-confirmed value domain key for this field. Overrides the domain
   * the engine inferred or proposed.
   */
  domainKey?: InputMaybe<Scalars["String"]["input"]>;
  enumMappings?: InputMaybe<Scalars["JSON"]["input"]>;
  /**
   * A kinds.csv kind name, for a kind-session row. When set, the engine records
   * it on the row and no canonicalPath is sent.
   */
  kind?: InputMaybe<Scalars["String"]["input"]>;
  leaf?: InputMaybe<Scalars["String"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  pool?: InputMaybe<Scalars["String"]["input"]>;
  sourceFieldId: Scalars["String"]["input"];
  values?: InputMaybe<Array<AttributeReviewValueFixInput>>;
};

export type AttributeReviewFieldMappingItem = {
  __typename?: "AttributeReviewFieldMappingItem";
  agent?: Maybe<AgentAnswers>;
  aiBand?: Maybe<Scalars["String"]["output"]>;
  /** Each model's majority answer, forwarded as-is for stage 9; no screen draws it yet. */
  answers?: Maybe<Scalars["JSON"]["output"]>;
  arrayIndex?: Maybe<Scalars["Int"]["output"]>;
  /**
   * The canonical field's datatype as registered: string, number, boolean,
   * array, or null. Used by the UI to render array canonicals as path[N]
   * (one row per array_index) and to suppress the duplicate-canonical badge
   * when multiple rows legitimately share an array canonical at different
   * array_index values.
   */
  canonicalDatatype?: Maybe<Scalars["String"]["output"]>;
  canonicalExpansionRequestId?: Maybe<Scalars["String"]["output"]>;
  canonicalPath?: Maybe<Scalars["String"]["output"]>;
  collisionWinnerPath?: Maybe<Scalars["String"]["output"]>;
  copyOf?: Maybe<Scalars["String"]["output"]>;
  domainExists: Scalars["Boolean"]["output"];
  domainKey?: Maybe<Scalars["String"]["output"]>;
  domainSource?: Maybe<Scalars["String"]["output"]>;
  /** Always false. Kept because the old review screen's query selects it. */
  duplicateCanonicalPath: Scalars["Boolean"]["output"];
  enumDetailsTruncated: Scalars["Boolean"]["output"];
  enumMappingCount: Scalars["Int"]["output"];
  enumMappings: Scalars["JSON"]["output"];
  folder?: Maybe<Scalars["String"]["output"]>;
  gateVerdict?: Maybe<AttributeReviewGateVerdict>;
  hidden: Scalars["Boolean"]["output"];
  /**
   * Stage 8 kind step. Set only on a kind session's rows (never a path session):
   * the fact this field is, the kinds.csv folder it files under, the one fixed
   * review reason, and its own words. Never a GraphQL enum -- kinds.csv is the
   * only place a kind name is typed.
   */
  kind?: Maybe<Scalars["String"]["output"]>;
  leaf?: Maybe<Scalars["String"]["output"]>;
  leafRejection?: Maybe<Scalars["JSON"]["output"]>;
  leafSource?: Maybe<Scalars["String"]["output"]>;
  link: Scalars["Boolean"]["output"];
  linkField?: Maybe<Scalars["String"]["output"]>;
  linkOwner?: Maybe<Scalars["String"]["output"]>;
  llmReasoning?: Maybe<Scalars["String"]["output"]>;
  llmRequired: Scalars["Boolean"]["output"];
  lowConfidenceReason?: Maybe<Scalars["String"]["output"]>;
  mappingSource?: Maybe<Scalars["String"]["output"]>;
  marketplaceRawJson: Scalars["JSON"]["output"];
  marketplaceSpecific: Scalars["Boolean"]["output"];
  marketplaceSpecificAuditNote?: Maybe<Scalars["String"]["output"]>;
  marketplaceSpecificKey?: Maybe<Scalars["String"]["output"]>;
  marketplaceSpecificMarkedAt?: Maybe<Scalars["String"]["output"]>;
  marketplaceSpecificMarkedBy?: Maybe<Scalars["String"]["output"]>;
  marketplaceSpecificReason?: Maybe<MarketplaceSpecificReason>;
  marketplaceSpecificValueCount: Scalars["Int"]["output"];
  /** Engine-authoritative: true when this field still needs review. The FE buckets and counts from this flag; needReviewFields is the count of items where it is true. */
  needsReview: Scalars["Boolean"]["output"];
  ownPath?: Maybe<Scalars["String"]["output"]>;
  pastAnswer: Scalars["Boolean"]["output"];
  path?: Maybe<Scalars["String"]["output"]>;
  pathPreview?: Maybe<Scalars["String"]["output"]>;
  pathType?: Maybe<Scalars["String"]["output"]>;
  pendingCanonicalExpansion: Scalars["Boolean"]["output"];
  pendingGeneratedCanonicalValues: Scalars["JSON"]["output"];
  pendingGeneratedValueDomains: Scalars["JSON"]["output"];
  pool?: Maybe<Scalars["JSON"]["output"]>;
  proposedDomainKey?: Maybe<Scalars["String"]["output"]>;
  proposedDomainRationale?: Maybe<Scalars["String"]["output"]>;
  provenance?: Maybe<Scalars["String"]["output"]>;
  registryStatus?: Maybe<Scalars["String"]["output"]>;
  remapped?: Maybe<Scalars["JSON"]["output"]>;
  requirementLevel: Scalars["String"]["output"];
  /** Always false. Kept because the old review screen's query selects it. */
  requiresReReview: Scalars["Boolean"]["output"];
  review?: Maybe<Scalars["String"]["output"]>;
  reviewDetail?: Maybe<Scalars["String"]["output"]>;
  reviewReason?: Maybe<Scalars["String"]["output"]>;
  shadowRegistryEvidenceCount: Scalars["Int"]["output"];
  shadowRegistryMatch: Scalars["Boolean"]["output"];
  shadowRegistryPeerMarketplaces: Array<Scalars["String"]["output"]>;
  showKind?: Maybe<Scalars["String"]["output"]>;
  sourceDescription?: Maybe<Scalars["String"]["output"]>;
  sourceEnumValueCount: Scalars["Int"]["output"];
  sourceEnumValueLabels: Scalars["JSON"]["output"];
  sourceEnumValues: Array<Scalars["String"]["output"]>;
  sourceFieldId: Scalars["String"]["output"];
  sourceLabel?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  suggested: Array<Scalars["String"]["output"]>;
  unresolvedValueCount: Scalars["Int"]["output"];
  valueApprovalCount: Scalars["Int"]["output"];
  valueApprovals: Scalars["JSON"]["output"];
  valueResolutionSources: Scalars["JSON"]["output"];
  valueResolutionStatus: Scalars["JSON"]["output"];
  values?: Maybe<Scalars["JSON"]["output"]>;
  warnings?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type AttributeReviewFieldMappingsPayload = {
  __typename?: "AttributeReviewFieldMappingsPayload";
  canonicalTaxonId: Scalars["String"]["output"];
  /** Set only on a finished session: whether ops may edit one row, and why not. */
  finishedEdit?: Maybe<AttributeReviewFinishedEdit>;
  items: Array<AttributeReviewFieldMappingItem>;
  /** Every kinds.csv row. Non-empty only on a kind session; [] on a path session. */
  kindOptions: Array<AttributeReviewKindOption>;
  llmMappedFieldsCount: Scalars["Int"]["output"];
  llmRequiredFieldsCount: Scalars["Int"]["output"];
  llmSkipReason?: Maybe<Scalars["String"]["output"]>;
  llmSkipped: Scalars["Boolean"]["output"];
  lowConfidenceFields: Scalars["Int"]["output"];
  mappedFields: Scalars["Int"]["output"];
  mappingSessionId: Scalars["ID"]["output"];
  marketplace: Scalars["String"]["output"];
  marketplaceId?: Maybe<Scalars["String"]["output"]>;
  needReviewFields: Scalars["Int"]["output"];
  productType: Scalars["String"]["output"];
  schemaVersion: Scalars["String"]["output"];
  totalFields: Scalars["Int"]["output"];
};

export type AttributeReviewFinishedEdit = {
  __typename?: "AttributeReviewFinishedEdit";
  allowed: Scalars["Boolean"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
};

export type AttributeReviewGateVerdict = {
  __typename?: "AttributeReviewGateVerdict";
  reason?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  suggestedHome?: Maybe<Scalars["String"]["output"]>;
};

/** One row of the engine's kinds.csv. Never an enum: no kind name is typed in the server. */
export type AttributeReviewKindOption = {
  __typename?: "AttributeReviewKindOption";
  folder: Scalars["String"]["output"];
  kind: Scalars["String"]["output"];
  productField: Scalars["Boolean"]["output"];
};

/**
 * Per-value decision for Approve Selected. Submitted to taxonomy's
 * approve-session value_decisions API.
 */
export type AttributeReviewSelectedValueDecisionInput = {
  /** @deprecated marketplace_specific decisions are not accepted */
  auditNote?: InputMaybe<Scalars["String"]["input"]>;
  canonicalPath: Scalars["String"]["input"];
  canonicalValueId?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated marketplace_specific decisions are not accepted */
  collisionWinnerPath?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Deprecated. See AttributeReviewValueDecisionInput.createExportMapping —
   * same semantics: implied true for create_new_canonical_value, ignored
   * for other decisions, preserved only for backward compatibility.
   * @deprecated Implied true for create_new_canonical_value; ignored for other decisions. The server creates the export mapping unconditionally for create_new_canonical_value.
   */
  createExportMapping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * One of: approve, reject, create_new_canonical_value.
   * Clear/revert is not exposed until taxonomy provides a supported endpoint.
   */
  decision: Scalars["String"]["input"];
  /**
   * For 'create_new_canonical_value': the marketplace-specific string the
   * canonical value should render as when products carrying it are
   * exported back to this marketplace. Required — without it the
   * round-trip is broken. Enforced server-side by the Python schema
   * validator and client-side by the admin form.
   */
  exportValue?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Unused: the three fields below fed the marketplace_specific decision, which
   * is no longer accepted. Kept so the old review screen's approve still validates.
   * @deprecated marketplace_specific decisions are not accepted
   */
  marketplaceSpecificReason?: InputMaybe<MarketplaceSpecificReason>;
  marketplaceValue: Scalars["String"]["input"];
  newLabel?: InputMaybe<Scalars["String"]["input"]>;
  newValueKey?: InputMaybe<Scalars["String"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  rejectionScope?: InputMaybe<Scalars["String"]["input"]>;
  sourceFieldId?: InputMaybe<Scalars["String"]["input"]>;
  valueApprovalId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Single attribute-review session by ID (typed; use raw for full backend payload). */
export type AttributeReviewSession = {
  __typename?: "AttributeReviewSession";
  canonicalTaxonId: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["String"]["output"]>;
  lowConfidenceFields?: Maybe<Scalars["Int"]["output"]>;
  mappedFields?: Maybe<Scalars["Int"]["output"]>;
  mappingSessionId: Scalars["ID"]["output"];
  marketplace: Scalars["String"]["output"];
  needReviewFields?: Maybe<Scalars["Int"]["output"]>;
  productType: Scalars["String"]["output"];
  progress?: Maybe<Scalars["Float"]["output"]>;
  /** Full session payload from backend (for flexibility until all fields are typed). */
  raw?: Maybe<Scalars["JSON"]["output"]>;
  schemaVersion: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  totalFields?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type AttributeReviewSessionSummary = {
  __typename?: "AttributeReviewSessionSummary";
  canonicalTaxonId: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
  lowConfidenceFields: Scalars["Int"]["output"];
  mappedFields: Scalars["Int"]["output"];
  mappingSessionId: Scalars["ID"]["output"];
  marketplace: Scalars["String"]["output"];
  needReviewFields: Scalars["Int"]["output"];
  productType: Scalars["String"]["output"];
  progress: Scalars["Float"]["output"];
  schemaVersion: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  totalFields: Scalars["Int"]["output"];
};

/**
 * Per-value decision for the canonical_values registry. Supplied alongside
 * fieldDecisions to explicitly approve / reject / edit a single (canonical_path,
 * marketplace_value) pair so the global canonical_values + canonical_value_synonyms
 * stores accumulate vocabulary across sessions. For boolean / trivially-resolved
 * values, the UI auto-builds these from the field's enumMappings.
 */
export type AttributeReviewValueDecisionInput = {
  canonicalPath: Scalars["String"]["input"];
  /** Optional explicit canonical_value_id (if the UI already resolved it). */
  canonicalValueId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Deprecated. For 'create_new_canonical_value' the server now always
   * creates the marketplace export mapping alongside the canonical value
   * — the round-trip is structurally required because the canonical
   * value only exists because the source marketplace surfaced an unknown
   * raw value. The server normalizes this flag to true for that decision
   * type and ignores any other value. Preserved for backward
   * compatibility with older clients; may be removed once no client
   * sends it.
   * @deprecated Implied true for create_new_canonical_value; ignored for other decisions. The server creates the export mapping unconditionally for create_new_canonical_value.
   */
  createExportMapping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * One of: approve, reject, create_new_canonical_value.
   * Raw edit decisions are rejected by the server for generated/changed values;
   * use approve with canonicalValueId or create_new_canonical_value instead.
   */
  decision: Scalars["String"]["input"];
  /**
   * Unused. It only ever fed the 'edit' decision, which the server always
   * refused and no client ever sent. Kept so older clients do not break.
   * @deprecated edit decisions are not accepted
   */
  editedCanonicalValue?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * For 'create_new_canonical_value': the marketplace-specific string the
   * canonical value should render as when products carrying it are
   * exported back to this marketplace. Required — without it the
   * round-trip is broken (the export composer has no string to write).
   * Enforced server-side by the Python schema validator and client-side
   * by the admin form (defaults to the marketplace's source value, only
   * edited for the rare case where import and export strings differ).
   */
  exportValue?: InputMaybe<Scalars["String"]["input"]>;
  marketplaceValue: Scalars["String"]["input"];
  /** For 'create_new_canonical_value': human-readable label. */
  newLabel?: InputMaybe<Scalars["String"]["input"]>;
  /** For 'create_new_canonical_value': the new canonical key to create. */
  newValueKey?: InputMaybe<Scalars["String"]["input"]>;
  /** For 'reject': free-form reason logged to canonical_value_rejections. */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  rejectionScope?: InputMaybe<Scalars["String"]["input"]>;
  sourceFieldId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Stable registry review-item identity for registry-backed value approvals.
   * Required by the approval service when the session carries persisted value
   * review items; preserved alongside canonicalPath / marketplaceValue for
   * legacy compatibility.
   */
  valueApprovalId?: InputMaybe<Scalars["String"]["input"]>;
};

export type AttributeReviewValueDomainSearchItem = {
  __typename?: "AttributeReviewValueDomainSearchItem";
  domainKey: Scalars["String"]["output"];
};

export type AttributeReviewValueDomainSearchPayload = {
  __typename?: "AttributeReviewValueDomainSearchPayload";
  items: Array<AttributeReviewValueDomainSearchItem>;
};

export type AttributeReviewValueFixInput = {
  ignored?: InputMaybe<Scalars["Boolean"]["input"]>;
  newValue?: InputMaybe<Scalars["JSON"]["input"]>;
  poolValue?: InputMaybe<Scalars["String"]["input"]>;
  storeValue: Scalars["String"]["input"];
};

export type BulkExecuteMarketplaceFulfillmentActionInput = {
  action: Scalars["String"]["input"];
  orderIds: Array<Scalars["String"]["input"]>;
  payload?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type BulkFlipkartShipmentsInput = {
  orderIds: Array<Scalars["String"]["input"]>;
};

export type BulkPackFlipkartShipmentsInput = {
  invoiceDate: Scalars["String"]["input"];
  orderIds: Array<Scalars["String"]["input"]>;
};

export type BulkPrintSnapdealDocumentsInput = {
  orderIds: Array<Scalars["String"]["input"]>;
  thermalEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BulkPrintSnapdealHandoverInput = {
  orderIds: Array<Scalars["String"]["input"]>;
  reprint?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BulkShipShopifyOrdersWithShiprocketInput = {
  heightCm: Scalars["Float"]["input"];
  lengthCm: Scalars["Float"]["input"];
  notifyCustomer?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderIds: Array<Scalars["String"]["input"]>;
  weightGrams: Scalars["Int"]["input"];
  widthCm: Scalars["Float"]["input"];
};

export type BulkShiprocketLabelPayload = {
  __typename?: "BulkShiprocketLabelPayload";
  failedCount: Scalars["Int"]["output"];
  results: Array<BulkShiprocketLabelResult>;
  successCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type BulkShiprocketLabelResult = {
  __typename?: "BulkShiprocketLabelResult";
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  fileName?: Maybe<Scalars["String"]["output"]>;
  orderIds: Array<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type BulkShiprocketOperationPayload = {
  __typename?: "BulkShiprocketOperationPayload";
  failedCount: Scalars["Int"]["output"];
  results: Array<BulkShiprocketOperationResult>;
  successCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type BulkShiprocketOperationResult = {
  __typename?: "BulkShiprocketOperationResult";
  awbNumber?: Maybe<Scalars["String"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["String"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type BulkShiprocketPickupPayload = {
  __typename?: "BulkShiprocketPickupPayload";
  failedCount: Scalars["Int"]["output"];
  results: Array<BulkShiprocketPickupResult>;
  successCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type BulkShiprocketPickupResult = {
  __typename?: "BulkShiprocketPickupResult";
  error?: Maybe<Scalars["String"]["output"]>;
  orderIds: Array<Scalars["String"]["output"]>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  tokenNumber?: Maybe<Scalars["String"]["output"]>;
};

export type BulkSnapdealOrdersInput = {
  orderIds: Array<Scalars["String"]["input"]>;
};

export type CacheMeeshoCategorySchemaInput = {
  categoryPath?: InputMaybe<Scalars["String"]["input"]>;
  schemaData: Scalars["JSON"]["input"];
  sscatId: Scalars["String"]["input"];
  supplierId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CacheMeeshoCategorySchemaPayload = {
  __typename?: "CacheMeeshoCategorySchemaPayload";
  sscatId: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type CancelFlipkartShipmentInput = {
  cancellationGroupIds: Array<Scalars["String"]["input"]>;
  orderId: Scalars["String"]["input"];
  reason: Scalars["String"]["input"];
  /** The shipment to act on; defaults to the one that needs work now. */
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CancelSyncInput = {
  syncJobId: Scalars["ID"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ChangePasswordInput = {
  currentPassword: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
};

export type ClaimMeeshoProductSaveJobInput = {
  jobId: Scalars["String"]["input"];
};

export type ClaimMeeshoProductSaveJobPayload = {
  __typename?: "ClaimMeeshoProductSaveJobPayload";
  claimed: Scalars["Boolean"]["output"];
  jobId: Scalars["String"]["output"];
  marketplacePayload?: Maybe<Scalars["JSON"]["output"]>;
  status: Scalars["String"]["output"];
};

export type CompleteMeeshoProductSaveInput = {
  errorMessage?: InputMaybe<Scalars["String"]["input"]>;
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["String"]["input"];
  success: Scalars["Boolean"]["input"];
};

export type CompleteMeeshoProductSavePayload = {
  __typename?: "CompleteMeeshoProductSavePayload";
  jobId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type CompleteMeeshoSchemaFetchJobInput = {
  categoryPath?: InputMaybe<Scalars["String"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["String"]["input"];
  schemaData: Scalars["JSON"]["input"];
  sscatId: Scalars["String"]["input"];
  success: Scalars["Boolean"]["input"];
  supplierId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompleteMeeshoSchemaFetchJobPayload = {
  __typename?: "CompleteMeeshoSchemaFetchJobPayload";
  jobId: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type ConfirmProductMediaUploadInput = {
  assetId: Scalars["ID"]["input"];
};

export type ConnectCoupangSellerInput = {
  accessKey: Scalars["String"]["input"];
  secretKey: Scalars["String"]["input"];
  vendorId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ConnectCoupangSellerPayload = {
  __typename?: "ConnectCoupangSellerPayload";
  connectionId: Scalars["String"]["output"];
};

export type ConnectMarketplaceLogisticsInput = {
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  logisticsConnectionId: Scalars["ID"]["input"];
  marketplaceConnectionId: Scalars["ID"]["input"];
  workspaceId: Scalars["ID"]["input"];
};

export type ConnectMeeshoSellerInput = {
  supplierId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ConnectMeeshoSellerPayload = {
  __typename?: "ConnectMeeshoSellerPayload";
  connectionId: Scalars["String"]["output"];
};

export type ConnectShopcluesSellerInput = {
  password: Scalars["String"]["input"];
  userName: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ConnectShopcluesSellerPayload = {
  __typename?: "ConnectShopcluesSellerPayload";
  companyId: Scalars["String"]["output"];
  connectionId: Scalars["String"]["output"];
};

export type ConnectShopifySellerInput = {
  accessToken: Scalars["String"]["input"];
  shopDomain: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ConnectShopifySellerPayload = {
  __typename?: "ConnectShopifySellerPayload";
  connectionId: Scalars["String"]["output"];
};

export type ConnectSnapdealSellerInput = {
  authToken: Scalars["String"]["input"];
  clientId: Scalars["String"]["input"];
  sellerAuthzToken: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ConnectSnapdealSellerPayload = {
  __typename?: "ConnectSnapdealSellerPayload";
  connectionId: Scalars["String"]["output"];
};

export type ConnectionSummary = {
  __typename?: "ConnectionSummary";
  lastErrorMessage?: Maybe<Scalars["String"]["output"]>;
  lastSyncAt?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type CoupangCategoryRecommendInput = {
  brand?: InputMaybe<Scalars["String"]["input"]>;
  productDescription?: InputMaybe<Scalars["String"]["input"]>;
  productName: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CoupangCategoryRecommendItem = {
  __typename?: "CoupangCategoryRecommendItem";
  categoryId: Scalars["String"]["output"];
  categoryName: Scalars["String"]["output"];
  isCatchAll: Scalars["Boolean"]["output"];
  resultType: Scalars["String"]["output"];
};

export type CoupangCategoryRecommendPayload = {
  __typename?: "CoupangCategoryRecommendPayload";
  categories: Array<CoupangCategoryRecommendItem>;
  productName: Scalars["String"]["output"];
  raw: Scalars["JSON"]["output"];
  searchedAs: Scalars["String"]["output"];
};

export type CoupangCategorySchemaDigestInput = {
  displayCategoryCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CoupangCategorySchemaDigestPayload = {
  __typename?: "CoupangCategorySchemaDigestPayload";
  canonicalSchemaPayload: Scalars["JSON"]["output"];
  displayCategoryCode: Scalars["String"]["output"];
  raw: Scalars["JSON"]["output"];
};

export type CoupangOutboundShippingPlace = {
  __typename?: "CoupangOutboundShippingPlace";
  outboundShippingPlaceCode: Scalars["String"]["output"];
  shippingPlaceName: Scalars["String"]["output"];
};

export type CoupangReturnCenter = {
  __typename?: "CoupangReturnCenter";
  companyContactNumber: Scalars["String"]["output"];
  returnAddress: Scalars["String"]["output"];
  returnAddressDetail: Scalars["String"]["output"];
  returnCenterCode: Scalars["String"]["output"];
  returnZipCode: Scalars["String"]["output"];
  shippingPlaceName: Scalars["String"]["output"];
};

export type CoupangShippingOptionsPayload = {
  __typename?: "CoupangShippingOptionsPayload";
  outboundShippingPlaces: Array<CoupangOutboundShippingPlace>;
  returnCenters: Array<CoupangReturnCenter>;
};

export type CreateDraftFromSellerProductInput = {
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateMarketplaceFacilitatorInput = {
  cartServiceId?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<Scalars["JSON"]["input"]>;
  facilitatorWorkspaceId: Scalars["String"]["input"];
  marketplaceCode: Scalars["String"]["input"];
  shopcluesCompanyId?: InputMaybe<Scalars["String"]["input"]>;
  shopcluesSellerId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateMarketplaceFulfillmentEventInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  fulfillmentId: Scalars["String"]["input"];
  happenedAt?: InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["String"]["input"];
  province?: InputMaybe<Scalars["String"]["input"]>;
  status: MarketplaceFulfillmentEventStatus;
  zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateMarketplaceFulfillmentInput = {
  carrierCode?: InputMaybe<Scalars["String"]["input"]>;
  carrierName?: InputMaybe<Scalars["String"]["input"]>;
  heightCm?: InputMaybe<Scalars["Float"]["input"]>;
  lengthCm?: InputMaybe<Scalars["Float"]["input"]>;
  notifyCustomer?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["String"]["input"];
  packageReferenceId: Scalars["String"]["input"];
  selections: Array<MarketplaceFulfillmentSelectionInput>;
  shipDate?: InputMaybe<Scalars["String"]["input"]>;
  shippingMethod?: InputMaybe<Scalars["String"]["input"]>;
  trackingNumber: Scalars["String"]["input"];
  trackingUrl?: InputMaybe<Scalars["String"]["input"]>;
  weightGrams?: InputMaybe<Scalars["Int"]["input"]>;
  widthCm?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateProductMediaUploadInput = {
  draftId?: InputMaybe<Scalars["ID"]["input"]>;
  filename: Scalars["String"]["input"];
  mimeType: Scalars["String"]["input"];
  sizeBytes: Scalars["Int"]["input"];
};

export type CreateShopcluesWalletTopupInput = {
  amount: Scalars["Int"]["input"];
  workspaceId: Scalars["ID"]["input"];
};

export type CreateWorkspaceInput = {
  addressLine1: Scalars["String"]["input"];
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  currency: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
  stateOrRegion: Scalars["String"]["input"];
  taxId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateWorkspacePayload = {
  __typename?: "CreateWorkspacePayload";
  workspace: Workspace;
};

export type CreateWorkspaceSubscriptionInput = {
  cancelAtPeriodEnd?: InputMaybe<Scalars["Boolean"]["input"]>;
  currentPeriodEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  currentPeriodStart?: InputMaybe<Scalars["DateTime"]["input"]>;
  planCode: SubscriptionPlanCode;
  provider?: InputMaybe<SubscriptionProvider>;
  providerCustomerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSubscriptionId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<SubscriptionStatus>;
  workspaceId: Scalars["ID"]["input"];
};

export type CreateWorkspaceSubscriptionPayload = {
  __typename?: "CreateWorkspaceSubscriptionPayload";
  subscription: WorkspaceSubscription;
};

export type DailyOrdersBreakdown = {
  __typename?: "DailyOrdersBreakdown";
  count: Scalars["Int"]["output"];
  date: Scalars["String"]["output"];
  revenue: Scalars["Float"]["output"];
};

export type DashboardConnections = {
  __typename?: "DashboardConnections";
  connectedCount: Scalars["Int"]["output"];
  connections: Array<ConnectionSummary>;
  totalCount: Scalars["Int"]["output"];
};

export type DashboardInput = {
  lowStockThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type DashboardInventory = {
  __typename?: "DashboardInventory";
  lowStockCount: Scalars["Int"]["output"];
  lowStockItems: Array<LowStockItem>;
  lowStockThreshold: Scalars["Int"]["output"];
  outOfStockCount: Scalars["Int"]["output"];
  totalAvailableUnits: Scalars["Int"]["output"];
  totalListingsTracked: Scalars["Int"]["output"];
  totalOnHandUnits: Scalars["Int"]["output"];
  totalStockUnits: Scalars["Int"]["output"];
};

export type DashboardListings = {
  __typename?: "DashboardListings";
  activeCount: Scalars["Int"]["output"];
  byProvider: Array<ListingsByProvider>;
  dayOnDayActiveChangePct: Scalars["Float"]["output"];
  dayOnDayChangePct: Scalars["Float"]["output"];
  inactiveCount: Scalars["Int"]["output"];
  newToday: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type DashboardOrders = {
  __typename?: "DashboardOrders";
  avgOrderValue: Scalars["Float"]["output"];
  byProvider: Array<OrdersByProvider>;
  byStatus: Array<OrdersByStatus>;
  dailyBreakdown: Array<DailyOrdersBreakdown>;
  dayOnDayChangePct: Scalars["Float"]["output"];
  dayOnDayRevenueChangePct: Scalars["Float"]["output"];
  todayCount: Scalars["Int"]["output"];
  todayRevenue: Scalars["Float"]["output"];
  totalCount: Scalars["Int"]["output"];
  totalRevenue: Scalars["Float"]["output"];
  yesterdayCount: Scalars["Int"]["output"];
};

export type DashboardStats = {
  __typename?: "DashboardStats";
  connections: DashboardConnections;
  inventory: DashboardInventory;
  listings: DashboardListings;
  orders: DashboardOrders;
  recentSync: DashboardSync;
};

export type DashboardSync = {
  __typename?: "DashboardSync";
  failedLast24h: Scalars["Int"]["output"];
  recentJobs: Array<SyncJobSummary>;
};

export type DeleteMappingSessionInput = {
  removeSavedAnswers?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionId: Scalars["ID"]["input"];
};

export type DeleteMappingSessionResult = {
  __typename?: "DeleteMappingSessionResult";
  deleted: Scalars["Boolean"]["output"];
  sessionId: Scalars["ID"]["output"];
};

export type DeleteSellerProductMarketplaceListingInput = {
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  listingId: Scalars["ID"]["input"];
  provider: Scalars["String"]["input"];
  skuCode?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type DeleteSellerProductMarketplaceListingPayload = {
  __typename?: "DeleteSellerProductMarketplaceListingPayload";
  externalId?: Maybe<Scalars["String"]["output"]>;
  listingId: Scalars["ID"]["output"];
  marketplace: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type DisconnectAmazonSellerInput = {
  workspaceId: Scalars["String"]["input"];
};

export type DisconnectAmazonSellerPayload = {
  __typename?: "DisconnectAmazonSellerPayload";
  success: Scalars["Boolean"]["output"];
};

export type DisconnectLogisticsConnectionInput = {
  logisticsConnectionId: Scalars["ID"]["input"];
  workspaceId: Scalars["ID"]["input"];
};

export type DisconnectLogisticsConnectionPayload = {
  __typename?: "DisconnectLogisticsConnectionPayload";
  success: Scalars["Boolean"]["output"];
};

export type DisconnectMarketplaceLogisticsInput = {
  logisticsConnectionId: Scalars["ID"]["input"];
  marketplaceConnectionId: Scalars["ID"]["input"];
  workspaceId: Scalars["ID"]["input"];
};

export type DisconnectMarketplaceLogisticsPayload = {
  __typename?: "DisconnectMarketplaceLogisticsPayload";
  success: Scalars["Boolean"]["output"];
};

export type DisconnectMarketplaceSellerInput = {
  provider: MarketplaceProvider;
  workspaceId: Scalars["String"]["input"];
};

export type DisconnectMarketplaceSellerPayload = {
  __typename?: "DisconnectMarketplaceSellerPayload";
  success: Scalars["Boolean"]["output"];
};

export type DismissStockMismatchesInput = {
  draftIds: Array<Scalars["ID"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type DownloadBulkFlipkartShipmentDocumentInput = {
  kind: FlipkartShipmentDocumentKind;
  orderIds: Array<Scalars["String"]["input"]>;
};

export type DownloadBulkShiprocketLabelsInput = {
  orderIds: Array<Scalars["String"]["input"]>;
};

export type DownloadFlipkartManifestInput = {
  isMps: Scalars["Boolean"]["input"];
  orderId: Scalars["String"]["input"];
  pickUpAfter?: InputMaybe<Scalars["String"]["input"]>;
  pickUpBefore?: InputMaybe<Scalars["String"]["input"]>;
  /** The shipment to act on; defaults to the one that needs work now. */
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
  vendorGroupCode: Scalars["String"]["input"];
};

export type DownloadFlipkartShipmentDocumentInput = {
  kind: FlipkartShipmentDocumentKind;
  orderId: Scalars["String"]["input"];
  /** The shipment to act on; defaults to the one that needs work now. */
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type DownloadShiprocketLabelInput = {
  awbNumber?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["String"]["input"];
};

export enum DraftViewerRole {
  Facilitator = "FACILITATOR",
  Owner = "OWNER",
}

export type EasyShipSlot = {
  __typename?: "EasyShipSlot";
  endTime: Scalars["String"]["output"];
  handoverMethod?: Maybe<Scalars["String"]["output"]>;
  slotId: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
};

export type EbayAuthSessionInput = {
  workspaceId: Scalars["String"]["input"];
};

export type EbayAuthSessionPayload = {
  __typename?: "EbayAuthSessionPayload";
  sessionId: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type EbayCategoryMatch = {
  __typename?: "EbayCategoryMatch";
  categoryId: Scalars["String"]["output"];
  categoryName: Scalars["String"]["output"];
  fullPath: Scalars["String"]["output"];
};

export type EbayCategorySchemaDigestInput = {
  canonicalTaxonId?: InputMaybe<Scalars["String"]["input"]>;
  categoryId: Scalars["String"]["input"];
  categoryTreeId: Scalars["String"]["input"];
  marketplaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type EbayCategorySchemaDigestPayload = {
  __typename?: "EbayCategorySchemaDigestPayload";
  canonicalSchemaPayload: Scalars["JSON"]["output"];
  categoryId: Scalars["String"]["output"];
  categoryName?: Maybe<Scalars["String"]["output"]>;
  categoryTreeId: Scalars["String"]["output"];
  marketplaceId: Scalars["String"]["output"];
};

export type EbayCategorySearchInput = {
  categoryTreeId?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  marketplaceId?: InputMaybe<Scalars["String"]["input"]>;
  query: Scalars["String"]["input"];
};

export type EbayCategorySearchPayload = {
  __typename?: "EbayCategorySearchPayload";
  categories: Array<EbayCategoryMatch>;
  categoryTreeId?: Maybe<Scalars["String"]["output"]>;
};

export enum EntitlementDisplayType {
  Both = "BOTH",
  Brief = "BRIEF",
  Summary = "SUMMARY",
}

export enum EntitlementValueType {
  Bool = "BOOL",
  Int = "INT",
  Json = "JSON",
  Text = "TEXT",
}

export type ExecuteMarketplaceFulfillmentActionInput = {
  action: Scalars["String"]["input"];
  orderId: Scalars["String"]["input"];
  payload?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type ExtractProductListingInput = {
  canonicalCategoryId: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  marketplaces: Array<Scalars["String"]["input"]>;
  text: Scalars["String"]["input"];
};

export type ExtractProductListingPayload = {
  __typename?: "ExtractProductListingPayload";
  canonicalCategoryId: Scalars["String"]["output"];
  enrichment?: Maybe<ListingEnrichment>;
  fields: Array<ExtractedListingField>;
  missingRecommended: Array<MissingListingField>;
  missingRequired: Array<MissingListingField>;
};

export type ExtractedListingField = {
  __typename?: "ExtractedListingField";
  canonicalPath: Scalars["String"]["output"];
  confidence: Scalars["Float"]["output"];
  evidence?: Maybe<Scalars["String"]["output"]>;
  needsReview: Scalars["Boolean"]["output"];
  /** "extracted" (stated in the seller text) or "derived" (AI-composed copy). */
  source: Scalars["String"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
  /** Form-shaped value (string or string array) — merge into canonicalData verbatim. */
  value: Scalars["JSON"]["output"];
};

export type FacilitatedSeller = {
  __typename?: "FacilitatedSeller";
  name: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type FieldUserRow = {
  __typename?: "FieldUserRow";
  label: Scalars["String"]["output"];
  marketplace: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  productTypeName: Scalars["String"]["output"];
};

export type FlipkartAuthSessionInput = {
  workspaceId: Scalars["String"]["input"];
};

export type FlipkartAuthSessionPayload = {
  __typename?: "FlipkartAuthSessionPayload";
  sessionId: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type FlipkartBulkOperationPayload = {
  __typename?: "FlipkartBulkOperationPayload";
  failedCount: Scalars["Int"]["output"];
  results: Array<FlipkartBulkOperationResult>;
  successCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type FlipkartBulkOperationResult = {
  __typename?: "FlipkartBulkOperationResult";
  error?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["String"]["output"];
  /** The shipment this line is about; null when the order had nothing eligible. */
  shipmentId?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type FlipkartHandoverCount = {
  __typename?: "FlipkartHandoverCount";
  count: Scalars["Int"]["output"];
  isMps: Scalars["Boolean"]["output"];
  otc?: Maybe<FlipkartHandoverOtc>;
  pickUpDate?: Maybe<FlipkartPickupWindow>;
  vendorGroupCode: Scalars["String"]["output"];
};

export type FlipkartHandoverOtc = {
  __typename?: "FlipkartHandoverOtc";
  code?: Maybe<Scalars["String"]["output"]>;
  errorCode?: Maybe<Scalars["String"]["output"]>;
};

export type FlipkartNotificationLocationResult = {
  __typename?: "FlipkartNotificationLocationResult";
  enabled: Scalars["Boolean"]["output"];
  locationId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type FlipkartOrderWebhooksInput = {
  workspaceId: Scalars["String"]["input"];
};

export type FlipkartOrderWebhooksPayload = {
  __typename?: "FlipkartOrderWebhooksPayload";
  endpoint: Scalars["String"]["output"];
  locations: Array<FlipkartNotificationLocationResult>;
  provider: Scalars["String"]["output"];
  sellerId: Scalars["String"]["output"];
};

export type FlipkartPickupWindow = {
  __typename?: "FlipkartPickupWindow";
  after?: Maybe<Scalars["String"]["output"]>;
  before?: Maybe<Scalars["String"]["output"]>;
};

export type FlipkartShipment = {
  __typename?: "FlipkartShipment";
  actions: FlipkartShipmentActions;
  cancellationGroupIds: Array<Scalars["String"]["output"]>;
  dispatchAfterDate?: Maybe<Scalars["String"]["output"]>;
  dispatchByDate?: Maybe<Scalars["String"]["output"]>;
  externalShipmentId?: Maybe<Scalars["String"]["output"]>;
  forms: Array<FlipkartShipmentForm>;
  fulfillmentMethod: Scalars["String"]["output"];
  hold: Scalars["Boolean"]["output"];
  locationId?: Maybe<Scalars["String"]["output"]>;
  logisticsPartner?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  orderId: Scalars["String"]["output"];
  orderItems: Array<FlipkartShipmentOrderItem>;
  packingDefaults: FlipkartShipmentPackingDefaults;
  shipmentId: Scalars["String"]["output"];
  shipmentType: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  subShipmentIds: Array<Scalars["String"]["output"]>;
};

export type FlipkartShipmentActions = {
  __typename?: "FlipkartShipmentActions";
  canCancel: Scalars["Boolean"]["output"];
  canConfirmSellerHubAcceptance: Scalars["Boolean"]["output"];
  canDownloadInvoice: Scalars["Boolean"]["output"];
  canDownloadLabel: Scalars["Boolean"]["output"];
  canDownloadManifest: Scalars["Boolean"]["output"];
  canMarkReadyToDispatch: Scalars["Boolean"]["output"];
  canPack: Scalars["Boolean"]["output"];
  canUpdateFormAcknowledgement: Scalars["Boolean"]["output"];
  canViewHandover: Scalars["Boolean"]["output"];
  packBlocker?: Maybe<Scalars["String"]["output"]>;
  readyToDispatchBlocker?: Maybe<Scalars["String"]["output"]>;
  sellerHubAcceptanceConfirmedAt?: Maybe<Scalars["String"]["output"]>;
};

export type FlipkartShipmentDimensionsInput = {
  breadth: Scalars["Float"]["input"];
  height: Scalars["Float"]["input"];
  length: Scalars["Float"]["input"];
  width: Scalars["Float"]["input"];
};

export enum FlipkartShipmentDocumentKind {
  Invoice = "INVOICE",
  Label = "LABEL",
}

export type FlipkartShipmentDocumentPayload = {
  __typename?: "FlipkartShipmentDocumentPayload";
  contentBase64: Scalars["String"]["output"];
  contentType: Scalars["String"]["output"];
  fileName: Scalars["String"]["output"];
};

export type FlipkartShipmentForm = {
  __typename?: "FlipkartShipmentForm";
  automated?: Maybe<Scalars["Boolean"]["output"]>;
  link?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
};

export type FlipkartShipmentInput = {
  orderId: Scalars["String"]["input"];
  /** The shipment to act on; defaults to the one that needs work now. */
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type FlipkartShipmentOrderItem = {
  __typename?: "FlipkartShipmentOrderItem";
  cancellationGroupId?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["String"]["output"];
  orderItemId: Scalars["String"]["output"];
  quantity: Scalars["Int"]["output"];
  sku?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FlipkartShipmentPackingDefaults = {
  __typename?: "FlipkartShipmentPackingDefaults";
  resolutionError?: Maybe<Scalars["String"]["output"]>;
  subShipments: Array<FlipkartShipmentPackingSubShipmentDefault>;
  taxItems: Array<FlipkartShipmentPackingTaxDefault>;
  unresolvedSkus: Array<Scalars["String"]["output"]>;
};

export type FlipkartShipmentPackingDimensions = {
  __typename?: "FlipkartShipmentPackingDimensions";
  breadth: Scalars["Float"]["output"];
  height: Scalars["Float"]["output"];
  length: Scalars["Float"]["output"];
  width: Scalars["Float"]["output"];
};

export type FlipkartShipmentPackingSubShipmentDefault = {
  __typename?: "FlipkartShipmentPackingSubShipmentDefault";
  dimensions?: Maybe<FlipkartShipmentPackingDimensions>;
  subShipment: Scalars["String"]["output"];
};

export type FlipkartShipmentPackingTaxDefault = {
  __typename?: "FlipkartShipmentPackingTaxDefault";
  hsn?: Maybe<Scalars["String"]["output"]>;
  orderItemId: Scalars["String"]["output"];
  sku?: Maybe<Scalars["String"]["output"]>;
  taxCode?: Maybe<Scalars["String"]["output"]>;
  taxRate?: Maybe<Scalars["Float"]["output"]>;
};

export type FlipkartShipmentTaxItemInput = {
  orderItemId: Scalars["String"]["input"];
  purchasePrice?: InputMaybe<Scalars["Float"]["input"]>;
  quantity: Scalars["Int"]["input"];
  serialNumbers?: InputMaybe<Array<Array<Scalars["String"]["input"]>>>;
  taxRate: Scalars["Float"]["input"];
};

export type FlipkartSubShipmentInput = {
  dimensions: FlipkartShipmentDimensionsInput;
  subShipment: Scalars["String"]["input"];
};

export type FlipkartVerticalSchemaDigestInput = {
  vertical: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type FlipkartVerticalSchemaDigestPayload = {
  __typename?: "FlipkartVerticalSchemaDigestPayload";
  canonicalSchemaPayload: Scalars["JSON"]["output"];
  raw: Scalars["JSON"]["output"];
  vertical: Scalars["String"]["output"];
};

export type FlipkartWebhookProvisioning = {
  __typename?: "FlipkartWebhookProvisioning";
  approvedAt?: Maybe<Scalars["DateTime"]["output"]>;
  batchReference?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  enabledAt?: Maybe<Scalars["DateTime"]["output"]>;
  exportedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  lastError?: Maybe<Scalars["String"]["output"]>;
  locationIds: Array<Scalars["String"]["output"]>;
  registeredEmail: Scalars["String"]["output"];
  sellerId?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type FlipkartWebhookProvisioningBatchFile = {
  __typename?: "FlipkartWebhookProvisioningBatchFile";
  batchReference: Scalars["String"]["output"];
  contentBase64: Scalars["String"]["output"];
  contentType: Scalars["String"]["output"];
  count: Scalars["Int"]["output"];
  fileName: Scalars["String"]["output"];
};

export type FormVersionLag = {
  __typename?: "FormVersionLag";
  behind: Scalars["Int"]["output"];
  marketplace: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  stamp: Scalars["String"]["output"];
  stamped: Scalars["Int"]["output"];
};

export type FxRateToday = {
  __typename?: "FxRateToday";
  rate: Scalars["Float"]["output"];
  rateDate: Scalars["String"]["output"];
};

export type GetOrderDocumentInput = {
  documentType: OrderDocumentType;
  externalOrderId: Scalars["String"]["input"];
  orderId?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type GetShippingOptionsInput = {
  externalOrderId: Scalars["String"]["input"];
  heightCm: Scalars["Float"]["input"];
  lengthCm: Scalars["Float"]["input"];
  weightGrams: Scalars["Int"]["input"];
  widthCm: Scalars["Float"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type GetShippingOptionsPayload = {
  __typename?: "GetShippingOptionsPayload";
  slots: Array<EasyShipSlot>;
};

export type GetShopcluesWalletBalanceInput = {
  workspaceId: Scalars["ID"]["input"];
};

export type GetShopcluesWalletTransactionsInput = {
  fromDate: Scalars["String"]["input"];
  noOfEntries?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["String"]["input"]>;
  toDate: Scalars["String"]["input"];
  workspaceId: Scalars["ID"]["input"];
};

export type IamForgotPasswordInput = {
  email: Scalars["String"]["input"];
};

export type IamLoginInput = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  rememberedDevice?: InputMaybe<Scalars["String"]["input"]>;
};

export type IamLoginPayload = {
  __typename?: "IamLoginPayload";
  accessToken?: Maybe<Scalars["String"]["output"]>;
  loginTicket?: Maybe<Scalars["String"]["output"]>;
  maskedEmail?: Maybe<Scalars["String"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  rememberedDevice?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<IamUser>;
};

export type IamLogoutPayload = {
  __typename?: "IamLogoutPayload";
  message: Scalars["String"]["output"];
};

export type IamOauthAccount = {
  __typename?: "IamOauthAccount";
  createdAt: Scalars["DateTime"]["output"];
  emailVerified?: Maybe<Scalars["Boolean"]["output"]>;
  provider: Scalars["String"]["output"];
  providerUserId: Scalars["String"]["output"];
};

export type IamPasswordResetPayload = {
  __typename?: "IamPasswordResetPayload";
  message: Scalars["String"]["output"];
};

export type IamRefreshTokenInput = {
  refreshToken: Scalars["String"]["input"];
};

export type IamRefreshTokenPayload = {
  __typename?: "IamRefreshTokenPayload";
  accessToken: Scalars["String"]["output"];
};

export type IamResetPasswordInput = {
  newPassword: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type IamSignupInput = {
  email: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
};

export type IamSignupPayload = {
  __typename?: "IamSignupPayload";
  message: Scalars["String"]["output"];
};

export type IamUser = {
  __typename?: "IamUser";
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastLoginAt?: Maybe<Scalars["DateTime"]["output"]>;
  loginCodeOn: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  role?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  userType: Scalars["String"]["output"];
};

export type IamUserDetail = {
  __typename?: "IamUserDetail";
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastLoginAt?: Maybe<Scalars["DateTime"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  oauthAccounts: Array<IamOauthAccount>;
  role?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  userType: Scalars["String"]["output"];
};

export type IngestMeeshoOrdersInput = {
  orders: Array<MeeshoRawOrderInput>;
  workspaceId: Scalars["String"]["input"];
};

export type IngestMeeshoOrdersPayload = {
  __typename?: "IngestMeeshoOrdersPayload";
  status: Scalars["String"]["output"];
  syncJobId: Scalars["String"]["output"];
  syncedCount: Scalars["Int"]["output"];
};

export type InventoryBySkuInput = {
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type InventoryHistoryInput = {
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type InventoryMovement = {
  __typename?: "InventoryMovement";
  createdAt: Scalars["DateTime"]["output"];
  deltaQuantity: Scalars["Int"]["output"];
  deltaReserved: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  idempotencyKey: Scalars["String"]["output"];
  orderId?: Maybe<Scalars["String"]["output"]>;
  orderItemId?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
  skuId: Scalars["String"]["output"];
  sourceId: Scalars["String"]["output"];
  sourceType: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type InventoryMovementPage = {
  __typename?: "InventoryMovementPage";
  items: Array<InventoryMovement>;
  totalCount: Scalars["Int"]["output"];
};

export type InventorySnapshot = {
  __typename?: "InventorySnapshot";
  availableQuantity: Scalars["Int"]["output"];
  quantity: Scalars["Int"]["output"];
  reserved: Scalars["Int"]["output"];
  skuCode: Scalars["String"]["output"];
  skuId: Scalars["ID"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedBy?: Maybe<Scalars["ID"]["output"]>;
};

export type InventorySyncAttempt = {
  __typename?: "InventorySyncAttempt";
  attemptedAt: Scalars["DateTime"]["output"];
  availableQuantity: Scalars["Int"]["output"];
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  connectionId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  externalReferenceId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  idempotencyKey: Scalars["String"]["output"];
  outboxEventId?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  skuCode: Scalars["String"]["output"];
  skuId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type InventorySyncAttemptPage = {
  __typename?: "InventorySyncAttemptPage";
  items: Array<InventorySyncAttempt>;
  totalCount: Scalars["Int"]["output"];
};

export type InventorySyncAttemptsInput = {
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  skuCode?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type LastSend = {
  __typename?: "LastSend";
  amount: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  fxRate: Scalars["Float"]["output"];
  fxRateDate: Scalars["String"]["output"];
};

export type Leaf = {
  __typename?: "Leaf";
  alwaysRequired: Scalars["Boolean"]["output"];
  anchor?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  folder: Scalars["String"]["output"];
  helpText?: Maybe<Scalars["String"]["output"]>;
  inputType?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  leaf: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  perStore: Scalars["Boolean"]["output"];
  status: Scalars["String"]["output"];
  usedBy: Scalars["Int"]["output"];
  usedByStores: Scalars["JSON"]["output"];
};

export type LeafImpact = {
  __typename?: "LeafImpact";
  products: Scalars["Int"]["output"];
  sellers: Scalars["Int"]["output"];
};

export type LinkListingsInput = {
  listingIds: Array<Scalars["ID"]["input"]>;
  /** Stock for the linked product. Required only when the listings hold different stock. */
  onHandQuantity?: InputMaybe<Scalars["Int"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type ListingEnrichment = {
  __typename?: "ListingEnrichment";
  description?: Maybe<Scalars["String"]["output"]>;
  features?: Maybe<Array<Scalars["String"]["output"]>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ListingsByProvider = {
  __typename?: "ListingsByProvider";
  activeCount: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type LockedMarketplace = {
  __typename?: "LockedMarketplace";
  code: Scalars["String"]["output"];
  reason: Scalars["String"]["output"];
};

export type LogisticsConnectionData = {
  __typename?: "LogisticsConnectionData";
  createdAt: Scalars["String"]["output"];
  displayName?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  externalCompanyId?: Maybe<Scalars["String"]["output"]>;
  externalCreatedAt?: Maybe<Scalars["String"]["output"]>;
  externalSellerId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastErrorCode?: Maybe<Scalars["String"]["output"]>;
  lastErrorMessage?: Maybe<Scalars["String"]["output"]>;
  lastSyncAt?: Maybe<Scalars["String"]["output"]>;
  logistics: LogisticsProvider;
  provider: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  workspaceId: Scalars["ID"]["output"];
};

export type LogisticsConnectionMapping = {
  __typename?: "LogisticsConnectionMapping";
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  marketplaceConnectionId: Scalars["ID"]["output"];
  status: Scalars["String"]["output"];
};

export type LogisticsConnectionSummary = {
  __typename?: "LogisticsConnectionSummary";
  displayName?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  externalSellerId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  mappings: Array<LogisticsConnectionMapping>;
  provider: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type LogisticsProvider = {
  __typename?: "LogisticsProvider";
  code: Scalars["String"]["output"];
  createdAt: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  websiteUrl?: Maybe<Scalars["String"]["output"]>;
};

export type LowStockItem = {
  __typename?: "LowStockItem";
  id: Scalars["String"]["output"];
  marketplaceId: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  sku: Scalars["String"]["output"];
  stock: Scalars["Int"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type MapListingToProductInput = {
  listingId: Scalars["ID"]["input"];
  targetDraftId: Scalars["ID"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type MarkAllNotificationsReadInput = {
  types?: InputMaybe<Array<Scalars["String"]["input"]>>;
  workspaceId: Scalars["String"]["input"];
};

export type MarkAllNotificationsReadPayload = {
  __typename?: "MarkAllNotificationsReadPayload";
  unreadCount: Scalars["Int"]["output"];
  updatedCount: Scalars["Int"]["output"];
};

export type Marketplace = {
  __typename?: "Marketplace";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isCBTEnabled: Scalars["Boolean"]["output"];
  lastSyncedAt?: Maybe<Scalars["DateTime"]["output"]>;
  name: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  /**
   * Marketplace-specific sync configuration. Shape varies by provider:
   * - AMAZON: { syncMode: 'api', spApiMarketplaceId: string }
   * - SHOPIFY: { syncMode: 'api' }
   * - others: { syncMode: 'api' }
   */
  syncConfig?: Maybe<Scalars["JSON"]["output"]>;
  syncStatus: Scalars["String"]["output"];
  websiteUrl?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceBulkOperationPayload = {
  __typename?: "MarketplaceBulkOperationPayload";
  failedCount: Scalars["Int"]["output"];
  results: Array<MarketplaceBulkOperationResult>;
  successCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type MarketplaceBulkOperationResult = {
  __typename?: "MarketplaceBulkOperationResult";
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  fulfillmentId?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["String"]["output"];
  orderStatus?: Maybe<Scalars["String"]["output"]>;
  provider?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type MarketplaceCategoryHit = {
  __typename?: "MarketplaceCategoryHit";
  categoryId: Scalars["String"]["output"];
  categoryName: Scalars["String"]["output"];
  fullPath: Scalars["String"]["output"];
};

export type MarketplaceCategorySearchInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  marketplace: Scalars["String"]["input"];
  query: Scalars["String"]["input"];
};

export type MarketplaceCategorySearchPayload = {
  __typename?: "MarketplaceCategorySearchPayload";
  categories: Array<MarketplaceCategoryHit>;
};

export type MarketplaceConnectionReference = {
  __typename?: "MarketplaceConnectionReference";
  displayName?: Maybe<Scalars["String"]["output"]>;
  externalSellerId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  provider: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export enum MarketplaceConnectionStatus {
  Connected = "CONNECTED",
  Degraded = "DEGRADED",
  Disconnected = "DISCONNECTED",
  Pending = "PENDING",
}

export type MarketplaceFacilitator = {
  __typename?: "MarketplaceFacilitator";
  cartServiceId?: Maybe<Scalars["String"]["output"]>;
  config: Scalars["JSON"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  facilitatorWorkspaceId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  marketplaceCode: Scalars["String"]["output"];
  shopcluesCompanyId?: Maybe<Scalars["String"]["output"]>;
  shopcluesSellerId?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type MarketplaceFacilitatorStatus = {
  __typename?: "MarketplaceFacilitatorStatus";
  connected: Scalars["Boolean"]["output"];
  linkedProducts: Scalars["Int"]["output"];
  markedId?: Maybe<Scalars["String"]["output"]>;
  marketplaceCode: Scalars["String"]["output"];
  marketplaceName: Scalars["String"]["output"];
  openOrders: Scalars["Int"]["output"];
  sellers: Scalars["Int"]["output"];
};

export type MarketplaceFulfillmentEvent = {
  __typename?: "MarketplaceFulfillmentEvent";
  happenedAt: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export enum MarketplaceFulfillmentEventStatus {
  AttemptedDelivery = "ATTEMPTED_DELIVERY",
  CarrierPickedUp = "CARRIER_PICKED_UP",
  Confirmed = "CONFIRMED",
  Delayed = "DELAYED",
  Delivered = "DELIVERED",
  Failure = "FAILURE",
  InTransit = "IN_TRANSIT",
  OutForDelivery = "OUT_FOR_DELIVERY",
}

export type MarketplaceFulfillmentGroup = {
  __typename?: "MarketplaceFulfillmentGroup";
  id: Scalars["String"]["output"];
  lineItems: Array<MarketplaceFulfillmentLineItem>;
  locationId?: Maybe<Scalars["String"]["output"]>;
  locationName?: Maybe<Scalars["String"]["output"]>;
  requestStatus?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  supportedActions: Array<Scalars["String"]["output"]>;
};

export type MarketplaceFulfillmentLineItem = {
  __typename?: "MarketplaceFulfillmentLineItem";
  heightCm?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["String"]["output"];
  lengthCm?: Maybe<Scalars["Float"]["output"]>;
  orderLineItemId?: Maybe<Scalars["String"]["output"]>;
  remainingQuantity: Scalars["Int"]["output"];
  sku?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  totalQuantity: Scalars["Int"]["output"];
  weightGrams?: Maybe<Scalars["Int"]["output"]>;
  widthCm?: Maybe<Scalars["Float"]["output"]>;
};

export type MarketplaceFulfillmentLineItemInput = {
  id: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
};

export type MarketplaceFulfillmentMutationPayload = {
  __typename?: "MarketplaceFulfillmentMutationPayload";
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  fileName?: Maybe<Scalars["String"]["output"]>;
  fulfillmentId: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["String"]["output"];
  orderStatus: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type MarketplaceFulfillmentSelectionInput = {
  fulfillmentOrderId: Scalars["String"]["input"];
  lineItems: Array<MarketplaceFulfillmentLineItemInput>;
};

export type MarketplaceFulfillmentShipment = {
  __typename?: "MarketplaceFulfillmentShipment";
  displayStatus?: Maybe<Scalars["String"]["output"]>;
  events: Array<MarketplaceFulfillmentEvent>;
  id: Scalars["String"]["output"];
  locationId?: Maybe<Scalars["String"]["output"]>;
  locationName?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  tracking: Array<MarketplaceFulfillmentTracking>;
};

export type MarketplaceFulfillmentTracking = {
  __typename?: "MarketplaceFulfillmentTracking";
  company?: Maybe<Scalars["String"]["output"]>;
  number?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceGlobalSettingsPayload = {
  __typename?: "MarketplaceGlobalSettingsPayload";
  config: Scalars["JSON"]["output"];
  marketplaceId: Scalars["String"]["output"];
  schema: Array<MarketplaceSettingsKey>;
  storedConfig: Scalars["JSON"]["output"];
};

/** One thing the marketplace rejected before we sent the listing. */
export type MarketplaceListingViolation = {
  __typename?: "MarketplaceListingViolation";
  attribute: Scalars["String"]["output"];
  blocking: Scalars["Boolean"]["output"];
  /** The form field the seller must fix. Null when we do not collect this field. */
  canonicalPath?: Maybe<Scalars["String"]["output"]>;
  keyword?: Maybe<Scalars["String"]["output"]>;
  /** What the seller sees, e.g. Pricing › MRP. Null when we do not collect this field. */
  label?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
};

export type MarketplaceLogisticsConnectionData = {
  __typename?: "MarketplaceLogisticsConnectionData";
  createdAt: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  logisticsConnection: LogisticsConnectionData;
  logisticsConnectionId: Scalars["ID"]["output"];
  marketplaceConnection: MarketplaceConnectionReference;
  marketplaceConnectionId: Scalars["ID"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  workspaceId: Scalars["ID"]["output"];
};

export type MarketplaceLogisticsConnectionPayload = {
  __typename?: "MarketplaceLogisticsConnectionPayload";
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  logisticsConnectionId: Scalars["ID"]["output"];
  marketplaceConnectionId: Scalars["ID"]["output"];
  status: Scalars["String"]["output"];
  workspaceId: Scalars["ID"]["output"];
};

export type MarketplaceMappingSession = {
  __typename?: "MarketplaceMappingSession";
  actionUnavailableReasons: Array<Scalars["String"]["output"]>;
  approvalPipelineJob?: Maybe<TaxonomyApprovalPipelineJob>;
  approvalPipelineSyncJobId?: Maybe<Scalars["ID"]["output"]>;
  approvalSync: MarketplaceMappingSessionApprovalSync;
  approvalSyncError?: Maybe<Scalars["String"]["output"]>;
  approvalSyncErrorType?: Maybe<Scalars["String"]["output"]>;
  approvalSyncFailedAt?: Maybe<Scalars["String"]["output"]>;
  approvalSyncJobId?: Maybe<Scalars["String"]["output"]>;
  approvalSyncRetryable: Scalars["Boolean"]["output"];
  approvalSyncStatus?: Maybe<Scalars["String"]["output"]>;
  approvedFields?: Maybe<Scalars["Int"]["output"]>;
  availableActions: Array<Scalars["String"]["output"]>;
  canDelete: Scalars["Boolean"]["output"];
  canRestart: Scalars["Boolean"]["output"];
  canRetry: Scalars["Boolean"]["output"];
  canonicalCategory?: Maybe<Scalars["String"]["output"]>;
  canonicalTaxonId?: Maybe<Scalars["String"]["output"]>;
  completedAt?: Maybe<Scalars["String"]["output"]>;
  confidence?: Maybe<Scalars["Float"]["output"]>;
  createdAt: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
  failedAt?: Maybe<Scalars["String"]["output"]>;
  failedFields?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  lowConfidenceFields: Scalars["Int"]["output"];
  mappedAt?: Maybe<Scalars["String"]["output"]>;
  mappedBy?: Maybe<Scalars["String"]["output"]>;
  mappedFields: Scalars["Int"]["output"];
  mappingSessionId?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  marketplaceId?: Maybe<Scalars["String"]["output"]>;
  needsReviewFields: Scalars["Int"]["output"];
  pendingFields?: Maybe<Scalars["Int"]["output"]>;
  productType: Scalars["String"]["output"];
  progress: Scalars["Float"]["output"];
  schemaVersion?: Maybe<Scalars["String"]["output"]>;
  sourceStatus?: Maybe<Scalars["String"]["output"]>;
  /** mapped | pending | needs_review | failed */
  status: Scalars["String"]["output"];
  totalBlocked?: Maybe<Scalars["Int"]["output"]>;
  totalFields: Scalars["Int"]["output"];
  updatedAt: Scalars["String"]["output"];
};

export type MarketplaceMappingSessionActionInput = {
  auditNote: Scalars["String"]["input"];
  mappingSessionId: Scalars["ID"]["input"];
};

export type MarketplaceMappingSessionActionPayload = {
  __typename?: "MarketplaceMappingSessionActionPayload";
  detail?: Maybe<MarketplaceMappingSessionDetail>;
  mappingSessionId: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
};

export type MarketplaceMappingSessionApprovalSync = {
  __typename?: "MarketplaceMappingSessionApprovalSync";
  error?: Maybe<Scalars["String"]["output"]>;
  errorDetails?: Maybe<Scalars["JSON"]["output"]>;
  errorType?: Maybe<Scalars["String"]["output"]>;
  failedAt?: Maybe<Scalars["String"]["output"]>;
  jobId?: Maybe<Scalars["String"]["output"]>;
  retryable: Scalars["Boolean"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceMappingSessionCounts = {
  __typename?: "MarketplaceMappingSessionCounts";
  failed: Scalars["Int"]["output"];
  mapped: Scalars["Int"]["output"];
  needsReview: Scalars["Int"]["output"];
  pending: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type MarketplaceMappingSessionDetail = {
  __typename?: "MarketplaceMappingSessionDetail";
  approvalSync: MarketplaceMappingSessionApprovalSync;
  errorDetails?: Maybe<Scalars["JSON"]["output"]>;
  inputIdentifiers: Scalars["JSON"]["output"];
  latestApprovalJob?: Maybe<TaxonomyApprovalPipelineJob>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  rawSession?: Maybe<Scalars["JSON"]["output"]>;
  runSummary?: Maybe<Scalars["JSON"]["output"]>;
  session: MarketplaceMappingSession;
  statusError?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceMappingSessionsInput = {
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  productType?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** mapped | pending | needs_review | failed */
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarketplaceMappingSessionsPageInfo = {
  __typename?: "MarketplaceMappingSessionsPageInfo";
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  page: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
};

export type MarketplaceMappingSessionsPayload = {
  __typename?: "MarketplaceMappingSessionsPayload";
  counts: MarketplaceMappingSessionCounts;
  items: Array<MarketplaceMappingSession>;
  marketplaces: Array<Scalars["String"]["output"]>;
  pageInfo: MarketplaceMappingSessionsPageInfo;
};

export enum MarketplaceOrderAction {
  CancelFulfillment = "CANCEL_FULFILLMENT",
  MarkDelivered = "MARK_DELIVERED",
}

export type MarketplaceOrderDeliveryInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  deliveredAt?: InputMaybe<Scalars["String"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  province?: InputMaybe<Scalars["String"]["input"]>;
  zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarketplaceOrderEvent = {
  __typename?: "MarketplaceOrderEvent";
  eventId: Scalars["String"]["output"];
  eventType: Scalars["String"]["output"];
  marketplaceId: Scalars["String"]["output"];
  occurredAt: Scalars["String"]["output"];
  orderId?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type MarketplaceOrderFulfillmentJourney = {
  __typename?: "MarketplaceOrderFulfillmentJourney";
  details?: Maybe<Scalars["JSON"]["output"]>;
  financialStatus?: Maybe<Scalars["String"]["output"]>;
  fulfillmentMode?: Maybe<Scalars["String"]["output"]>;
  fulfillmentStatus?: Maybe<Scalars["String"]["output"]>;
  groups: Array<MarketplaceFulfillmentGroup>;
  orderId: Scalars["String"]["output"];
  orderStatus: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  rawStatus?: Maybe<Scalars["String"]["output"]>;
  shipments: Array<MarketplaceFulfillmentShipment>;
  supportedActions: Array<Scalars["String"]["output"]>;
};

export type MarketplaceOrderShipment = {
  __typename?: "MarketplaceOrderShipment";
  awbNumber?: Maybe<Scalars["String"]["output"]>;
  carrierCode?: Maybe<Scalars["String"]["output"]>;
  carrierName?: Maybe<Scalars["String"]["output"]>;
  confirmedAt?: Maybe<Scalars["String"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  fulfillmentMethod: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  orderId: Scalars["String"]["output"];
  packageReferenceId?: Maybe<Scalars["String"]["output"]>;
  pickupRequestedAt?: Maybe<Scalars["String"]["output"]>;
  pickupScheduledDate?: Maybe<Scalars["String"]["output"]>;
  pickupTokenNumber?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  shipDate?: Maybe<Scalars["String"]["output"]>;
  shippingMethod?: Maybe<Scalars["String"]["output"]>;
  shiprocketEstimatedDeliveryDate?: Maybe<Scalars["String"]["output"]>;
  shiprocketTrackingStatus?: Maybe<Scalars["String"]["output"]>;
  shiprocketTrackingUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  trackingNumber?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceOrderStatusCancellationInput = {
  note?: InputMaybe<Scalars["String"]["input"]>;
  notifyCustomer?: InputMaybe<Scalars["Boolean"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  refundOriginalPaymentMethods?: InputMaybe<Scalars["Boolean"]["input"]>;
  restock?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MarketplaceOrderStatusShipmentInput = {
  awbNumber?: InputMaybe<Scalars["String"]["input"]>;
  carrierCode?: InputMaybe<Scalars["String"]["input"]>;
  carrierName?: InputMaybe<Scalars["String"]["input"]>;
  packageReferenceId?: InputMaybe<Scalars["String"]["input"]>;
  shipDate?: InputMaybe<Scalars["String"]["input"]>;
  shippingMethod?: InputMaybe<Scalars["String"]["input"]>;
  trackingNumber?: InputMaybe<Scalars["String"]["input"]>;
  trackingUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export enum MarketplaceOrderStatusUpdateTarget {
  Cancelled = "CANCELLED",
  Confirmed = "CONFIRMED",
  Shipped = "SHIPPED",
}

export type MarketplacePriceLine = {
  __typename?: "MarketplacePriceLine";
  anchor: Scalars["String"]["output"];
  lastSend?: Maybe<LastSend>;
};

export type MarketplacePricing = {
  __typename?: "MarketplacePricing";
  currency: Scalars["String"]["output"];
  marketplace: Scalars["String"]["output"];
  prices: Array<MarketplacePriceLine>;
  today?: Maybe<FxRateToday>;
};

export enum MarketplaceProvider {
  Amazon = "AMAZON",
  Coupang = "COUPANG",
  Ebay = "EBAY",
  ElevenStreet = "ELEVEN_STREET",
  Flipkart = "FLIPKART",
  Meesho = "MEESHO",
  Noon = "NOON",
  Shopclues = "SHOPCLUES",
  Shopify = "SHOPIFY",
  Snapdeal = "SNAPDEAL",
  Wish = "WISH",
}

export type MarketplaceSettingsCode = {
  __typename?: "MarketplaceSettingsCode";
  code: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type MarketplaceSettingsKey = {
  __typename?: "MarketplaceSettingsKey";
  codes: Array<MarketplaceSettingsCode>;
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  type: Scalars["String"]["output"];
};

export enum MarketplaceSpecificReason {
  CollisionLoser = "COLLISION_LOSER",
  NoCanonicalFit = "NO_CANONICAL_FIT",
  OpsDecision = "OPS_DECISION",
}

export type MasterSku = {
  __typename?: "MasterSku";
  createdAt: Scalars["DateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  skuCode: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  version: Scalars["Int"]["output"];
};

export type MasterSkusPayload = {
  __typename?: "MasterSkusPayload";
  skus: Array<MasterSku>;
  totalCount: Scalars["Int"]["output"];
};

export type MeeshoActiveSessionInput = {
  /**
   * When true, force a silent re-auth (v2-login) before returning the cookie.
   * Used after the extension hits a 401/403 from Meesho even though our
   * cached cookie hasn't crossed its expiresAt yet.
   */
  forceRefresh?: InputMaybe<Scalars["Boolean"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type MeeshoActiveSessionPayload = {
  __typename?: "MeeshoActiveSessionPayload";
  browserId: Scalars["String"]["output"];
  identifier: Scalars["String"]["output"];
  sessionCookie: Scalars["String"]["output"];
  storedAt: Scalars["String"]["output"];
  supplierId: Scalars["String"]["output"];
};

export type MeeshoCategorySchema = {
  __typename?: "MeeshoCategorySchema";
  categoryImage?: Maybe<Scalars["String"]["output"]>;
  categoryPath?: Maybe<Scalars["String"]["output"]>;
  maxProducts: Scalars["Int"]["output"];
  minProducts: Scalars["Int"]["output"];
  otherData: Array<MeeshoCategorySchemaField>;
  productData: Array<MeeshoCategorySchemaField>;
  productDetailsData: Array<MeeshoCategorySchemaField>;
  productSizeData: Array<MeeshoCategorySchemaField>;
  requiredImagesCount: Scalars["Int"]["output"];
  sscatId: Scalars["String"]["output"];
  variations: Array<MeeshoCategorySchemaVariation>;
};

export type MeeshoCategorySchemaField = {
  __typename?: "MeeshoCategorySchemaField";
  allowCopy: Scalars["Boolean"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  identifier: Scalars["String"]["output"];
  isPriceRelevantAttribute?: Maybe<Scalars["Boolean"]["output"]>;
  isTaxonomyAttribute?: Maybe<Scalars["Boolean"]["output"]>;
  mandatory: Scalars["Boolean"]["output"];
  max?: Maybe<Scalars["Float"]["output"]>;
  mergeIntoFieldIdentifier?: Maybe<Scalars["String"]["output"]>;
  mergeOrder?: Maybe<Scalars["Int"]["output"]>;
  min?: Maybe<Scalars["Float"]["output"]>;
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  validationRegex?: Maybe<Scalars["String"]["output"]>;
  valueUnit?: Maybe<Scalars["String"]["output"]>;
  values?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type MeeshoCategorySchemaVariation = {
  __typename?: "MeeshoCategorySchemaVariation";
  id: Scalars["Int"]["output"];
  variationName: Scalars["String"]["output"];
};

export type MeeshoProductTypeSchemaDigestInput = {
  /** Meesho sub_sub_category_id. */
  productType: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type MeeshoProductTypeSchemaDigestPayload = {
  __typename?: "MeeshoProductTypeSchemaDigestPayload";
  aiResponse: Scalars["JSON"]["output"];
  canonicalSchemaPayload: Scalars["JSON"]["output"];
  categoryPath?: Maybe<Scalars["String"]["output"]>;
  productType: Scalars["String"]["output"];
  sscatId: Scalars["String"]["output"];
};

export type MeeshoProductTypeSearchItem = {
  __typename?: "MeeshoProductTypeSearchItem";
  /** Human-readable Meesho category path (e.g. "Men Fashion > Bottomwear > Jeans"). */
  displayName?: Maybe<Scalars["String"]["output"]>;
  /** Meesho sub_sub_category_id (e.g. "10140"). Used as productType when starting sync. */
  name: Scalars["String"]["output"];
  synced: Scalars["Boolean"]["output"];
};

export type MeeshoRawOrderInput = {
  raw: Scalars["JSON"]["input"];
};

export type MeeshoSchemaFetchJob = {
  __typename?: "MeeshoSchemaFetchJob";
  categoryPath?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  sscatId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type MeeshoSearchProductTypesInput = {
  keyword: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type MeeshoSearchProductTypesPayload = {
  __typename?: "MeeshoSearchProductTypesPayload";
  productTypes: Array<MeeshoProductTypeSearchItem>;
};

export type MissingListingField = {
  __typename?: "MissingListingField";
  canonicalPath: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  addShopcluesWalletBalance: ShopcluesWalletBalancePayload;
  adminActivateUser: AdminUserPayload;
  adminDeactivateUser: AdminUserPayload;
  adminDeleteUser: AdminUserPayload;
  adminLogin: IamLoginPayload;
  advanceOnboardingStep: AdvanceOnboardingStepPayload;
  amazonConfirmShipment: AmazonConfirmShipmentPayload;
  amazonRefreshEasyShipDocuments: AmazonEasyShipDocumentsPayload;
  amazonRequestEasyShipDocuments: AmazonEasyShipDocumentsPayload;
  amazonScheduleEasyShipPackage: AmazonScheduledEasyShipPackagePayload;
  approveFlipkartWebhookProvisioning: AdminFlipkartWebhookProvisioning;
  attributeReviewApproveSelected: AttributeReviewApproveSelectedPayload;
  attributeReviewApproveSession?: Maybe<AttributeReviewApprovePayload>;
  /** Both models map one row's store values again, against its field or the field given. Returns how many values changed. */
  attributeReviewMapRowValues: Scalars["Int"]["output"];
  /** Open rows take this store's past answer for the same field, with no AI call. Returns how many rows changed. */
  attributeReviewUsePastAnswers: Scalars["Int"]["output"];
  bulkCreateSnapdealHandover: SnapdealBulkOperationPayload;
  bulkExecuteMarketplaceFulfillmentAction: MarketplaceBulkOperationPayload;
  bulkMarkFlipkartShipmentsReadyToDispatch: FlipkartBulkOperationPayload;
  bulkPackFlipkartShipments: FlipkartBulkOperationPayload;
  bulkPrintSnapdealDocuments: SnapdealBulkOperationPayload;
  bulkPrintSnapdealHandover: SnapdealBulkOperationPayload;
  bulkShipShopifyOrdersWithShiprocket: BulkShiprocketOperationPayload;
  cacheMeeshoCategorySchema: CacheMeeshoCategorySchemaPayload;
  cancelFlipkartShipment: FlipkartShipment;
  cancelSync: Scalars["Boolean"]["output"];
  cancelTaxonomyApprovalPipelineJob: TaxonomyApprovalPipelineJobActionPayload;
  changePassword: IamLoginPayload;
  claimMeeshoProductSaveJob: ClaimMeeshoProductSaveJobPayload;
  completeMeeshoProductSave: CompleteMeeshoProductSavePayload;
  completeMeeshoSchemaFetchJob: CompleteMeeshoSchemaFetchJobPayload;
  confirmFlipkartSellerHubAcceptance: FlipkartShipment;
  confirmProductMediaUpload: ProductMediaAsset;
  connectCoupangSeller: ConnectCoupangSellerPayload;
  connectMarketplaceLogistics: MarketplaceLogisticsConnectionPayload;
  connectMeeshoSeller: ConnectMeeshoSellerPayload;
  connectShopcluesSeller: ConnectShopcluesSellerPayload;
  connectShopifySeller: ConnectShopifySellerPayload;
  connectSnapdealSeller: ConnectSnapdealSellerPayload;
  createDraftFromSellerProduct: ProductDraft;
  createMarketplaceFacilitator: MarketplaceFacilitator;
  createMarketplaceFulfillment: MarketplaceFulfillmentMutationPayload;
  createMarketplaceFulfillmentEvent: MarketplaceFulfillmentMutationPayload;
  createProductMediaUpload: ProductMediaUploadTarget;
  createShopcluesOrderManifest: ShopcluesManifestRequestPayload;
  createShopcluesWalletTopup: ShopcluesWalletTopupPayload;
  createWorkspace: CreateWorkspacePayload;
  createWorkspaceSubscription: CreateWorkspaceSubscriptionPayload;
  debitShopcluesWalletBalance: ShopcluesWalletBalancePayload;
  /**
   * Delete an under-review mapping session and all of its session-scoped data
   * (session doc + jobs, value-review rows, tracking rows, and caches). Approved
   * knowledge and the canonical registry are kept. OPS/ADMIN only.
   */
  deleteMappingSession: DeleteMappingSessionResult;
  deleteMarketplaceMappingSession: MarketplaceMappingSessionActionPayload;
  deletePackagePreset: Scalars["Boolean"]["output"];
  deleteProductDraft: Scalars["Boolean"]["output"];
  deleteSellerProductMarketplaceListing: DeleteSellerProductMarketplaceListingPayload;
  disconnectAmazonSeller: DisconnectAmazonSellerPayload;
  disconnectLogisticsConnection: DisconnectLogisticsConnectionPayload;
  disconnectMarketplaceLogistics: DisconnectMarketplaceLogisticsPayload;
  disconnectMarketplaceSeller: DisconnectMarketplaceSellerPayload;
  dismissStockMismatches: Scalars["Boolean"]["output"];
  downloadBulkFlipkartShipmentDocument: FlipkartShipmentDocumentPayload;
  downloadBulkShiprocketLabels: BulkShiprocketLabelPayload;
  downloadFlipkartManifest: FlipkartShipmentDocumentPayload;
  downloadFlipkartShipmentDocument: FlipkartShipmentDocumentPayload;
  downloadShiprocketLabel: ShiprocketLabelPayload;
  executeMarketplaceFulfillmentAction: MarketplaceFulfillmentMutationPayload;
  exportFlipkartWebhookProvisioningBatch: FlipkartWebhookProvisioningBatchFile;
  /**
   * Extract product-creation form values from a seller's free-text description
   * (AI-based product listing). Pure proxy to the taxonomy engine — nothing is
   * persisted; the client merges the returned values into the draft form.
   */
  extractProductListing: ExtractProductListingPayload;
  getOrderDocument: OrderDocumentPayload;
  getShippingOptions: GetShippingOptionsPayload;
  getShopcluesRequestedFilePath: ShopcluesRequestedFilePathPayload;
  getShopcluesWalletBalance: ShopcluesWalletBalancePayload;
  getShopcluesWalletTransactions: ShopcluesWalletTransactionsPayload;
  /**
   * Promote a Meesho draft (saved by the Chrome extension) to live on Meesho.
   * Creates a new extension job that calls submitSingleCatalog.
   */
  goLiveMeesho: PublishProductSession;
  iamForgotPassword: IamPasswordResetPayload;
  iamLogin: IamLoginPayload;
  iamLogout: IamLogoutPayload;
  iamRefreshToken: IamRefreshTokenPayload;
  iamResetPassword: IamPasswordResetPayload;
  iamSignup: IamSignupPayload;
  ingestMeeshoOrders: IngestMeeshoOrdersPayload;
  /** Link a set of listings into one product, opening a new one if none of them has one. */
  linkListings: ProductDraft;
  mapListingToProduct: ProductDraft;
  markAllNotificationsRead: MarkAllNotificationsReadPayload;
  markFlipkartShipmentReadyToDispatch: FlipkartShipment;
  /** Idempotent: reading a read notification returns it unchanged. */
  markNotificationRead: Notification;
  markTaxonomyApprovalPipelineJobFailed: TaxonomyApprovalPipelineJobActionPayload;
  packFlipkartShipment: FlipkartShipment;
  /**
   * Start async publish of a product draft to one or more marketplaces.
   * Meesho listings are saved as a draft on Meesho (via the Chrome extension);
   * use goLiveMeesho to promote that draft to live.
   */
  publishProduct: PublishProductSession;
  purchaseShippingLabel: ShippingLabelPayload;
  refreshFlipkartShipment: FlipkartShipment;
  refreshFlipkartVerticals: RefreshFlipkartVerticalsPayload;
  refreshProductMarketplaceStatus: ProductMarketplaceSaveJob;
  /**
   * Re-submit an unmapped product type to the taxonomy backend using the latest
   * Qdrant approved vectors. Generates a sessionId server-side and advances the
   * TaxonomyResolutionTask from OPEN → MAPPING_IN_PROGRESS.
   */
  refreshProductTypeMapping: ProductTypeSyncSession;
  refreshShiprocketTracking: ShiprocketTrackingPayload;
  registerShopcluesMerchant: ShopcluesMerchantPayload;
  removeProductMediaAsset: Scalars["Boolean"]["output"];
  requestBulkShiprocketPickup: BulkShiprocketPickupPayload;
  requestShiprocketPickup: ShiprocketPickupPayload;
  requestShopcluesOrderInvoice: ShopcluesFulfillmentRequestPayload;
  requestShopcluesOrderShippingLabel: ShopcluesFulfillmentRequestPayload;
  resendLoginCode: ResendLoginCodePayload;
  restartMarketplaceMappingSession: MarketplaceMappingSessionActionPayload;
  resumeProcessing: Scalars["JSON"]["output"];
  resumeTaxonomyApprovalPipelineQueue: ResumeTaxonomyApprovalPipelineQueuePayload;
  resyncShopifyInventory: ResyncShopifyInventoryPayload;
  retryMarketplaceMappingSession: MarketplaceMappingSessionActionPayload;
  retryTaxonomyApprovalPipelineJob: TaxonomyApprovalPipelineJobActionPayload;
  savePackagePreset: PackagePreset;
  /** Upsert a product draft. Pass id to update an existing draft, omit to create. */
  saveProductDraft: ProductDraft;
  /**
   * Upsert per-marketplace field value presets for a seller. One row per
   * (workspaceId, canonicalCategoryId, marketplace) — overwrites on repeat saves.
   */
  saveProductFieldMapping: ProductFieldMapping;
  saveProductToMarketplace: ProductMarketplaceSaveSession;
  sellerLogin: IamLoginPayload;
  sellerSignup: IamSignupPayload;
  setLeafFlags: Leaf;
  setLoginCode: SetLoginCodePayload;
  setMarketplaceStatus: AdminMarketplace;
  setPoolSellerTyping: Scalars["Boolean"]["output"];
  setSellerStatus: AdminSellerStatus;
  setSharedStock: Scalars["Boolean"]["output"];
  shipOrderWithShiprocket: MarketplaceFulfillmentMutationPayload;
  startOrderSync: OrderSyncRun;
  /**
   * Validate a mapping session and mark it as ready for subscription.
   * Returns the sessionId the client should subscribe to via taxonomyMappingSession.
   */
  startProductTypeSync: ProductTypeSyncSession;
  startShopifyCustomOAuth: StartShopifyCustomOAuthPayload;
  startShopifyInstall: StartShopifyInstallPayload;
  storeLogisticsConnection: StoreLogisticsConnectionPayload;
  storeMeeshoCredentials: StoreMeeshoCredentialsPayload;
  subscribeEbayOrderWebhooks: SubscribeEbayOrderWebhooksPayload;
  subscribeFlipkartOrderWebhooks: FlipkartOrderWebhooksPayload;
  subscribeShopifyOrderWebhooks: SubscribeShopifyOrderWebhooksPayload;
  syncListings: SyncListingsPayload;
  syncOrders: SyncOrdersPayload;
  taxonomySaveProductTypeMapping: Scalars["JSON"]["output"];
  unmapListingFromProduct: Scalars["Boolean"]["output"];
  unsubscribeEbayOrderWebhooks: UnsubscribeEbayOrderWebhooksPayload;
  unsubscribeFlipkartOrderWebhooks: FlipkartOrderWebhooksPayload;
  unsubscribeShopifyOrderWebhooks: UnsubscribeShopifyOrderWebhooksPayload;
  updateFlipkartFormAcknowledgements: FlipkartShipment;
  updateMarketplaceFacilitator: MarketplaceFacilitator;
  updateMarketplaceFulfillmentTracking: MarketplaceFulfillmentMutationPayload;
  updateMarketplaceGlobalSettings?: Maybe<MarketplaceGlobalSettingsPayload>;
  updateMarketplaceOrderStatus: UpdateMarketplaceOrderStatusPayload;
  upsertInventoryBySku: SellerProductInventorySnapshot;
  verifyLoginCode: IamLoginPayload;
};

export type MutationAddShopcluesWalletBalanceArgs = {
  input: ShopcluesWalletBalanceMutationInput;
};

export type MutationAdminActivateUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationAdminDeactivateUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationAdminDeleteUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationAdminLoginArgs = {
  input: IamLoginInput;
};

export type MutationAdvanceOnboardingStepArgs = {
  input: AdvanceOnboardingStepInput;
};

export type MutationAmazonConfirmShipmentArgs = {
  input: AmazonConfirmShipmentInput;
};

export type MutationAmazonRefreshEasyShipDocumentsArgs = {
  input: AmazonRefreshEasyShipDocumentsInput;
};

export type MutationAmazonRequestEasyShipDocumentsArgs = {
  input: AmazonRequestEasyShipDocumentsInput;
};

export type MutationAmazonScheduleEasyShipPackageArgs = {
  input: AmazonScheduleEasyShipPackageInput;
};

export type MutationApproveFlipkartWebhookProvisioningArgs = {
  input: ApproveFlipkartWebhookProvisioningInput;
};

export type MutationAttributeReviewApproveSelectedArgs = {
  input: AttributeReviewApproveSelectedInput;
};

export type MutationAttributeReviewApproveSessionArgs = {
  input: AttributeReviewApproveInput;
};

export type MutationAttributeReviewMapRowValuesArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>;
  sessionId: Scalars["ID"]["input"];
  sourceFieldId: Scalars["String"]["input"];
};

export type MutationAttributeReviewUsePastAnswersArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type MutationBulkCreateSnapdealHandoverArgs = {
  input: BulkSnapdealOrdersInput;
};

export type MutationBulkExecuteMarketplaceFulfillmentActionArgs = {
  input: BulkExecuteMarketplaceFulfillmentActionInput;
};

export type MutationBulkMarkFlipkartShipmentsReadyToDispatchArgs = {
  input: BulkFlipkartShipmentsInput;
};

export type MutationBulkPackFlipkartShipmentsArgs = {
  input: BulkPackFlipkartShipmentsInput;
};

export type MutationBulkPrintSnapdealDocumentsArgs = {
  input: BulkPrintSnapdealDocumentsInput;
};

export type MutationBulkPrintSnapdealHandoverArgs = {
  input: BulkPrintSnapdealHandoverInput;
};

export type MutationBulkShipShopifyOrdersWithShiprocketArgs = {
  input: BulkShipShopifyOrdersWithShiprocketInput;
};

export type MutationCacheMeeshoCategorySchemaArgs = {
  input: CacheMeeshoCategorySchemaInput;
};

export type MutationCancelFlipkartShipmentArgs = {
  input: CancelFlipkartShipmentInput;
};

export type MutationCancelSyncArgs = {
  input: CancelSyncInput;
};

export type MutationCancelTaxonomyApprovalPipelineJobArgs = {
  input: TaxonomyApprovalPipelineJobActionInput;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationClaimMeeshoProductSaveJobArgs = {
  input: ClaimMeeshoProductSaveJobInput;
};

export type MutationCompleteMeeshoProductSaveArgs = {
  input: CompleteMeeshoProductSaveInput;
};

export type MutationCompleteMeeshoSchemaFetchJobArgs = {
  input: CompleteMeeshoSchemaFetchJobInput;
};

export type MutationConfirmFlipkartSellerHubAcceptanceArgs = {
  input: FlipkartShipmentInput;
};

export type MutationConfirmProductMediaUploadArgs = {
  input: ConfirmProductMediaUploadInput;
};

export type MutationConnectCoupangSellerArgs = {
  input: ConnectCoupangSellerInput;
};

export type MutationConnectMarketplaceLogisticsArgs = {
  input: ConnectMarketplaceLogisticsInput;
};

export type MutationConnectMeeshoSellerArgs = {
  input: ConnectMeeshoSellerInput;
};

export type MutationConnectShopcluesSellerArgs = {
  input: ConnectShopcluesSellerInput;
};

export type MutationConnectShopifySellerArgs = {
  input: ConnectShopifySellerInput;
};

export type MutationConnectSnapdealSellerArgs = {
  input: ConnectSnapdealSellerInput;
};

export type MutationCreateDraftFromSellerProductArgs = {
  input: CreateDraftFromSellerProductInput;
};

export type MutationCreateMarketplaceFacilitatorArgs = {
  input: CreateMarketplaceFacilitatorInput;
};

export type MutationCreateMarketplaceFulfillmentArgs = {
  input: CreateMarketplaceFulfillmentInput;
};

export type MutationCreateMarketplaceFulfillmentEventArgs = {
  input: CreateMarketplaceFulfillmentEventInput;
};

export type MutationCreateProductMediaUploadArgs = {
  input: CreateProductMediaUploadInput;
};

export type MutationCreateShopcluesOrderManifestArgs = {
  input: ShopcluesFulfillmentOrderRequestInput;
};

export type MutationCreateShopcluesWalletTopupArgs = {
  input: CreateShopcluesWalletTopupInput;
};

export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};

export type MutationCreateWorkspaceSubscriptionArgs = {
  input: CreateWorkspaceSubscriptionInput;
};

export type MutationDebitShopcluesWalletBalanceArgs = {
  input: ShopcluesWalletBalanceMutationInput;
};

export type MutationDeleteMappingSessionArgs = {
  input: DeleteMappingSessionInput;
};

export type MutationDeleteMarketplaceMappingSessionArgs = {
  input: MarketplaceMappingSessionActionInput;
};

export type MutationDeletePackagePresetArgs = {
  id: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type MutationDeleteProductDraftArgs = {
  draftId: Scalars["ID"]["input"];
};

export type MutationDeleteSellerProductMarketplaceListingArgs = {
  input: DeleteSellerProductMarketplaceListingInput;
};

export type MutationDisconnectAmazonSellerArgs = {
  input: DisconnectAmazonSellerInput;
};

export type MutationDisconnectLogisticsConnectionArgs = {
  input: DisconnectLogisticsConnectionInput;
};

export type MutationDisconnectMarketplaceLogisticsArgs = {
  input: DisconnectMarketplaceLogisticsInput;
};

export type MutationDisconnectMarketplaceSellerArgs = {
  input: DisconnectMarketplaceSellerInput;
};

export type MutationDismissStockMismatchesArgs = {
  input: DismissStockMismatchesInput;
};

export type MutationDownloadBulkFlipkartShipmentDocumentArgs = {
  input: DownloadBulkFlipkartShipmentDocumentInput;
};

export type MutationDownloadBulkShiprocketLabelsArgs = {
  input: DownloadBulkShiprocketLabelsInput;
};

export type MutationDownloadFlipkartManifestArgs = {
  input: DownloadFlipkartManifestInput;
};

export type MutationDownloadFlipkartShipmentDocumentArgs = {
  input: DownloadFlipkartShipmentDocumentInput;
};

export type MutationDownloadShiprocketLabelArgs = {
  input: DownloadShiprocketLabelInput;
};

export type MutationExecuteMarketplaceFulfillmentActionArgs = {
  input: ExecuteMarketplaceFulfillmentActionInput;
};

export type MutationExtractProductListingArgs = {
  input: ExtractProductListingInput;
};

export type MutationGetOrderDocumentArgs = {
  input: GetOrderDocumentInput;
};

export type MutationGetShippingOptionsArgs = {
  input: GetShippingOptionsInput;
};

export type MutationGetShopcluesRequestedFilePathArgs = {
  input: ShopcluesRequestedFilePathInput;
};

export type MutationGetShopcluesWalletBalanceArgs = {
  input: GetShopcluesWalletBalanceInput;
};

export type MutationGetShopcluesWalletTransactionsArgs = {
  input: GetShopcluesWalletTransactionsInput;
};

export type MutationGoLiveMeeshoArgs = {
  draftId: Scalars["ID"]["input"];
};

export type MutationIamForgotPasswordArgs = {
  input: IamForgotPasswordInput;
};

export type MutationIamLoginArgs = {
  input: IamLoginInput;
};

export type MutationIamRefreshTokenArgs = {
  input: IamRefreshTokenInput;
};

export type MutationIamResetPasswordArgs = {
  input: IamResetPasswordInput;
};

export type MutationIamSignupArgs = {
  input: IamSignupInput;
};

export type MutationIngestMeeshoOrdersArgs = {
  input: IngestMeeshoOrdersInput;
};

export type MutationLinkListingsArgs = {
  input: LinkListingsInput;
};

export type MutationMapListingToProductArgs = {
  input: MapListingToProductInput;
};

export type MutationMarkAllNotificationsReadArgs = {
  input: MarkAllNotificationsReadInput;
};

export type MutationMarkFlipkartShipmentReadyToDispatchArgs = {
  input: FlipkartShipmentInput;
};

export type MutationMarkNotificationReadArgs = {
  id: Scalars["ID"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type MutationMarkTaxonomyApprovalPipelineJobFailedArgs = {
  input: TaxonomyApprovalPipelineJobActionInput;
};

export type MutationPackFlipkartShipmentArgs = {
  input: PackFlipkartShipmentInput;
};

export type MutationPublishProductArgs = {
  draftId: Scalars["ID"]["input"];
  marketplaces?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationPurchaseShippingLabelArgs = {
  input: PurchaseShippingLabelInput;
};

export type MutationRefreshFlipkartShipmentArgs = {
  input: FlipkartShipmentInput;
};

export type MutationRefreshFlipkartVerticalsArgs = {
  input: RefreshFlipkartVerticalsInput;
};

export type MutationRefreshProductMarketplaceStatusArgs = {
  draftId: Scalars["ID"]["input"];
  marketplace: Scalars["String"]["input"];
};

export type MutationRefreshProductTypeMappingArgs = {
  marketplace: Scalars["String"]["input"];
  productType: Scalars["String"]["input"];
};

export type MutationRefreshShiprocketTrackingArgs = {
  input: RefreshShiprocketTrackingInput;
};

export type MutationRegisterShopcluesMerchantArgs = {
  input: RegisterShopcluesMerchantInput;
};

export type MutationRemoveProductMediaAssetArgs = {
  assetId: Scalars["ID"]["input"];
};

export type MutationRequestBulkShiprocketPickupArgs = {
  input: RequestBulkShiprocketPickupInput;
};

export type MutationRequestShiprocketPickupArgs = {
  input: RequestShiprocketPickupInput;
};

export type MutationRequestShopcluesOrderInvoiceArgs = {
  input: ShopcluesFulfillmentOrderRequestInput;
};

export type MutationRequestShopcluesOrderShippingLabelArgs = {
  input: ShopcluesFulfillmentOrderRequestInput;
};

export type MutationResendLoginCodeArgs = {
  loginTicket: Scalars["String"]["input"];
};

export type MutationRestartMarketplaceMappingSessionArgs = {
  input: MarketplaceMappingSessionActionInput;
};

export type MutationResumeProcessingArgs = {
  marketplace: Scalars["String"]["input"];
  productType: Scalars["String"]["input"];
  reason: Scalars["String"]["input"];
};

export type MutationResumeTaxonomyApprovalPipelineQueueArgs = {
  input: ResumeTaxonomyApprovalPipelineQueueInput;
};

export type MutationResyncShopifyInventoryArgs = {
  input: ResyncShopifyInventoryInput;
};

export type MutationRetryMarketplaceMappingSessionArgs = {
  input: MarketplaceMappingSessionActionInput;
};

export type MutationRetryTaxonomyApprovalPipelineJobArgs = {
  input: TaxonomyApprovalPipelineJobActionInput;
};

export type MutationSavePackagePresetArgs = {
  input: SavePackagePresetInput;
};

export type MutationSaveProductDraftArgs = {
  input: SaveProductDraftInput;
};

export type MutationSaveProductFieldMappingArgs = {
  input: SaveProductFieldMappingInput;
};

export type MutationSaveProductToMarketplaceArgs = {
  draftId: Scalars["ID"]["input"];
  marketplaces?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationSellerLoginArgs = {
  input: IamLoginInput;
};

export type MutationSellerSignupArgs = {
  input: IamSignupInput;
};

export type MutationSetLeafFlagsArgs = {
  alwaysRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  inputType?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  path: Scalars["String"]["input"];
  perStore?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationSetLoginCodeArgs = {
  input: SetLoginCodeInput;
};

export type MutationSetMarketplaceStatusArgs = {
  input: SetMarketplaceStatusInput;
};

export type MutationSetPoolSellerTypingArgs = {
  allowed: Scalars["Boolean"]["input"];
  pool: Scalars["String"]["input"];
};

export type MutationSetSellerStatusArgs = {
  input: SetSellerStatusInput;
};

export type MutationSetSharedStockArgs = {
  input: SetSharedStockInput;
};

export type MutationShipOrderWithShiprocketArgs = {
  input: ShipOrderWithShiprocketInput;
};

export type MutationStartOrderSyncArgs = {
  input: SyncOrdersInput;
};

export type MutationStartProductTypeSyncArgs = {
  marketplace: Scalars["String"]["input"];
  productType: Scalars["String"]["input"];
  sessionId: Scalars["ID"]["input"];
};

export type MutationStartShopifyCustomOAuthArgs = {
  input: StartShopifyCustomOAuthInput;
};

export type MutationStartShopifyInstallArgs = {
  input: StartShopifyInstallInput;
};

export type MutationStoreLogisticsConnectionArgs = {
  input: StoreLogisticsConnectionInput;
};

export type MutationStoreMeeshoCredentialsArgs = {
  input: StoreMeeshoCredentialsInput;
};

export type MutationSubscribeEbayOrderWebhooksArgs = {
  input: SubscribeEbayOrderWebhooksInput;
};

export type MutationSubscribeFlipkartOrderWebhooksArgs = {
  input: FlipkartOrderWebhooksInput;
};

export type MutationSubscribeShopifyOrderWebhooksArgs = {
  input: SubscribeShopifyOrderWebhooksInput;
};

export type MutationSyncListingsArgs = {
  input: SyncListingsInput;
};

export type MutationSyncOrdersArgs = {
  input: SyncOrdersInput;
};

export type MutationTaxonomySaveProductTypeMappingArgs = {
  input: TaxonomySaveProductTypeMappingInput;
};

export type MutationUnmapListingFromProductArgs = {
  input: UnmapListingFromProductInput;
};

export type MutationUnsubscribeEbayOrderWebhooksArgs = {
  input: UnsubscribeEbayOrderWebhooksInput;
};

export type MutationUnsubscribeFlipkartOrderWebhooksArgs = {
  input: FlipkartOrderWebhooksInput;
};

export type MutationUnsubscribeShopifyOrderWebhooksArgs = {
  input: UnsubscribeShopifyOrderWebhooksInput;
};

export type MutationUpdateFlipkartFormAcknowledgementsArgs = {
  input: UpdateFlipkartFormAcknowledgementsInput;
};

export type MutationUpdateMarketplaceFacilitatorArgs = {
  input: UpdateMarketplaceFacilitatorInput;
};

export type MutationUpdateMarketplaceFulfillmentTrackingArgs = {
  input: UpdateMarketplaceFulfillmentTrackingInput;
};

export type MutationUpdateMarketplaceGlobalSettingsArgs = {
  config: Scalars["JSON"]["input"];
  marketplaceId: Scalars["String"]["input"];
};

export type MutationUpdateMarketplaceOrderStatusArgs = {
  input: UpdateMarketplaceOrderStatusInput;
};

export type MutationUpsertInventoryBySkuArgs = {
  input: UpsertInventoryBySkuInput;
};

export type MutationVerifyLoginCodeArgs = {
  input: VerifyLoginCodeInput;
};

/**
 * One notification for the signed-in user. Render from type, event and payload; title and message
 * are the server's English fallback.
 */
export type Notification = {
  __typename?: "Notification";
  createdAt: Scalars["DateTime"]["output"];
  entityId?: Maybe<Scalars["String"]["output"]>;
  entityType?: Maybe<Scalars["String"]["output"]>;
  event: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  payload: Scalars["JSON"]["output"];
  payloadVersion: Scalars["Int"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type NotificationPage = {
  __typename?: "NotificationPage";
  items: Array<Notification>;
  /** Pass as after for the next page; null on the last page. */
  nextCursor?: Maybe<Scalars["String"]["output"]>;
};

export type NotificationsInput = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  entityId?: InputMaybe<Scalars["String"]["input"]>;
  entityType?: InputMaybe<Scalars["String"]["input"]>;
  /** Page size, 1-50 (default 20). */
  first?: InputMaybe<Scalars["Int"]["input"]>;
  /** Notification categories, e.g. ORDER, INVENTORY. Omit for all. */
  types?: InputMaybe<Array<Scalars["String"]["input"]>>;
  unreadOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type Order = {
  __typename?: "Order";
  buyerEmail?: Maybe<Scalars["String"]["output"]>;
  buyerName?: Maybe<Scalars["String"]["output"]>;
  cancelReason?: Maybe<Scalars["String"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  /** The marketplace's own id for this order's line when its order is split per line (Flipkart item id). */
  externalLineId?: Maybe<Scalars["String"]["output"]>;
  externalOrderId: Scalars["String"]["output"];
  firstItem?: Maybe<OrderLineItem>;
  fulfillmentType?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  itemCount?: Maybe<Scalars["Int"]["output"]>;
  lastUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  orderedAt: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  rawStatus?: Maybe<Scalars["String"]["output"]>;
  rawSyncedAt: Scalars["String"]["output"];
  shipment?: Maybe<OrderShipmentSummary>;
  /** Marketplace shipments for this order; 1 unless the marketplace split it (Flipkart). */
  shipmentCount: Scalars["Int"]["output"];
  shippingAddress?: Maybe<Scalars["JSON"]["output"]>;
  status: Scalars["String"]["output"];
  statusGroup: OrderStatusGroup;
  totalAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Units per status; empty unless the order's units are in different states (Flipkart). */
  unitStatuses: Array<OrderUnitStatus>;
};

export type OrderDocumentPayload = {
  __typename?: "OrderDocumentPayload";
  fileName: Scalars["String"]["output"];
  htmlContent: Scalars["String"]["output"];
};

export enum OrderDocumentType {
  PackingSlip = "PACKING_SLIP",
  TaxInvoice = "TAX_INVOICE",
}

export type OrderLineItem = {
  __typename?: "OrderLineItem";
  externalProductId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  quantity?: Maybe<Scalars["Int"]["output"]>;
  skuCode?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OrderProviderCount = {
  __typename?: "OrderProviderCount";
  count: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
};

export type OrderShipmentSummary = {
  __typename?: "OrderShipmentSummary";
  awbNumber?: Maybe<Scalars["String"]["output"]>;
  carrierCode?: Maybe<Scalars["String"]["output"]>;
  carrierName?: Maybe<Scalars["String"]["output"]>;
  confirmedAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  shipDate?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  trackingNumber?: Maybe<Scalars["String"]["output"]>;
};

export type OrderStatusCount = {
  __typename?: "OrderStatusCount";
  count: Scalars["Int"]["output"];
  status: OrderStatusGroup;
};

export enum OrderStatusGroup {
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Disconnected = "DISCONNECTED",
  Dispatch = "DISPATCH",
  InTransit = "IN_TRANSIT",
  NeedsReview = "NEEDS_REVIEW",
  Pending = "PENDING",
  Returned = "RETURNED",
  ReturnInTransit = "RETURN_IN_TRANSIT",
  Upcoming = "UPCOMING",
}

export type OrderSummaryInput = {
  orderedFrom?: InputMaybe<Scalars["String"]["input"]>;
  orderedTo?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type OrderSummaryPayload = {
  __typename?: "OrderSummaryPayload";
  providerCounts: Array<OrderProviderCount>;
  statusCounts: Array<OrderStatusCount>;
  totalCount: Scalars["Int"]["output"];
};

export type OrderSyncRun = {
  __typename?: "OrderSyncRun";
  createdAt: Scalars["String"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  results: Array<SyncResult>;
  startedAt?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type OrderUnitStatus = {
  __typename?: "OrderUnitStatus";
  /** The units' own status as the order list shows it, e.g. DISPATCH or RETURN_INITIATED. */
  status: Scalars["String"]["output"];
  statusGroup: OrderStatusGroup;
  units: Scalars["Int"]["output"];
};

export type OrdersByProvider = {
  __typename?: "OrdersByProvider";
  count: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
};

export type OrdersByStatus = {
  __typename?: "OrdersByStatus";
  count: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
};

export type OrdersInput = {
  orderedFrom?: InputMaybe<Scalars["String"]["input"]>;
  orderedTo?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  pageToken?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  statusGroup?: InputMaybe<OrderStatusGroup>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
  workspaceId: Scalars["String"]["input"];
};

export type OrdersPayload = {
  __typename?: "OrdersPayload";
  items: Array<Order>;
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
  page: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
};

export type PackFlipkartShipmentInput = {
  invoiceDate: Scalars["String"]["input"];
  invoiceNumber?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["String"]["input"];
  /** The shipment to act on; defaults to the one that needs work now. */
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
  subShipments?: InputMaybe<Array<FlipkartSubShipmentInput>>;
  taxItems?: InputMaybe<Array<FlipkartShipmentTaxItemInput>>;
};

export type PackagePreset = {
  __typename?: "PackagePreset";
  heightCm: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  lengthCm: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  weightGrams: Scalars["Int"]["output"];
  widthCm: Scalars["Float"]["output"];
};

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
};

export type PendingMeeshoProductSaveJob = {
  __typename?: "PendingMeeshoProductSaveJob";
  attemptCount: Scalars["Int"]["output"];
  createdAt: Scalars["String"]["output"];
  draftId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  marketplace: Scalars["String"]["output"];
  marketplacePayload?: Maybe<Scalars["JSON"]["output"]>;
  sessionId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type PendingMeeshoSchemaFetchJobsPayload = {
  __typename?: "PendingMeeshoSchemaFetchJobsPayload";
  jobs: Array<MeeshoSchemaFetchJob>;
};

export type ProductCreationCanonicalEnumValue = {
  __typename?: "ProductCreationCanonicalEnumValue";
  canonicalValueId: Scalars["String"]["output"];
  deprecated: Scalars["Boolean"]["output"];
  exportability: Scalars["JSON"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  valueKey?: Maybe<Scalars["String"]["output"]>;
};

export type ProductCreationEnumOption = {
  __typename?: "ProductCreationEnumOption";
  label?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
};

export type ProductCreationSchema = {
  __typename?: "ProductCreationSchema";
  canonicalCategoryId: Scalars["String"]["output"];
  commonFields: Array<ProductCreationSchemaField>;
  commonSections: Array<ProductCreationSection>;
  /**
   * Marketplaces added to the request as CBT parents (e.g. ShopClues for
   * Coupang). The picker shows them ticked and locked with the reason.
   */
  lockedMarketplaces: Array<LockedMarketplace>;
  /**
   * Per-marketplace fields keyed by lowercased marketplace code. A
   * marketplace key is present only when the taxonomy service returns
   * a non-empty fragment for it — i.e. there is an APPROVED, ACTIVE
   * mapping_definition for (marketplace, product_type) in Mongo. A
   * marketplace that the caller requested but for which the taxonomy
   * service has no approved definition will NOT appear as a key here
   * (instead it is listed in unreadyMarketplaces). UIs that iterate
   * over Object.keys(marketplaceFields) naturally hide such tabs.
   */
  marketplaceFields: Scalars["JSON"]["output"];
  /**
   * Per-marketplace sections — keyed identically to marketplaceFields.
   * Unready marketplaces are omitted (see unreadyMarketplaces).
   */
  marketplaceSections: Scalars["JSON"]["output"];
  sharedMedia?: Maybe<SharedProductMediaConfig>;
  /**
   * Marketplaces the caller requested that have no APPROVED, ACTIVE
   * mapping_definition for this canonical category. These marketplaces
   * are deliberately absent from marketplaceFields and
   * marketplaceSections so consumers don't render empty tabs. The
   * array is always present (possibly empty), lowercased, and
   * deduplicated. UIs can render a "not yet configured for this
   * category" hint per entry.
   */
  unreadyMarketplaces: Array<Scalars["String"]["output"]>;
};

export type ProductCreationSchemaField = {
  __typename?: "ProductCreationSchemaField";
  advanced?: Maybe<Scalars["Boolean"]["output"]>;
  anchor?: Maybe<Scalars["String"]["output"]>;
  autofillValue?: Maybe<Scalars["JSON"]["output"]>;
  canonicalEnumValues?: Maybe<Array<ProductCreationCanonicalEnumValue>>;
  canonicalPath: Scalars["String"]["output"];
  constraints?: Maybe<ProductFieldConstraints>;
  defaultValue?: Maybe<Scalars["JSON"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  disposition?: Maybe<Scalars["String"]["output"]>;
  dispositionReason?: Maybe<Scalars["String"]["output"]>;
  domainVersion?: Maybe<Scalars["String"]["output"]>;
  enumOptions?: Maybe<Array<ProductCreationEnumOption>>;
  enumValues?: Maybe<Array<Scalars["String"]["output"]>>;
  example?: Maybe<Scalars["String"]["output"]>;
  fieldShape?: Maybe<Scalars["String"]["output"]>;
  forbiddenCondition?: Maybe<Scalars["JSON"]["output"]>;
  inputMode?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  marketplaceLeafPath?: Maybe<Scalars["String"]["output"]>;
  marketplacePayloadKind?: Maybe<Scalars["String"]["output"]>;
  marketplaceRequirements?: Maybe<Scalars["JSON"]["output"]>;
  marketplaceRootPath?: Maybe<Scalars["String"]["output"]>;
  marketplaceSpecific?: Maybe<Scalars["Boolean"]["output"]>;
  marketplaceSpecificAuditNote?: Maybe<Scalars["String"]["output"]>;
  marketplaceSpecificKey?: Maybe<Scalars["String"]["output"]>;
  marketplaceSpecificReason?: Maybe<Scalars["String"]["output"]>;
  marketplaceValidations?: Maybe<Scalars["JSON"]["output"]>;
  maxItems?: Maybe<Scalars["Int"]["output"]>;
  optionalIn: Array<Scalars["String"]["output"]>;
  pathHint?: Maybe<Scalars["String"]["output"]>;
  perStore?: Maybe<Scalars["Boolean"]["output"]>;
  required: Scalars["Boolean"]["output"];
  requiredCondition?: Maybe<Scalars["JSON"]["output"]>;
  requiredIn: Array<Scalars["String"]["output"]>;
  restrictionMode?: Maybe<Scalars["String"]["output"]>;
  sectionKey?: Maybe<Scalars["String"]["output"]>;
  sectionLabel?: Maybe<Scalars["String"]["output"]>;
  sectionOrder?: Maybe<Scalars["Int"]["output"]>;
  sourceFieldId?: Maybe<Scalars["String"]["output"]>;
  sourceSchemaType?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
  uiType?: Maybe<Scalars["String"]["output"]>;
  units?: Maybe<Array<Scalars["String"]["output"]>>;
  valueDomain?: Maybe<Scalars["String"]["output"]>;
  valueSource?: Maybe<Scalars["String"]["output"]>;
};

export type ProductCreationSection = {
  __typename?: "ProductCreationSection";
  fields: Array<ProductCreationSchemaField>;
  optionalCount: Scalars["Int"]["output"];
  requiredCount: Scalars["Int"]["output"];
  sectionKey: Scalars["String"]["output"];
  sectionLabel: Scalars["String"]["output"];
  sectionOrder: Scalars["Int"]["output"];
};

export type ProductDraft = {
  __typename?: "ProductDraft";
  canonicalCategoryId: Scalars["String"]["output"];
  canonicalData: Scalars["JSON"]["output"];
  createdAt: Scalars["String"]["output"];
  formNotices?: Maybe<Scalars["JSON"]["output"]>;
  formVersions?: Maybe<Scalars["JSON"]["output"]>;
  id: Scalars["ID"]["output"];
  ownerName?: Maybe<Scalars["String"]["output"]>;
  selectedMarketplaces: Array<Scalars["String"]["output"]>;
  skuCode: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  viewerRole: DraftViewerRole;
  workspaceId: Scalars["String"]["output"];
};

export type ProductFieldConstraints = {
  __typename?: "ProductFieldConstraints";
  format?: Maybe<Scalars["String"]["output"]>;
  maxItems?: Maybe<Scalars["Int"]["output"]>;
  maxLength?: Maybe<Scalars["Int"]["output"]>;
  minItems?: Maybe<Scalars["Int"]["output"]>;
  minLength?: Maybe<Scalars["Int"]["output"]>;
  pattern?: Maybe<Scalars["String"]["output"]>;
  requiredItemProperties?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type ProductFieldMapping = {
  __typename?: "ProductFieldMapping";
  canonicalCategoryId: Scalars["String"]["output"];
  createdAt: Scalars["String"]["output"];
  fieldValues: Scalars["JSON"]["output"];
  id: Scalars["ID"]["output"];
  marketplace: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type ProductListing = {
  __typename?: "ProductListing";
  brand?: Maybe<Scalars["String"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  fulfillmentType?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  marketplaceId: Scalars["String"]["output"];
  price?: Maybe<Scalars["Float"]["output"]>;
  provider: Scalars["String"]["output"];
  rawStatus?: Maybe<Scalars["String"]["output"]>;
  rawSyncedAt: Scalars["String"]["output"];
  sku: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  stock?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ProductListingsInput = {
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  pageToken?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type ProductListingsPayload = {
  __typename?: "ProductListingsPayload";
  items: Array<ProductListing>;
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
  totalCount: Scalars["Int"]["output"];
};

export type ProductMarketplaceSaveJob = {
  __typename?: "ProductMarketplaceSaveJob";
  attemptCount: Scalars["Int"]["output"];
  completedAt?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  draftId: Scalars["ID"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  issues?: Maybe<Scalars["JSON"]["output"]>;
  lastAttemptAt?: Maybe<Scalars["String"]["output"]>;
  listingIssues?: Maybe<Scalars["JSON"]["output"]>;
  listingStatus?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  missingFields: Array<Scalars["String"]["output"]>;
  preflightViolations?: Maybe<Array<MarketplaceListingViolation>>;
  sessionId: Scalars["ID"]["output"];
  startedAt?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  submissionId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["String"]["output"];
  validationMode?: Maybe<Scalars["String"]["output"]>;
  verificationStatus?: Maybe<Scalars["String"]["output"]>;
};

export type ProductMarketplaceSaveSession = {
  __typename?: "ProductMarketplaceSaveSession";
  draftId: Scalars["ID"]["output"];
  marketplaces: Array<Scalars["String"]["output"]>;
  sessionId: Scalars["ID"]["output"];
  statuses: Array<ProductMarketplaceSaveUpdate>;
};

export type ProductMarketplaceSaveUpdate = {
  __typename?: "ProductMarketplaceSaveUpdate";
  error?: Maybe<Scalars["String"]["output"]>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  issues?: Maybe<Scalars["JSON"]["output"]>;
  listingIssues?: Maybe<Scalars["JSON"]["output"]>;
  listingStatus?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  missingFields?: Maybe<Array<Scalars["String"]["output"]>>;
  preflightViolations?: Maybe<Array<MarketplaceListingViolation>>;
  sessionId: Scalars["ID"]["output"];
  status: Scalars["String"]["output"];
  submissionId?: Maybe<Scalars["String"]["output"]>;
  validationMode?: Maybe<Scalars["String"]["output"]>;
  verificationStatus?: Maybe<Scalars["String"]["output"]>;
};

export type ProductMediaAsset = {
  __typename?: "ProductMediaAsset";
  filename: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  mimeType: Scalars["String"]["output"];
  sizeBytes: Scalars["Int"]["output"];
  url: Scalars["String"]["output"];
};

export type ProductMediaUploadTarget = {
  __typename?: "ProductMediaUploadTarget";
  assetId: Scalars["ID"]["output"];
  headers?: Maybe<Scalars["JSON"]["output"]>;
  storageKey: Scalars["String"]["output"];
  uploadUrl: Scalars["String"]["output"];
};

export type ProductPublishUpdate = {
  __typename?: "ProductPublishUpdate";
  error?: Maybe<Scalars["String"]["output"]>;
  listingId?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  /** Canonical paths the seller needs to fill to fix validation errors. */
  missingFields?: Maybe<Array<Scalars["String"]["output"]>>;
  preflightViolations?: Maybe<Array<MarketplaceListingViolation>>;
  sessionId: Scalars["ID"]["output"];
  /** PENDING | CONVERTING | PUSHING | SUCCESS | FAILED */
  status: Scalars["String"]["output"];
  validationMode?: Maybe<Scalars["String"]["output"]>;
};

export type ProductSyncStatus = {
  __typename?: "ProductSyncStatus";
  completedAt?: Maybe<Scalars["String"]["output"]>;
  errorType?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  queuedAt: Scalars["String"]["output"];
  startedAt?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  syncJobId: Scalars["String"]["output"];
  syncedCount: Scalars["Int"]["output"];
};

/**
 * Returned by startProductTypeSync — contains the session ID the client
 * should subscribe to via taxonomyMappingSession(sessionId).
 */
export type ProductTypeSyncSession = {
  __typename?: "ProductTypeSyncSession";
  marketplace: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  sessionId: Scalars["ID"]["output"];
};

export type PublishProductSession = {
  __typename?: "PublishProductSession";
  draftId: Scalars["ID"]["output"];
  marketplaces: Array<Scalars["String"]["output"]>;
  sessionId: Scalars["ID"]["output"];
};

export type PublishRejection = {
  __typename?: "PublishRejection";
  error: Scalars["String"]["output"];
  failedAt: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  marketplace: Scalars["String"]["output"];
  productType?: Maybe<Scalars["String"]["output"]>;
};

export type PurchaseShippingLabelInput = {
  externalOrderId: Scalars["String"]["input"];
  slotId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type Query = {
  __typename?: "Query";
  _placeholder?: Maybe<Scalars["Boolean"]["output"]>;
  adminDashboard: AdminDashboardStats;
  adminFlipkartWebhookProvisionings: Array<AdminFlipkartWebhookProvisioning>;
  adminOrders: AdminOrdersPayload;
  adminSeller?: Maybe<SellerListItem>;
  adminSellers: AdminSellersPayload;
  adminUser?: Maybe<IamUserDetail>;
  adminUsers: AdminUsersConnection;
  amazonAdminAuthSession: AmazonAuthSessionPayload;
  amazonAuthSession: AmazonAuthSessionPayload;
  amazonEasyShipHandoverSlots: AmazonEasyShipHandoverSlotsPayload;
  amazonGetProductTypeSchema: AmazonProductTypeSchemaPayload;
  amazonProductTypeSchemaDigest: AmazonProductTypeSchemaDigestPayload;
  amazonSearchProductTypes: AmazonSearchProductTypesPayload;
  amazonSystemCredential: AmazonSystemCredentialStatus;
  attributeReviewFieldMappings?: Maybe<AttributeReviewFieldMappingsPayload>;
  attributeReviewSession?: Maybe<AttributeReviewSession>;
  attributeReviewSessionsUnderReview: Array<AttributeReviewSessionSummary>;
  /** Active value domains matching the query, for reusing an existing domain. */
  attributeReviewValueDomainSearch: AttributeReviewValueDomainSearchPayload;
  coupangCategoryRecommend: CoupangCategoryRecommendPayload;
  coupangCategorySchemaDigest: CoupangCategorySchemaDigestPayload;
  coupangShippingOptions: CoupangShippingOptionsPayload;
  dashboard: DashboardStats;
  ebayAuthSession: EbayAuthSessionPayload;
  ebayCategorySchemaDigest: EbayCategorySchemaDigestPayload;
  ebayCategorySearch: EbayCategorySearchPayload;
  facilitatedSellers: Array<FacilitatedSeller>;
  flipkartAuthSession: FlipkartAuthSessionPayload;
  flipkartHandoverCounts: Array<FlipkartHandoverCount>;
  /** One shipment of the order: the named one, or the one that needs work now. */
  flipkartShipment: FlipkartShipment;
  /** Every Flipkart shipment of the order; the ones that need work now come first. */
  flipkartShipments: Array<FlipkartShipment>;
  flipkartVerticalSchemaDigest: FlipkartVerticalSchemaDigestPayload;
  flipkartWebhookProvisioning?: Maybe<FlipkartWebhookProvisioning>;
  formVersionLag: Array<FormVersionLag>;
  inventoryBySku?: Maybe<SellerProductInventorySnapshot>;
  inventoryHistory: InventoryMovementPage;
  inventorySnapshot?: Maybe<InventorySnapshot>;
  inventorySyncAttempts: InventorySyncAttemptPage;
  leafImpact: LeafImpact;
  leafUsers: Array<FieldUserRow>;
  leaves: Array<Leaf>;
  logistics: Array<LogisticsProvider>;
  logisticsConnections: Array<LogisticsConnectionSummary>;
  marketplaceCategorySearch: MarketplaceCategorySearchPayload;
  marketplaceFacilitatorStatus: Array<MarketplaceFacilitatorStatus>;
  marketplaceGlobalSettings?: Maybe<MarketplaceGlobalSettingsPayload>;
  marketplaceLogisticsConnections: Array<MarketplaceLogisticsConnectionData>;
  marketplaceMappingSession?: Maybe<MarketplaceMappingSessionDetail>;
  marketplaceMappingSessions: MarketplaceMappingSessionsPayload;
  marketplaceOrderFulfillment: MarketplaceOrderFulfillmentJourney;
  marketplaceOrderShipment?: Maybe<MarketplaceOrderShipment>;
  marketplacePricing: Array<MarketplacePricing>;
  marketplaces: Array<Marketplace>;
  masterSkus: MasterSkusPayload;
  meeshoActiveSession: MeeshoActiveSessionPayload;
  meeshoCategorySchema?: Maybe<MeeshoCategorySchema>;
  meeshoProductTypeSchemaDigest: MeeshoProductTypeSchemaDigestPayload;
  meeshoSearchProductTypes: MeeshoSearchProductTypesPayload;
  notificationUnreadCount: Scalars["Int"]["output"];
  notifications: NotificationPage;
  orderSummary: OrderSummaryPayload;
  orderSyncStatus?: Maybe<OrderSyncRun>;
  orders: OrdersPayload;
  packagePresets: Array<PackagePreset>;
  pendingMeeshoProductSaveJobs: Array<PendingMeeshoProductSaveJob>;
  pendingMeeshoSchemaFetchJobs: PendingMeeshoSchemaFetchJobsPayload;
  /** Return the unified product creation schema for a canonical category + marketplaces. */
  productCreationSchema: ProductCreationSchema;
  productDraft?: Maybe<ProductDraft>;
  productListings: ProductListingsPayload;
  productMarketplaceSaveJobs: Array<ProductMarketplaceSaveJob>;
  productSyncStatus: Array<ProductSyncStatus>;
  publishRejections: Array<PublishRejection>;
  sellerProductDetail?: Maybe<SellerProductDetail>;
  sellerProductOrders: SellerProductOrdersPayload;
  sellerProducts: SellerProductsPayload;
  shopifyAuthSession: ShopifyAuthSessionPayload;
  shopifyOrders: ShopifyOrdersPayload;
  shopifyProductTypeSchemaDigest: ShopifyProductTypeSchemaDigestPayload;
  shopifySearchProductTypes: ShopifySearchProductTypesPayload;
  snapdealAuthSession: SnapdealAuthSessionPayload;
  snapdealCategorySchemaDigest: SnapdealCategorySchemaDigestPayload;
  snapdealCategorySearch: SnapdealCategorySearchPayload;
  stockMismatches: Array<StockMismatch>;
  subscriptionPlans: Array<SubscriptionPlan>;
  /** List marketplaces with an approved mapping for the given canonical category. */
  supportedMarketplacesForCategory: Array<SupportedMarketplace>;
  taxonomyApprovalPipelineJob?: Maybe<TaxonomyApprovalPipelineJobDetail>;
  taxonomyApprovalPipelineJobs: TaxonomyApprovalPipelineJobsPayload;
  taxonomyCategoriesSearch: Array<TaxonomyCategorySearchItem>;
  taxonomyCategoriesSuggest: Array<TaxonomyCategorySuggestItem>;
  taxonomyIngestionRun?: Maybe<TaxonomyIngestionRun>;
  taxonomyIngestionRuns: Array<TaxonomyIngestionRun>;
  /** Return the top N canonical categories that have at least one approved marketplace mapping. Used for initial dropdown suggestions. */
  taxonomyMappedCategories: Array<TaxonomyCategorySearchItem>;
  taxonomyResolutionTasks: Array<TaxonomyResolutionTask>;
  taxonomySchema: Scalars["JSON"]["output"];
  /** List supported mapped categories for a marketplace. */
  taxonomySupportedCategories: Array<TaxonomySupportedCategory>;
  /** List marketplaces that currently have active approved taxonomy mappings. */
  taxonomySupportedMarketplaces: Array<TaxonomySupportedMarketplace>;
  /**
   * Pre-publish validation of a draft against each marketplace's authoritative schema.
   * Side-effect-free (no job, no marketplace submission). Returns a JSON array of
   * { marketplace, productType, valid, mode, violations: [{ source, blocking, canonicalPath,
   * attribute, instancePath, keyword, message }] }.
   */
  validateProductForMarketplace: Scalars["JSON"]["output"];
  viewerBootstrap: ViewerBootstrapPayload;
  wishAuthSession: WishAuthSessionPayload;
};

export type QueryAdminDashboardArgs = {
  input?: InputMaybe<AdminDashboardInput>;
};

export type QueryAdminFlipkartWebhookProvisioningsArgs = {
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAdminOrdersArgs = {
  input?: InputMaybe<AdminOrdersInput>;
};

export type QueryAdminSellerArgs = {
  id: Scalars["String"]["input"];
};

export type QueryAdminSellersArgs = {
  input?: InputMaybe<AdminSellersInput>;
};

export type QueryAdminUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<AdminUsersFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAmazonAuthSessionArgs = {
  input: AmazonAuthSessionInput;
};

export type QueryAmazonEasyShipHandoverSlotsArgs = {
  input: AmazonEasyShipHandoverSlotsInput;
};

export type QueryAmazonGetProductTypeSchemaArgs = {
  input: AmazonGetProductTypeSchemaInput;
};

export type QueryAmazonProductTypeSchemaDigestArgs = {
  input: AmazonProductTypeSchemaDigestInput;
};

export type QueryAmazonSearchProductTypesArgs = {
  input: AmazonSearchProductTypesInput;
};

export type QueryAttributeReviewFieldMappingsArgs = {
  includeEnumDetails?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeFinished?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionId: Scalars["ID"]["input"];
  sourceFieldId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAttributeReviewSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type QueryAttributeReviewSessionsUnderReviewArgs = {
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  productType?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAttributeReviewValueDomainSearchArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCoupangCategoryRecommendArgs = {
  input: CoupangCategoryRecommendInput;
};

export type QueryCoupangCategorySchemaDigestArgs = {
  input: CoupangCategorySchemaDigestInput;
};

export type QueryCoupangShippingOptionsArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryDashboardArgs = {
  input: DashboardInput;
};

export type QueryEbayAuthSessionArgs = {
  input: EbayAuthSessionInput;
};

export type QueryEbayCategorySchemaDigestArgs = {
  input: EbayCategorySchemaDigestInput;
};

export type QueryEbayCategorySearchArgs = {
  input: EbayCategorySearchInput;
};

export type QueryFacilitatedSellersArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryFlipkartAuthSessionArgs = {
  input: FlipkartAuthSessionInput;
};

export type QueryFlipkartHandoverCountsArgs = {
  orderId: Scalars["String"]["input"];
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFlipkartShipmentArgs = {
  orderId: Scalars["String"]["input"];
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFlipkartShipmentsArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryFlipkartVerticalSchemaDigestArgs = {
  input: FlipkartVerticalSchemaDigestInput;
};

export type QueryFlipkartWebhookProvisioningArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryInventoryBySkuArgs = {
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type QueryInventoryHistoryArgs = {
  input: InventoryHistoryInput;
};

export type QueryInventorySnapshotArgs = {
  input: InventoryBySkuInput;
};

export type QueryInventorySyncAttemptsArgs = {
  input: InventorySyncAttemptsInput;
};

export type QueryLeafImpactArgs = {
  path: Scalars["String"]["input"];
};

export type QueryLeafUsersArgs = {
  path: Scalars["String"]["input"];
};

export type QueryLeavesArgs = {
  folder?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLogisticsConnectionsArgs = {
  workspaceId: Scalars["ID"]["input"];
};

export type QueryMarketplaceCategorySearchArgs = {
  input: MarketplaceCategorySearchInput;
};

export type QueryMarketplaceFacilitatorStatusArgs = {
  workspaceId: Scalars["ID"]["input"];
};

export type QueryMarketplaceGlobalSettingsArgs = {
  marketplaceId: Scalars["String"]["input"];
};

export type QueryMarketplaceLogisticsConnectionsArgs = {
  workspaceId: Scalars["ID"]["input"];
};

export type QueryMarketplaceMappingSessionArgs = {
  mappingSessionId: Scalars["ID"]["input"];
};

export type QueryMarketplaceMappingSessionsArgs = {
  input?: InputMaybe<MarketplaceMappingSessionsInput>;
};

export type QueryMarketplaceOrderFulfillmentArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryMarketplaceOrderShipmentArgs = {
  fulfillmentMethod?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["String"]["input"];
};

export type QueryMarketplacePricingArgs = {
  draftId: Scalars["ID"]["input"];
};

export type QueryMasterSkusArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryMeeshoActiveSessionArgs = {
  input: MeeshoActiveSessionInput;
};

export type QueryMeeshoCategorySchemaArgs = {
  sscatId: Scalars["String"]["input"];
};

export type QueryMeeshoProductTypeSchemaDigestArgs = {
  input: MeeshoProductTypeSchemaDigestInput;
};

export type QueryMeeshoSearchProductTypesArgs = {
  input: MeeshoSearchProductTypesInput;
};

export type QueryNotificationUnreadCountArgs = {
  types?: InputMaybe<Array<Scalars["String"]["input"]>>;
  workspaceId: Scalars["String"]["input"];
};

export type QueryNotificationsArgs = {
  input: NotificationsInput;
};

export type QueryOrderSummaryArgs = {
  input: OrderSummaryInput;
};

export type QueryOrderSyncStatusArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryOrdersArgs = {
  input: OrdersInput;
};

export type QueryPackagePresetsArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryPendingMeeshoProductSaveJobsArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryPendingMeeshoSchemaFetchJobsArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryProductCreationSchemaArgs = {
  canonicalCategoryId: Scalars["String"]["input"];
  marketplaces: Array<Scalars["String"]["input"]>;
};

export type QueryProductDraftArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryProductListingsArgs = {
  input: ProductListingsInput;
};

export type QueryProductMarketplaceSaveJobsArgs = {
  draftId: Scalars["ID"]["input"];
};

export type QueryProductSyncStatusArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryPublishRejectionsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySellerProductDetailArgs = {
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type QuerySellerProductOrdersArgs = {
  input: SellerProductOrdersInput;
};

export type QuerySellerProductsArgs = {
  input: SellerProductsInput;
};

export type QueryShopifyAuthSessionArgs = {
  input: ShopifyAuthSessionInput;
};

export type QueryShopifyOrdersArgs = {
  input: ShopifyOrdersInput;
};

export type QueryShopifyProductTypeSchemaDigestArgs = {
  input: ShopifyProductTypeSchemaDigestInput;
};

export type QueryShopifySearchProductTypesArgs = {
  input: ShopifySearchProductTypesInput;
};

export type QuerySnapdealAuthSessionArgs = {
  input: SnapdealAuthSessionInput;
};

export type QuerySnapdealCategorySchemaDigestArgs = {
  input: SnapdealCategorySchemaDigestInput;
};

export type QuerySnapdealCategorySearchArgs = {
  input: SnapdealCategorySearchInput;
};

export type QueryStockMismatchesArgs = {
  includeDismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type QuerySupportedMarketplacesForCategoryArgs = {
  canonicalCategoryId: Scalars["String"]["input"];
};

export type QueryTaxonomyApprovalPipelineJobArgs = {
  syncJobId: Scalars["ID"]["input"];
};

export type QueryTaxonomyApprovalPipelineJobsArgs = {
  input?: InputMaybe<TaxonomyApprovalPipelineJobsInput>;
};

export type QueryTaxonomyCategoriesSearchArgs = {
  mappedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  q: Scalars["String"]["input"];
};

export type QueryTaxonomyCategoriesSuggestArgs = {
  hints?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  mappedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  productType?: InputMaybe<Scalars["String"]["input"]>;
  q: Scalars["String"]["input"];
};

export type QueryTaxonomyIngestionRunArgs = {
  runId: Scalars["ID"]["input"];
};

export type QueryTaxonomyIngestionRunsArgs = {
  includeCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type QueryTaxonomyMappedCategoriesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryTaxonomyResolutionTasksArgs = {
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTaxonomySchemaArgs = {
  category: Scalars["String"]["input"];
  marketplace: Scalars["String"]["input"];
};

export type QueryTaxonomySupportedCategoriesArgs = {
  marketplace: Scalars["String"]["input"];
};

export type QueryValidateProductForMarketplaceArgs = {
  draftId: Scalars["ID"]["input"];
  marketplaces: Array<Scalars["String"]["input"]>;
};

export type QueryWishAuthSessionArgs = {
  input: WishAuthSessionInput;
};

export type RefreshFlipkartVerticalsInput = {
  workspaceId: Scalars["String"]["input"];
};

export type RefreshFlipkartVerticalsPayload = {
  __typename?: "RefreshFlipkartVerticalsPayload";
  count: Scalars["Int"]["output"];
  version: Scalars["Int"]["output"];
};

export type RefreshShiprocketTrackingInput = {
  orderId: Scalars["String"]["input"];
};

export type RegisterShopcluesMerchantInput = {
  workspaceId: Scalars["ID"]["input"];
};

export type RequestBulkShiprocketPickupInput = {
  orderIds: Array<Scalars["String"]["input"]>;
  pickupDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type RequestShiprocketPickupInput = {
  orderId: Scalars["String"]["input"];
  pickupDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResendLoginCodePayload = {
  __typename?: "ResendLoginCodePayload";
  retryAfterSec: Scalars["Int"]["output"];
};

export type ResumeTaxonomyApprovalPipelineQueueInput = {
  auditNote: Scalars["String"]["input"];
  mappingSessionId: Scalars["ID"]["input"];
};

export type ResumeTaxonomyApprovalPipelineQueuePayload = {
  __typename?: "ResumeTaxonomyApprovalPipelineQueuePayload";
  job?: Maybe<TaxonomyApprovalPipelineJob>;
  message: Scalars["String"]["output"];
  resourceLockKey: Scalars["String"]["output"];
  resumedSyncJobId?: Maybe<Scalars["ID"]["output"]>;
};

export type ResyncShopifyInventoryInput = {
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ResyncShopifyInventoryPayload = {
  __typename?: "ResyncShopifyInventoryPayload";
  availableQuantity: Scalars["Int"]["output"];
  queued: Scalars["Boolean"]["output"];
  skuCode: Scalars["String"]["output"];
  skuId: Scalars["String"]["output"];
};

export type SavePackagePresetInput = {
  heightCm: Scalars["Float"]["input"];
  lengthCm: Scalars["Float"]["input"];
  name: Scalars["String"]["input"];
  weightGrams: Scalars["Int"]["input"];
  widthCm: Scalars["Float"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type SaveProductDraftInput = {
  canonicalCategoryId: Scalars["String"]["input"];
  canonicalData: Scalars["JSON"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  selectedMarketplaces: Array<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type SaveProductFieldMappingInput = {
  canonicalCategoryId: Scalars["String"]["input"];
  fieldValues: Scalars["JSON"]["input"];
  marketplace: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type SellerListItem = {
  __typename?: "SellerListItem";
  activeOrders: Scalars["Int"]["output"];
  createdAt: Scalars["String"]["output"];
  disputes: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  lowStockCount: Scalars["Int"]["output"];
  marketplaces: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  ownerEmail?: Maybe<Scalars["String"]["output"]>;
  ownerName?: Maybe<Scalars["String"]["output"]>;
  plan: Scalars["String"]["output"];
  revenue30d: Scalars["Float"]["output"];
  status: Scalars["String"]["output"];
  syncStatus: Scalars["String"]["output"];
  totalProducts: Scalars["Int"]["output"];
};

export type SellerProductDetail = {
  __typename?: "SellerProductDetail";
  brand?: Maybe<Scalars["String"]["output"]>;
  canonicalCategoryId?: Maybe<Scalars["String"]["output"]>;
  draftId?: Maybe<Scalars["ID"]["output"]>;
  draftStatus?: Maybe<Scalars["String"]["output"]>;
  draftUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  hasActive: Scalars["Boolean"]["output"];
  hasDraft: Scalars["Boolean"]["output"];
  hasInactive: Scalars["Boolean"]["output"];
  hasIncomplete: Scalars["Boolean"]["output"];
  hasNeedsAttention: Scalars["Boolean"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  inventory?: Maybe<SellerProductInventorySnapshot>;
  marketplaceCount: Scalars["Int"]["output"];
  marketplaces: Array<SellerProductMarketplaceSummary>;
  orderCount: Scalars["Int"]["output"];
  orders: Array<SellerProductOrderEntry>;
  rowKey: Scalars["String"]["output"];
  skuCode?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["String"]["output"];
};

export type SellerProductInventorySnapshot = {
  __typename?: "SellerProductInventorySnapshot";
  quantity?: Maybe<Scalars["Int"]["output"]>;
  reserved?: Maybe<Scalars["Int"]["output"]>;
  skuId?: Maybe<Scalars["ID"]["output"]>;
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  updatedBy?: Maybe<Scalars["ID"]["output"]>;
};

export enum SellerProductListingSpread {
  Multi = "multi",
  Single = "single",
}

export enum SellerProductListingStatus {
  Active = "active",
  Inactive = "inactive",
}

export type SellerProductMarketplaceSummary = {
  __typename?: "SellerProductMarketplaceSummary";
  currency?: Maybe<Scalars["String"]["output"]>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  fulfillmentType?: Maybe<Scalars["String"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  lastSyncedAt: Scalars["String"]["output"];
  linkSource?: Maybe<Scalars["String"]["output"]>;
  listingId: Scalars["ID"]["output"];
  marketplaceId: Scalars["String"]["output"];
  price?: Maybe<Scalars["Float"]["output"]>;
  provider: Scalars["String"]["output"];
  quantity?: Maybe<Scalars["Int"]["output"]>;
  rawStatus?: Maybe<Scalars["String"]["output"]>;
  /** True when another account sold this on a store it has since disconnected; the seller's product is not selling there. */
  sellingAccountDisconnected: Scalars["Boolean"]["output"];
  sku?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["String"]["output"];
  /** Listings in this store sharing that product; 2 or more means this listing is one of its variants. */
  variantCount: Scalars["Int"]["output"];
  /** The store product this variant belongs to; null when the store sends no variant data. */
  variantGroupId?: Maybe<Scalars["String"]["output"]>;
};

export type SellerProductOrderEntry = {
  __typename?: "SellerProductOrderEntry";
  currency?: Maybe<Scalars["String"]["output"]>;
  externalOrderId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  orderedAt: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  quantity?: Maybe<Scalars["Int"]["output"]>;
  status: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  totalAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type SellerProductOrdersInput = {
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type SellerProductOrdersPayload = {
  __typename?: "SellerProductOrdersPayload";
  items: Array<SellerProductOrderEntry>;
};

export type SellerProductSummary = {
  __typename?: "SellerProductSummary";
  brand?: Maybe<Scalars["String"]["output"]>;
  canonicalCategoryId?: Maybe<Scalars["String"]["output"]>;
  draftId?: Maybe<Scalars["ID"]["output"]>;
  draftStatus?: Maybe<Scalars["String"]["output"]>;
  draftUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  hasActive: Scalars["Boolean"]["output"];
  hasDraft: Scalars["Boolean"]["output"];
  hasInactive: Scalars["Boolean"]["output"];
  hasIncomplete: Scalars["Boolean"]["output"];
  hasNeedsAttention: Scalars["Boolean"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  inventory?: Maybe<SellerProductInventorySnapshot>;
  marketplaceCount: Scalars["Int"]["output"];
  marketplaces: Array<SellerProductMarketplaceSummary>;
  orderCount: Scalars["Int"]["output"];
  ownerName?: Maybe<Scalars["String"]["output"]>;
  rowKey: Scalars["String"]["output"];
  skuCode?: Maybe<Scalars["String"]["output"]>;
  stockDiffers: Scalars["Boolean"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["String"]["output"];
};

export type SellerProductsInput = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  listingSpread?: InputMaybe<SellerProductListingSpread>;
  /** The selected stores' own listing status; inactive is anything that isn't active. */
  listingStatus?: InputMaybe<SellerProductListingStatus>;
  marketplaces?: InputMaybe<Array<Scalars["String"]["input"]>>;
  onEverySelectedMarketplace?: InputMaybe<Scalars["Boolean"]["input"]>;
  outOfStockOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  /** Empty = every seller, own = this account's products, else a facilitated seller's workspace id. */
  seller?: InputMaybe<Scalars["String"]["input"]>;
  states?: InputMaybe<Array<Scalars["String"]["input"]>>;
  withSkuOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type SellerProductsMarketplaceCount = {
  __typename?: "SellerProductsMarketplaceCount";
  multiListingCount: Scalars["Int"]["output"];
  productCount: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
  singleListingCount: Scalars["Int"]["output"];
};

export type SellerProductsPageInfo = {
  __typename?: "SellerProductsPageInfo";
  endCursor?: Maybe<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
};

export type SellerProductsPayload = {
  __typename?: "SellerProductsPayload";
  items: Array<SellerProductSummary>;
  listingCount: Scalars["Int"]["output"];
  marketplaceCounts: Array<SellerProductsMarketplaceCount>;
  multiListingCount: Scalars["Int"]["output"];
  outOfStockCount: Scalars["Int"]["output"];
  pageInfo: SellerProductsPageInfo;
  /** Counts per owning workspace under the same filters but not the seller filter. Your own workspace id is your own products. */
  sellerCounts: Array<SellerProductsSellerCount>;
  singleListingCount: Scalars["Int"]["output"];
  /** The selected stores' own listings in the current tab and status. */
  tabListingCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type SellerProductsSellerCount = {
  __typename?: "SellerProductsSellerCount";
  count: Scalars["Int"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type SetLoginCodeInput = {
  on: Scalars["Boolean"]["input"];
  password?: InputMaybe<Scalars["String"]["input"]>;
};

export type SetLoginCodePayload = {
  __typename?: "SetLoginCodePayload";
  loginCodeOn: Scalars["Boolean"]["output"];
};

export type SetMarketplaceStatusInput = {
  code: Scalars["String"]["input"];
  status: Scalars["String"]["input"];
};

export type SetSellerStatusInput = {
  status: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type SetSharedStockInput = {
  draftId: Scalars["ID"]["input"];
  onHandQuantity: Scalars["Int"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type SharedProductMediaConfig = {
  __typename?: "SharedProductMediaConfig";
  acceptedMimeTypes?: Maybe<Array<Scalars["String"]["output"]>>;
  enabled: Scalars["Boolean"]["output"];
  guidelineUrl?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  maxFileSizeMb?: Maybe<Scalars["Int"]["output"]>;
  maxItems: Scalars["Int"]["output"];
  minItems?: Maybe<Scalars["Int"]["output"]>;
  ordered: Scalars["Boolean"]["output"];
};

export type ShipOrderWithShiprocketInput = {
  heightCm: Scalars["Float"]["input"];
  lengthCm: Scalars["Float"]["input"];
  notifyCustomer?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["String"]["input"];
  packageReferenceId: Scalars["String"]["input"];
  selections: Array<MarketplaceFulfillmentSelectionInput>;
  weightGrams: Scalars["Int"]["input"];
  widthCm: Scalars["Float"]["input"];
};

export type ShippingLabelPayload = {
  __typename?: "ShippingLabelPayload";
  fileName: Scalars["String"]["output"];
  labelBase64: Scalars["String"]["output"];
  labelFormat: Scalars["String"]["output"];
};

export type ShiprocketLabelPayload = {
  __typename?: "ShiprocketLabelPayload";
  downloadUrl: Scalars["String"]["output"];
  fileName: Scalars["String"]["output"];
};

export type ShiprocketPickupPayload = {
  __typename?: "ShiprocketPickupPayload";
  message: Scalars["String"]["output"];
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  tokenNumber?: Maybe<Scalars["String"]["output"]>;
};

export type ShiprocketTrackingPayload = {
  __typename?: "ShiprocketTrackingPayload";
  estimatedDeliveryDate?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  statusId?: Maybe<Scalars["Int"]["output"]>;
  trackingUrl?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["String"]["output"];
};

export type ShopcluesFulfillmentOrderRequestInput = {
  orderIds: Array<Scalars["String"]["input"]>;
  workspaceId: Scalars["ID"]["input"];
};

export type ShopcluesFulfillmentRequestPayload = {
  __typename?: "ShopcluesFulfillmentRequestPayload";
  rawResponse: Scalars["JSON"]["output"];
  requestId?: Maybe<Scalars["String"]["output"]>;
};

export type ShopcluesManifestRequestPayload = {
  __typename?: "ShopcluesManifestRequestPayload";
  carrierName?: Maybe<Scalars["String"]["output"]>;
  manifestId?: Maybe<Scalars["String"]["output"]>;
  rawResponse: Scalars["JSON"]["output"];
  requestId?: Maybe<Scalars["String"]["output"]>;
};

export type ShopcluesMerchant = {
  __typename?: "ShopcluesMerchant";
  companyStatus: Scalars["String"]["output"];
  companyStatusDescription?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  shopcluesUserId: Scalars["String"]["output"];
  shopcluesWalletId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  userId: Scalars["ID"]["output"];
  workspaceId: Scalars["ID"]["output"];
};

export type ShopcluesMerchantPayload = {
  __typename?: "ShopcluesMerchantPayload";
  merchant: ShopcluesMerchant;
};

export type ShopcluesRequestedFile = {
  __typename?: "ShopcluesRequestedFile";
  filePath: Scalars["String"]["output"];
  requestId: Scalars["String"]["output"];
};

export type ShopcluesRequestedFilePathInput = {
  requestIds: Array<Scalars["String"]["input"]>;
  workspaceId: Scalars["ID"]["input"];
};

export type ShopcluesRequestedFilePathPayload = {
  __typename?: "ShopcluesRequestedFilePathPayload";
  files: Array<ShopcluesRequestedFile>;
  invalidRequests: Array<Scalars["String"]["output"]>;
  notProcessedRequests: Array<Scalars["String"]["output"]>;
  rawResponse: Scalars["JSON"]["output"];
};

export type ShopcluesWalletBalanceMutationInput = {
  amount: Scalars["Int"]["input"];
  shopcluesOrderId: Scalars["String"]["input"];
  workspaceId: Scalars["ID"]["input"];
};

export type ShopcluesWalletBalancePayload = {
  __typename?: "ShopcluesWalletBalancePayload";
  balance: Scalars["Float"]["output"];
  ledgerId?: Maybe<Scalars["ID"]["output"]>;
  operation?: Maybe<Scalars["String"]["output"]>;
  serviceBalance?: Maybe<Scalars["JSON"]["output"]>;
  shopcluesOrderId?: Maybe<Scalars["String"]["output"]>;
  transactionId?: Maybe<Scalars["String"]["output"]>;
};

export type ShopcluesWalletTopup = {
  __typename?: "ShopcluesWalletTopup";
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  paidAt?: Maybe<Scalars["DateTime"]["output"]>;
  paymentLongUrl?: Maybe<Scalars["String"]["output"]>;
  paymentShortUrl?: Maybe<Scalars["String"]["output"]>;
  shopcluesMerchantWalletId: Scalars["ID"]["output"];
  shopcluesOrderId: Scalars["String"]["output"];
  shopcluesUserId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  workspaceId: Scalars["ID"]["output"];
};

export type ShopcluesWalletTopupPayload = {
  __typename?: "ShopcluesWalletTopupPayload";
  topup: ShopcluesWalletTopup;
};

export type ShopcluesWalletTransaction = {
  __typename?: "ShopcluesWalletTransaction";
  closingBalance: Scalars["String"]["output"];
  creditAmount?: Maybe<Scalars["String"]["output"]>;
  debitAmount?: Maybe<Scalars["String"]["output"]>;
  entityId: Scalars["String"]["output"];
  entityType: Scalars["String"]["output"];
  transactionDate: Scalars["String"]["output"];
  transactionDetails: Scalars["String"]["output"];
  transactionId: Scalars["String"]["output"];
};

export type ShopcluesWalletTransactionsPayload = {
  __typename?: "ShopcluesWalletTransactionsPayload";
  count: Scalars["String"]["output"];
  invalidOrderIds: Scalars["String"]["output"];
  noOfEntries: Scalars["Int"]["output"];
  page: Scalars["String"]["output"];
  pageLimit: Scalars["String"]["output"];
  transactions: Array<ShopcluesWalletTransaction>;
};

export type ShopifyAuthSessionInput = {
  shop: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type ShopifyAuthSessionPayload = {
  __typename?: "ShopifyAuthSessionPayload";
  sessionId: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type ShopifyOrder = {
  __typename?: "ShopifyOrder";
  buyerEmail?: Maybe<Scalars["String"]["output"]>;
  buyerName?: Maybe<Scalars["String"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  fulfillmentChannel?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  lastUpdateDate?: Maybe<Scalars["String"]["output"]>;
  numberOfItemsShipped?: Maybe<Scalars["Int"]["output"]>;
  numberOfItemsUnshipped?: Maybe<Scalars["Int"]["output"]>;
  orderItems?: Maybe<Scalars["JSON"]["output"]>;
  orderStatus?: Maybe<Scalars["String"]["output"]>;
  orderTotal?: Maybe<Scalars["Float"]["output"]>;
  purchaseDate?: Maybe<Scalars["String"]["output"]>;
  rawSyncedAt?: Maybe<Scalars["String"]["output"]>;
  salesChannel?: Maybe<Scalars["String"]["output"]>;
  shippingAddress?: Maybe<Scalars["JSON"]["output"]>;
  shopifyOrderId: Scalars["String"]["output"];
};

export type ShopifyOrderWebhookSubscriptionResult = {
  __typename?: "ShopifyOrderWebhookSubscriptionResult";
  endpoint: Scalars["String"]["output"];
  eventType: ShopifyOrderWebhookTopic;
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["String"]["output"];
};

export enum ShopifyOrderWebhookTopic {
  AppUninstalled = "APP_UNINSTALLED",
  FulfillmentsCreate = "FULFILLMENTS_CREATE",
  FulfillmentsUpdate = "FULFILLMENTS_UPDATE",
  OrdersCancelled = "ORDERS_CANCELLED",
  OrdersCreate = "ORDERS_CREATE",
  OrdersUpdated = "ORDERS_UPDATED",
}

export type ShopifyOrderWebhookUnsubscribeResult = {
  __typename?: "ShopifyOrderWebhookUnsubscribeResult";
  deleted: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  eventType: ShopifyOrderWebhookTopic;
  status: Scalars["String"]["output"];
  subscriptionId?: Maybe<Scalars["String"]["output"]>;
};

export type ShopifyOrdersInput = {
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  pageToken?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
  workspaceId: Scalars["String"]["input"];
};

export type ShopifyOrdersPayload = {
  __typename?: "ShopifyOrdersPayload";
  items: Array<ShopifyOrder>;
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
  totalCount: Scalars["Int"]["output"];
};

export type ShopifyProductTypeSchemaDigestInput = {
  productType: Scalars["String"]["input"];
};

export type ShopifyProductTypeSchemaDigestPayload = {
  __typename?: "ShopifyProductTypeSchemaDigestPayload";
  aiResponse: Scalars["JSON"]["output"];
  canonicalSchemaPayload: Scalars["JSON"]["output"];
  categoryGid?: Maybe<Scalars["String"]["output"]>;
  productType: Scalars["String"]["output"];
  shop: Scalars["String"]["output"];
};

export type ShopifyProductTypeSearchItem = {
  __typename?: "ShopifyProductTypeSearchItem";
  name: Scalars["String"]["output"];
  synced: Scalars["Boolean"]["output"];
};

export type ShopifySearchProductTypesInput = {
  keyword: Scalars["String"]["input"];
};

export type ShopifySearchProductTypesPayload = {
  __typename?: "ShopifySearchProductTypesPayload";
  productTypes: Array<ShopifyProductTypeSearchItem>;
};

export type SnapdealAuthSessionInput = {
  workspaceId: Scalars["String"]["input"];
};

export type SnapdealAuthSessionPayload = {
  __typename?: "SnapdealAuthSessionPayload";
  sessionId: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type SnapdealBulkOperationPayload = {
  __typename?: "SnapdealBulkOperationPayload";
  downloadUrls: Array<Scalars["String"]["output"]>;
  failedCount: Scalars["Int"]["output"];
  results: Array<SnapdealBulkOperationResult>;
  successCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type SnapdealBulkOperationResult = {
  __typename?: "SnapdealBulkOperationResult";
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["String"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type SnapdealCategory = {
  __typename?: "SnapdealCategory";
  categoryId: Scalars["String"]["output"];
  categoryName: Scalars["String"]["output"];
  fullPath: Scalars["String"]["output"];
  leaf: Scalars["Boolean"]["output"];
};

export type SnapdealCategorySchemaDigestInput = {
  categoryId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type SnapdealCategorySchemaDigestPayload = {
  __typename?: "SnapdealCategorySchemaDigestPayload";
  canonicalSchemaPayload: Scalars["JSON"]["output"];
  categoryId: Scalars["String"]["output"];
  raw: Scalars["JSON"]["output"];
};

export type SnapdealCategorySearchInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  query: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type SnapdealCategorySearchPayload = {
  __typename?: "SnapdealCategorySearchPayload";
  categories: Array<SnapdealCategory>;
};

export type StartShopifyCustomOAuthInput = {
  clientId: Scalars["String"]["input"];
  clientSecret: Scalars["String"]["input"];
  shopDomain: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type StartShopifyCustomOAuthPayload = {
  __typename?: "StartShopifyCustomOAuthPayload";
  authorizeUrl: Scalars["String"]["output"];
};

export type StartShopifyInstallInput = {
  workspaceId: Scalars["String"]["input"];
};

export type StartShopifyInstallPayload = {
  __typename?: "StartShopifyInstallPayload";
  installStartUrl: Scalars["String"]["output"];
};

/** A product whose stores report different stock, or a stock different from SmartStore's. */
export type StockMismatch = {
  __typename?: "StockMismatch";
  draftId: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  /** SmartStore's available stock; null when the product has no single stock pool. */
  onHand?: Maybe<Scalars["Int"]["output"]>;
  stocks: Array<StockMismatchStore>;
  title: Scalars["String"]["output"];
};

export type StockMismatchStore = {
  __typename?: "StockMismatchStore";
  /** The store's own product id. */
  externalId?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  skuCode: Scalars["String"]["output"];
  stock: Scalars["Int"]["output"];
};

export type StoreLogisticsConnectionInput = {
  company_id: Scalars["ID"]["input"];
  created_at: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  first_name: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  last_name: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
  workspaceId: Scalars["ID"]["input"];
};

export type StoreLogisticsConnectionPayload = {
  __typename?: "StoreLogisticsConnectionPayload";
  connectionId: Scalars["ID"]["output"];
  credentialId: Scalars["ID"]["output"];
};

export type StoreMeeshoCredentialsInput = {
  browserId: Scalars["String"]["input"];
  /**
   * Meesho login email captured by the SmartStore login form. Stored
   * encrypted (AES-256-GCM) so the server can silently re-auth when the
   * session cookie expires.
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  identifier: Scalars["String"]["input"];
  /**
   * Meesho login password captured by the SmartStore login form. Stored
   * encrypted alongside email. Never logged or returned in any query.
   */
  password?: InputMaybe<Scalars["String"]["input"]>;
  /** The connect.sid session cookie value from Meesho seller panel. */
  sessionCookie: Scalars["String"]["input"];
  supplierId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type StoreMeeshoCredentialsPayload = {
  __typename?: "StoreMeeshoCredentialsPayload";
  success: Scalars["Boolean"]["output"];
};

export type SubscribeEbayOrderWebhooksInput = {
  endpointUrl?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type SubscribeEbayOrderWebhooksPayload = {
  __typename?: "SubscribeEbayOrderWebhooksPayload";
  destinationId: Scalars["String"]["output"];
  endpoint: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  sellerId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["String"]["output"];
  topicId: Scalars["String"]["output"];
};

export type SubscribeShopifyOrderWebhooksInput = {
  endpointUrl?: InputMaybe<Scalars["String"]["input"]>;
  eventTypes?: InputMaybe<Array<ShopifyOrderWebhookTopic>>;
  workspaceId: Scalars["String"]["input"];
};

export type SubscribeShopifyOrderWebhooksPayload = {
  __typename?: "SubscribeShopifyOrderWebhooksPayload";
  provider: Scalars["String"]["output"];
  shop: Scalars["String"]["output"];
  subscriptions: Array<ShopifyOrderWebhookSubscriptionResult>;
};

export type Subscription = {
  __typename?: "Subscription";
  _placeholder?: Maybe<Scalars["Boolean"]["output"]>;
  marketplaceOrderEvents: MarketplaceOrderEvent;
  productMarketplaceSaveSession: ProductMarketplaceSaveUpdate;
  /** Real-time per-marketplace publish status updates. */
  productPublishSession: ProductPublishUpdate;
  taxonomyApprovalPipeline: TaxonomyApprovalPipelineUpdate;
  taxonomyIngestionSession: TaxonomyIngestionEvent;
  taxonomyMappingSession: TaxonomyMappingSessionUpdate;
};

export type SubscriptionMarketplaceOrderEventsArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type SubscriptionProductMarketplaceSaveSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type SubscriptionProductPublishSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type SubscriptionTaxonomyApprovalPipelineArgs = {
  syncJobId: Scalars["ID"]["input"];
};

export type SubscriptionTaxonomyIngestionSessionArgs = {
  runId: Scalars["ID"]["input"];
};

export type SubscriptionTaxonomyMappingSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type SubscriptionPlan = {
  __typename?: "SubscriptionPlan";
  changeNote?: Maybe<Scalars["String"]["output"]>;
  code: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  effectiveFrom: Scalars["DateTime"]["output"];
  effectiveTo?: Maybe<Scalars["DateTime"]["output"]>;
  entitlements: Array<SubscriptionPlanEntitlement>;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  version: Scalars["Int"]["output"];
};

export enum SubscriptionPlanCode {
  Free = "FREE",
  Gold = "GOLD",
  Platinum = "PLATINUM",
  Silver = "SILVER",
}

export type SubscriptionPlanEntitlement = {
  __typename?: "SubscriptionPlanEntitlement";
  description?: Maybe<Scalars["String"]["output"]>;
  displayType: EntitlementDisplayType;
  key: Scalars["String"]["output"];
  order: Scalars["Int"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
  valueBool?: Maybe<Scalars["Boolean"]["output"]>;
  valueInt?: Maybe<Scalars["Int"]["output"]>;
  valueJson?: Maybe<Scalars["JSON"]["output"]>;
  valueText?: Maybe<Scalars["String"]["output"]>;
  valueType: EntitlementValueType;
};

export enum SubscriptionProvider {
  Manual = "MANUAL",
  Razorpay = "RAZORPAY",
  Stripe = "STRIPE",
}

export enum SubscriptionStatus {
  Active = "ACTIVE",
  Canceled = "CANCELED",
  PastDue = "PAST_DUE",
  Trialing = "TRIALING",
}

export type SupportedMarketplace = {
  __typename?: "SupportedMarketplace";
  marketplace: Scalars["String"]["output"];
  notSupported: Scalars["Boolean"]["output"];
  productType: Scalars["String"]["output"];
};

export type SyncJobSummary = {
  __typename?: "SyncJobSummary";
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  finishedAt?: Maybe<Scalars["String"]["output"]>;
  itemsProcessed: Scalars["Int"]["output"];
  provider: Scalars["String"]["output"];
  startedAt?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  syncType: Scalars["String"]["output"];
};

export type SyncListingsInput = {
  providers?: InputMaybe<Array<Scalars["String"]["input"]>>;
  workspaceId: Scalars["String"]["input"];
};

export type SyncListingsPayload = {
  __typename?: "SyncListingsPayload";
  results: Array<SyncResult>;
};

export type SyncOrdersInput = {
  createdAfter?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type SyncOrdersPayload = {
  __typename?: "SyncOrdersPayload";
  results: Array<SyncResult>;
};

export type SyncResult = {
  __typename?: "SyncResult";
  error?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  syncJobId: Scalars["String"]["output"];
  syncedCount: Scalars["Int"]["output"];
};

export type TaxonomyApprovalPipelineJob = {
  __typename?: "TaxonomyApprovalPipelineJob";
  approvedBy?: Maybe<Scalars["String"]["output"]>;
  attemptCount: Scalars["Int"]["output"];
  availableActions: Array<Scalars["String"]["output"]>;
  canonicalValueDecisionCount: Scalars["Int"]["output"];
  claimedBy?: Maybe<Scalars["String"]["output"]>;
  completedAt?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  dispatchedAt?: Maybe<Scalars["String"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  errorType?: Maybe<Scalars["String"]["output"]>;
  failedAt?: Maybe<Scalars["String"]["output"]>;
  fieldDecisionCount: Scalars["Int"]["output"];
  lastLedgerAt?: Maybe<Scalars["String"]["output"]>;
  lastLedgerEventType?: Maybe<Scalars["String"]["output"]>;
  mappingSessionId: Scalars["ID"]["output"];
  marketplaceSpecificValueDecisionCount: Scalars["Int"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  payload?: Maybe<Scalars["JSON"]["output"]>;
  pipelineId?: Maybe<Scalars["String"]["output"]>;
  queuedAt: Scalars["String"]["output"];
  resourceLockKey: Scalars["String"]["output"];
  retryable: Scalars["Boolean"]["output"];
  startedAt?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  syncJobId: Scalars["ID"]["output"];
  taxonomyJobId?: Maybe<Scalars["String"]["output"]>;
  taxonomyStatus?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["String"]["output"];
};

export type TaxonomyApprovalPipelineJobActionInput = {
  auditNote: Scalars["String"]["input"];
  syncJobId: Scalars["ID"]["input"];
};

export type TaxonomyApprovalPipelineJobActionPayload = {
  __typename?: "TaxonomyApprovalPipelineJobActionPayload";
  job: TaxonomyApprovalPipelineJob;
  message: Scalars["String"]["output"];
};

export type TaxonomyApprovalPipelineJobDetail = {
  __typename?: "TaxonomyApprovalPipelineJobDetail";
  job: TaxonomyApprovalPipelineJob;
  ledger: Array<TaxonomyApprovalPipelineLedgerEntry>;
};

export type TaxonomyApprovalPipelineJobsInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  mappingSessionId?: InputMaybe<Scalars["ID"]["input"]>;
  resourceLockKey?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
  syncJobId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TaxonomyApprovalPipelineJobsPayload = {
  __typename?: "TaxonomyApprovalPipelineJobsPayload";
  items: Array<TaxonomyApprovalPipelineJob>;
};

export type TaxonomyApprovalPipelineLedgerEntry = {
  __typename?: "TaxonomyApprovalPipelineLedgerEntry";
  createdAt: Scalars["String"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  eventType?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  payload?: Maybe<Scalars["JSON"]["output"]>;
  retryable?: Maybe<Scalars["Boolean"]["output"]>;
  status: Scalars["String"]["output"];
  syncJobId?: Maybe<Scalars["ID"]["output"]>;
};

export type TaxonomyApprovalPipelineUpdate = {
  __typename?: "TaxonomyApprovalPipelineUpdate";
  affected?: Maybe<Scalars["JSON"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  errorDetails?: Maybe<Scalars["JSON"]["output"]>;
  errorType?: Maybe<Scalars["String"]["output"]>;
  eventId: Scalars["ID"]["output"];
  eventType: Scalars["String"]["output"];
  fieldResults?: Maybe<Scalars["JSON"]["output"]>;
  mappingSessionId: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  occurredAt: Scalars["String"]["output"];
  payload?: Maybe<Scalars["JSON"]["output"]>;
  pipelineId?: Maybe<Scalars["String"]["output"]>;
  resourceLockKey: Scalars["String"]["output"];
  retryable?: Maybe<Scalars["Boolean"]["output"]>;
  status: Scalars["String"]["output"];
  syncJobId: Scalars["ID"]["output"];
  taxonomyJobId?: Maybe<Scalars["String"]["output"]>;
  taxonomyStatus?: Maybe<Scalars["String"]["output"]>;
  terminal: Scalars["Boolean"]["output"];
  valueResults?: Maybe<Scalars["JSON"]["output"]>;
};

export type TaxonomyCategoryMappedTo = {
  __typename?: "TaxonomyCategoryMappedTo";
  /** True until a sync of this mapping succeeds; the category is then free to map again. */
  lastSyncFailed: Scalars["Boolean"]["output"];
  marketplaceCategoryId?: Maybe<Scalars["String"]["output"]>;
  productType: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type TaxonomyCategorySearchItem = {
  __typename?: "TaxonomyCategorySearchItem";
  level?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  parent?: Maybe<Scalars["String"]["output"]>;
  path: Scalars["String"]["output"];
  raw?: Maybe<Scalars["JSON"]["output"]>;
  sampleListing?: Maybe<Scalars["String"]["output"]>;
  score?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxonomyCategorySuggestItem = {
  __typename?: "TaxonomyCategorySuggestItem";
  categoryPath: Scalars["String"]["output"];
  /**
   * Set when this category already has an ACTIVE mapping for the requested
   * marketplace. Null when no marketplace was given, or nothing is mapped yet.
   */
  mappedTo?: Maybe<TaxonomyCategoryMappedTo>;
  raw?: Maybe<Scalars["JSON"]["output"]>;
  score?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxonomyIngestionEvent = {
  __typename?: "TaxonomyIngestionEvent";
  approxRemainingLabel?: Maybe<Scalars["String"]["output"]>;
  elapsedMs: Scalars["Float"]["output"];
  eventId: Scalars["ID"]["output"];
  eventType: Scalars["String"]["output"];
  externalSessionId?: Maybe<Scalars["String"]["output"]>;
  mappingSessionId?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  occurredAt: Scalars["String"]["output"];
  payload: Scalars["JSON"]["output"];
  productType: Scalars["String"]["output"];
  progressPercent?: Maybe<Scalars["Float"]["output"]>;
  runId: Scalars["ID"]["output"];
  stageKey?: Maybe<Scalars["String"]["output"]>;
  stageLabel?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  technicalMessage?: Maybe<Scalars["String"]["output"]>;
  terminal: Scalars["Boolean"]["output"];
  userMessage?: Maybe<Scalars["String"]["output"]>;
  workspaceId?: Maybe<Scalars["String"]["output"]>;
};

export type TaxonomyIngestionRun = {
  __typename?: "TaxonomyIngestionRun";
  approxRemainingLabel?: Maybe<Scalars["String"]["output"]>;
  completedAt?: Maybe<Scalars["String"]["output"]>;
  displayName: Scalars["String"]["output"];
  externalSessionId?: Maybe<Scalars["String"]["output"]>;
  mappingSessionId?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  progressPercent?: Maybe<Scalars["Float"]["output"]>;
  runId: Scalars["ID"]["output"];
  stageKey?: Maybe<Scalars["String"]["output"]>;
  stageLabel?: Maybe<Scalars["String"]["output"]>;
  startedAt: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  technicalMessage?: Maybe<Scalars["String"]["output"]>;
  terminal: Scalars["Boolean"]["output"];
  updatedAt: Scalars["String"]["output"];
  userMessage?: Maybe<Scalars["String"]["output"]>;
  workspaceId?: Maybe<Scalars["String"]["output"]>;
};

export type TaxonomyMappingSessionUpdate = {
  __typename?: "TaxonomyMappingSessionUpdate";
  /** Short status message suitable for UI display. */
  message?: Maybe<Scalars["String"]["output"]>;
  payload: Scalars["JSON"]["output"];
  /** Server-owned phase identifier for the five-step sync lifecycle. */
  phaseKey?: Maybe<Scalars["String"]["output"]>;
  /** Human readable label for the current sync phase. */
  phaseLabel?: Maybe<Scalars["String"]["output"]>;
  progress?: Maybe<Scalars["Float"]["output"]>;
  sessionId: Scalars["ID"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  /** Full five-step plan with per-step completion flags. */
  steps: Array<TaxonomySyncStep>;
};

export type TaxonomyResolutionTask = {
  __typename?: "TaxonomyResolutionTask";
  createdAt: Scalars["String"]["output"];
  firstBlockedListingId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  latestBlockedListingId?: Maybe<Scalars["String"]["output"]>;
  mappingSessionId?: Maybe<Scalars["String"]["output"]>;
  marketplace: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  resolvedAt?: Maybe<Scalars["String"]["output"]>;
  samplePayload?: Maybe<Scalars["JSON"]["output"]>;
  status: Scalars["String"]["output"];
  totalBlocked: Scalars["Int"]["output"];
  updatedAt: Scalars["String"]["output"];
};

export type TaxonomySaveProductTypeMappingInput = {
  /**
   * Confirms replacing an existing ACTIVE mapping for canonicalCategoryId on
   * this marketplace. Without it, a save is refused when one already exists.
   */
  allowOverwrite?: InputMaybe<Scalars["Boolean"]["input"]>;
  canonicalCategoryId: Scalars["String"]["input"];
  marketplace: Scalars["String"]["input"];
  /**
   * The marketplace's own category id/gid for productType (Shopify's taxonomy
   * category gid, ShopClues' numeric category id), when the caller has one.
   * Stored as-is, never re-derived from productType's text. A productType
   * already saved with a different id is refused (CONFLICT).
   */
  marketplaceCategoryId?: InputMaybe<Scalars["String"]["input"]>;
  productType: Scalars["String"]["input"];
};

export type TaxonomySupportedCategory = {
  __typename?: "TaxonomySupportedCategory";
  canonicalCategoryId: Scalars["String"]["output"];
  canonicalCategoryLevel?: Maybe<Scalars["Int"]["output"]>;
  canonicalCategoryName?: Maybe<Scalars["String"]["output"]>;
  canonicalCategoryParent?: Maybe<Scalars["String"]["output"]>;
  mappedFields: Scalars["Int"]["output"];
  marketplace: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type TaxonomySupportedMarketplace = {
  __typename?: "TaxonomySupportedMarketplace";
  categoryCount: Scalars["Int"]["output"];
  marketplace: Scalars["String"]["output"];
};

export type TaxonomySyncStep = {
  __typename?: "TaxonomySyncStep";
  done: Scalars["Boolean"]["output"];
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type UnmapListingFromProductInput = {
  listingId: Scalars["ID"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type UnsubscribeEbayOrderWebhooksInput = {
  workspaceId: Scalars["String"]["input"];
};

export type UnsubscribeEbayOrderWebhooksPayload = {
  __typename?: "UnsubscribeEbayOrderWebhooksPayload";
  deleted: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  sellerId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId?: Maybe<Scalars["String"]["output"]>;
};

export type UnsubscribeShopifyOrderWebhooksInput = {
  eventTypes?: InputMaybe<Array<ShopifyOrderWebhookTopic>>;
  workspaceId: Scalars["String"]["input"];
};

export type UnsubscribeShopifyOrderWebhooksPayload = {
  __typename?: "UnsubscribeShopifyOrderWebhooksPayload";
  provider: Scalars["String"]["output"];
  shop: Scalars["String"]["output"];
  subscriptions: Array<ShopifyOrderWebhookUnsubscribeResult>;
};

export type UpdateFlipkartFormAcknowledgementItemInput = {
  ackNumber: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type UpdateFlipkartFormAcknowledgementsInput = {
  forms: Array<UpdateFlipkartFormAcknowledgementItemInput>;
  orderId: Scalars["String"]["input"];
  /** The shipment to act on; defaults to the one that needs work now. */
  shipmentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateMarketplaceFacilitatorInput = {
  cartServiceId?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<Scalars["JSON"]["input"]>;
  facilitatorWorkspaceId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  marketplaceCode?: InputMaybe<Scalars["String"]["input"]>;
  shopcluesCompanyId?: InputMaybe<Scalars["String"]["input"]>;
  shopcluesSellerId?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateMarketplaceFulfillmentTrackingInput = {
  carrierName?: InputMaybe<Scalars["String"]["input"]>;
  fulfillmentId: Scalars["String"]["input"];
  notifyCustomer?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderId: Scalars["String"]["input"];
  trackingNumber: Scalars["String"]["input"];
  trackingUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateMarketplaceOrderStatusInput = {
  action?: InputMaybe<MarketplaceOrderAction>;
  cancellation?: InputMaybe<MarketplaceOrderStatusCancellationInput>;
  delivery?: InputMaybe<MarketplaceOrderDeliveryInput>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["String"]["input"];
  shipment?: InputMaybe<MarketplaceOrderStatusShipmentInput>;
  status?: InputMaybe<MarketplaceOrderStatusUpdateTarget>;
};

export type UpdateMarketplaceOrderStatusPayload = {
  __typename?: "UpdateMarketplaceOrderStatusPayload";
  externalActionId?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["String"]["output"];
  previousStatus: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  rawStatus?: Maybe<Scalars["String"]["output"]>;
  shipmentId?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type UpsertInventoryBySkuInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  quantity: Scalars["Int"]["input"];
  reserved?: InputMaybe<Scalars["Int"]["input"]>;
  skuCode: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type VerifyLoginCodeInput = {
  code: Scalars["String"]["input"];
  loginTicket: Scalars["String"]["input"];
  rememberDevice: Scalars["Boolean"]["input"];
};

export type ViewerBootstrapPayload = {
  __typename?: "ViewerBootstrapPayload";
  profile: IamUser;
  workspace?: Maybe<WorkspaceBootstrap>;
};

export type WishAuthSessionInput = {
  workspaceId: Scalars["String"]["input"];
};

export type WishAuthSessionPayload = {
  __typename?: "WishAuthSessionPayload";
  sessionId: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type Workspace = {
  __typename?: "Workspace";
  addressLine1: Scalars["String"]["output"];
  addressLine2: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  connectedMarketplaceCount: Scalars["Int"]["output"];
  country: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  marketplaceConnections: Array<WorkspaceMarketplaceConnectionSnapshot>;
  name: Scalars["String"]["output"];
  onboarding?: Maybe<WorkspaceOnboardingSnapshot>;
  onboardingStatus: WorkspaceOnboardingStatus;
  phoneNumber: Scalars["String"]["output"];
  plan?: Maybe<WorkspacePlanSnapshot>;
  postalCode: Scalars["String"]["output"];
  stateOrRegion: Scalars["String"]["output"];
  status: WorkspaceStatus;
  taxId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type WorkspaceBootstrap = {
  __typename?: "WorkspaceBootstrap";
  addressLine1: Scalars["String"]["output"];
  addressLine2: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  marketplaceConnections: Array<WorkspaceMarketplaceConnectionSnapshot>;
  name: Scalars["String"]["output"];
  onboarding?: Maybe<WorkspaceOnboardingSnapshot>;
  phoneNumber: Scalars["String"]["output"];
  plan?: Maybe<WorkspacePlanSnapshot>;
  postalCode: Scalars["String"]["output"];
  stateOrRegion: Scalars["String"]["output"];
  status: WorkspaceStatus;
  taxId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type WorkspaceMarketplaceConnectionSnapshot = {
  __typename?: "WorkspaceMarketplaceConnectionSnapshot";
  displayName?: Maybe<Scalars["String"]["output"]>;
  externalSellerId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastSyncAt?: Maybe<Scalars["DateTime"]["output"]>;
  provider: MarketplaceProvider;
  status: MarketplaceConnectionStatus;
};

export enum WorkspaceMembershipRole {
  Admin = "ADMIN",
  Finance = "FINANCE",
  Manager = "MANAGER",
  Ops = "OPS",
  Owner = "OWNER",
  Support = "SUPPORT",
  Viewer = "VIEWER",
}

export enum WorkspaceMembershipStatus {
  Active = "ACTIVE",
  Invited = "INVITED",
  Removed = "REMOVED",
}

export type WorkspaceOnboardingSnapshot = {
  __typename?: "WorkspaceOnboardingSnapshot";
  checkpoint?: Maybe<Scalars["String"]["output"]>;
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  currentStep: WorkspaceOnboardingStep;
  id: Scalars["ID"]["output"];
  progressJson?: Maybe<Scalars["JSON"]["output"]>;
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: WorkspaceOnboardingStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum WorkspaceOnboardingStatus {
  Blocked = "BLOCKED",
  Completed = "COMPLETED",
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
}

export enum WorkspaceOnboardingStep {
  ConnectMarketplaces = "CONNECT_MARKETPLACES",
  Done = "DONE",
  PlanSelect = "PLAN_SELECT",
  ReviewSync = "REVIEW_SYNC",
  StoreDetails = "STORE_DETAILS",
}

export type WorkspacePlanSnapshot = {
  __typename?: "WorkspacePlanSnapshot";
  cancelAtPeriodEnd: Scalars["Boolean"]["output"];
  code: Scalars["String"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  currentPeriodEnd?: Maybe<Scalars["DateTime"]["output"]>;
  currentPeriodStart?: Maybe<Scalars["DateTime"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  priceMonthly?: Maybe<Scalars["Int"]["output"]>;
  promoText?: Maybe<Scalars["String"]["output"]>;
  provider: SubscriptionProvider;
  status: SubscriptionStatus;
};

export enum WorkspaceStatus {
  Active = "ACTIVE",
  Closed = "CLOSED",
  Suspended = "SUSPENDED",
}

export type WorkspaceSubscription = {
  __typename?: "WorkspaceSubscription";
  cancelAtPeriodEnd: Scalars["Boolean"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currentPeriodEnd?: Maybe<Scalars["DateTime"]["output"]>;
  currentPeriodStart?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  plan: Scalars["String"]["output"];
  planId?: Maybe<Scalars["ID"]["output"]>;
  provider: SubscriptionProvider;
  providerCustomerId?: Maybe<Scalars["String"]["output"]>;
  providerSubscriptionId?: Maybe<Scalars["String"]["output"]>;
  status: SubscriptionStatus;
  updatedAt: Scalars["DateTime"]["output"];
  workspaceId: Scalars["ID"]["output"];
};

export type AdminLoginMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
}>;

export type AdminLoginMutation = {
  __typename?: "Mutation";
  adminLogin: {
    __typename?: "IamLoginPayload";
    accessToken?: string | null;
    refreshToken?: string | null;
    loginTicket?: string | null;
    maskedEmail?: string | null;
    user?: {
      __typename?: "IamUser";
      id: string;
      email: string;
      name?: string | null;
      status: string;
      role?: string | null;
      lastLoginAt?: any | null;
      createdAt: any;
    } | null;
  };
};

export type AttributeReviewApproveSelectedMutationVariables = Exact<{
  input: AttributeReviewApproveSelectedInput;
}>;

export type AttributeReviewApproveSelectedMutation = {
  __typename?: "Mutation";
  attributeReviewApproveSelected: {
    __typename?: "AttributeReviewApproveSelectedPayload";
    mappingSessionId: string;
    syncJobId?: string | null;
    pipelineId?: string | null;
    status: string;
    queued: boolean;
    retryable: boolean;
    approvedFieldCount: number;
    skippedFieldCount: number;
    failedFieldCount: number;
    approvedValueCount: number;
    marketplaceSpecificValueCount: number;
    skippedValueCount: number;
    failedValueCount: number;
    fieldResults: Array<{
      __typename?: "AttributeReviewBulkFieldResult";
      inputIndex: number;
      sourceFieldId: string;
      status: string;
      code?: string | null;
      message?: string | null;
    }>;
    valueResults: Array<{
      __typename?: "AttributeReviewBulkValueResult";
      inputIndex: number;
      sourceFieldId?: string | null;
      valueApprovalId?: string | null;
      canonicalPath?: string | null;
      marketplaceValue?: string | null;
      decision?: string | null;
      status: string;
      code?: string | null;
      message?: string | null;
      marketplaceSpecificKey?: string | null;
    }>;
  };
};

export type AttributeReviewApproveSessionMutationVariables = Exact<{
  input: AttributeReviewApproveInput;
}>;

export type AttributeReviewApproveSessionMutation = {
  __typename?: "Mutation";
  attributeReviewApproveSession?: {
    __typename?: "AttributeReviewApprovePayload";
    mappingSessionId: string;
    decision: string;
    syncJobId?: string | null;
  } | null;
};

export type CancelTaxonomyApprovalPipelineJobMutationVariables = Exact<{
  input: TaxonomyApprovalPipelineJobActionInput;
}>;

export type CancelTaxonomyApprovalPipelineJobMutation = {
  __typename?: "Mutation";
  cancelTaxonomyApprovalPipelineJob: {
    __typename?: "TaxonomyApprovalPipelineJobActionPayload";
    message: string;
    job: {
      __typename?: "TaxonomyApprovalPipelineJob";
      syncJobId: string;
      mappingSessionId: string;
      resourceLockKey: string;
      status: string;
      retryable: boolean;
      error?: string | null;
      errorType?: string | null;
      message?: string | null;
      attemptCount: number;
      pipelineId?: string | null;
      taxonomyJobId?: string | null;
      taxonomyStatus?: string | null;
      approvedBy?: string | null;
      notes?: string | null;
      fieldDecisionCount: number;
      canonicalValueDecisionCount: number;
      marketplaceSpecificValueDecisionCount: number;
      queuedAt: string;
      startedAt?: string | null;
      dispatchedAt?: string | null;
      completedAt?: string | null;
      failedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      lastLedgerEventType?: string | null;
      lastLedgerAt?: string | null;
      availableActions: Array<string>;
    };
  };
};

export type CreateMarketplaceFacilitatorMutationVariables = Exact<{
  input: CreateMarketplaceFacilitatorInput;
}>;

export type CreateMarketplaceFacilitatorMutation = {
  __typename?: "Mutation";
  createMarketplaceFacilitator: {
    __typename?: "MarketplaceFacilitator";
    id: string;
  };
};

export type DeleteMappingSessionMutationVariables = Exact<{
  input: DeleteMappingSessionInput;
}>;

export type DeleteMappingSessionMutation = {
  __typename?: "Mutation";
  deleteMappingSession: {
    __typename?: "DeleteMappingSessionResult";
    sessionId: string;
    deleted: boolean;
  };
};

export type IamLogoutMutationVariables = Exact<{ [key: string]: never }>;

export type IamLogoutMutation = {
  __typename?: "Mutation";
  iamLogout: { __typename?: "IamLogoutPayload"; message: string };
};

export type IamRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type IamRefreshTokenMutation = {
  __typename?: "Mutation";
  iamRefreshToken: {
    __typename?: "IamRefreshTokenPayload";
    accessToken: string;
  };
};

export type AttributeReviewMapRowValuesMutationVariables = Exact<{
  sessionId: Scalars["ID"]["input"];
  sourceFieldId: Scalars["String"]["input"];
  path?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AttributeReviewMapRowValuesMutation = {
  __typename?: "Mutation";
  attributeReviewMapRowValues: number;
};

export type MarkTaxonomyApprovalPipelineJobFailedMutationVariables = Exact<{
  input: TaxonomyApprovalPipelineJobActionInput;
}>;

export type MarkTaxonomyApprovalPipelineJobFailedMutation = {
  __typename?: "Mutation";
  markTaxonomyApprovalPipelineJobFailed: {
    __typename?: "TaxonomyApprovalPipelineJobActionPayload";
    message: string;
    job: {
      __typename?: "TaxonomyApprovalPipelineJob";
      syncJobId: string;
      mappingSessionId: string;
      resourceLockKey: string;
      status: string;
      retryable: boolean;
      error?: string | null;
      errorType?: string | null;
      message?: string | null;
      attemptCount: number;
      pipelineId?: string | null;
      taxonomyJobId?: string | null;
      taxonomyStatus?: string | null;
      approvedBy?: string | null;
      notes?: string | null;
      fieldDecisionCount: number;
      canonicalValueDecisionCount: number;
      marketplaceSpecificValueDecisionCount: number;
      queuedAt: string;
      startedAt?: string | null;
      dispatchedAt?: string | null;
      completedAt?: string | null;
      failedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      lastLedgerEventType?: string | null;
      lastLedgerAt?: string | null;
      availableActions: Array<string>;
    };
  };
};

export type RefreshFlipkartVerticalsMutationVariables = Exact<{
  input: RefreshFlipkartVerticalsInput;
}>;

export type RefreshFlipkartVerticalsMutation = {
  __typename?: "Mutation";
  refreshFlipkartVerticals: {
    __typename?: "RefreshFlipkartVerticalsPayload";
    version: number;
    count: number;
  };
};

export type RefreshProductTypeMappingMutationVariables = Exact<{
  marketplace: Scalars["String"]["input"];
  productType: Scalars["String"]["input"];
}>;

export type RefreshProductTypeMappingMutation = {
  __typename?: "Mutation";
  refreshProductTypeMapping: {
    __typename?: "ProductTypeSyncSession";
    sessionId: string;
    marketplace: string;
    productType: string;
  };
};

export type ResendLoginCodeMutationVariables = Exact<{
  loginTicket: Scalars["String"]["input"];
}>;

export type ResendLoginCodeMutation = {
  __typename?: "Mutation";
  resendLoginCode: {
    __typename?: "ResendLoginCodePayload";
    retryAfterSec: number;
  };
};

export type ResumeTaxonomyApprovalPipelineQueueMutationVariables = Exact<{
  input: ResumeTaxonomyApprovalPipelineQueueInput;
}>;

export type ResumeTaxonomyApprovalPipelineQueueMutation = {
  __typename?: "Mutation";
  resumeTaxonomyApprovalPipelineQueue: {
    __typename?: "ResumeTaxonomyApprovalPipelineQueuePayload";
    message: string;
    resumedSyncJobId?: string | null;
    resourceLockKey: string;
    job?: {
      __typename?: "TaxonomyApprovalPipelineJob";
      syncJobId: string;
      mappingSessionId: string;
      resourceLockKey: string;
      status: string;
      retryable: boolean;
      error?: string | null;
      errorType?: string | null;
      message?: string | null;
      attemptCount: number;
      pipelineId?: string | null;
      taxonomyJobId?: string | null;
      taxonomyStatus?: string | null;
      approvedBy?: string | null;
      notes?: string | null;
      fieldDecisionCount: number;
      canonicalValueDecisionCount: number;
      marketplaceSpecificValueDecisionCount: number;
      queuedAt: string;
      startedAt?: string | null;
      dispatchedAt?: string | null;
      completedAt?: string | null;
      failedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      lastLedgerEventType?: string | null;
      lastLedgerAt?: string | null;
      availableActions: Array<string>;
    } | null;
  };
};

export type RetryTaxonomyApprovalPipelineJobMutationVariables = Exact<{
  input: TaxonomyApprovalPipelineJobActionInput;
}>;

export type RetryTaxonomyApprovalPipelineJobMutation = {
  __typename?: "Mutation";
  retryTaxonomyApprovalPipelineJob: {
    __typename?: "TaxonomyApprovalPipelineJobActionPayload";
    message: string;
    job: {
      __typename?: "TaxonomyApprovalPipelineJob";
      syncJobId: string;
      mappingSessionId: string;
      resourceLockKey: string;
      status: string;
      retryable: boolean;
      error?: string | null;
      errorType?: string | null;
      message?: string | null;
      attemptCount: number;
      pipelineId?: string | null;
      taxonomyJobId?: string | null;
      taxonomyStatus?: string | null;
      approvedBy?: string | null;
      notes?: string | null;
      fieldDecisionCount: number;
      canonicalValueDecisionCount: number;
      marketplaceSpecificValueDecisionCount: number;
      queuedAt: string;
      startedAt?: string | null;
      dispatchedAt?: string | null;
      completedAt?: string | null;
      failedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      lastLedgerEventType?: string | null;
      lastLedgerAt?: string | null;
      availableActions: Array<string>;
    };
  };
};

export type SetLeafFlagsMutationVariables = Exact<{
  path: Scalars["String"]["input"];
  alwaysRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  perStore?: InputMaybe<Scalars["Boolean"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  inputType?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SetLeafFlagsMutation = {
  __typename?: "Mutation";
  setLeafFlags: {
    __typename?: "Leaf";
    path: string;
    alwaysRequired: boolean;
    perStore: boolean;
    label?: string | null;
    inputType?: string | null;
    helpText?: string | null;
  };
};

export type SetPoolSellerTypingMutationVariables = Exact<{
  pool: Scalars["String"]["input"];
  allowed: Scalars["Boolean"]["input"];
}>;

export type SetPoolSellerTypingMutation = {
  __typename?: "Mutation";
  setPoolSellerTyping: boolean;
};

export type StartProductTypeSyncMutationVariables = Exact<{
  marketplace: Scalars["String"]["input"];
  productType: Scalars["String"]["input"];
  sessionId: Scalars["ID"]["input"];
}>;

export type StartProductTypeSyncMutation = {
  __typename?: "Mutation";
  startProductTypeSync: {
    __typename?: "ProductTypeSyncSession";
    sessionId: string;
    marketplace: string;
    productType: string;
  };
};

export type TaxonomySaveProductTypeMappingMutationVariables = Exact<{
  input: TaxonomySaveProductTypeMappingInput;
}>;

export type TaxonomySaveProductTypeMappingMutation = {
  __typename?: "Mutation";
  taxonomySaveProductTypeMapping: any;
};

export type UpdateMarketplaceFacilitatorMutationVariables = Exact<{
  input: UpdateMarketplaceFacilitatorInput;
}>;

export type UpdateMarketplaceFacilitatorMutation = {
  __typename?: "Mutation";
  updateMarketplaceFacilitator: {
    __typename?: "MarketplaceFacilitator";
    id: string;
  };
};

export type AttributeReviewUsePastAnswersMutationVariables = Exact<{
  sessionId: Scalars["ID"]["input"];
}>;

export type AttributeReviewUsePastAnswersMutation = {
  __typename?: "Mutation";
  attributeReviewUsePastAnswers: number;
};

export type VerifyLoginCodeMutationVariables = Exact<{
  loginTicket: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type VerifyLoginCodeMutation = {
  __typename?: "Mutation";
  verifyLoginCode: {
    __typename?: "IamLoginPayload";
    accessToken?: string | null;
    refreshToken?: string | null;
    user?: {
      __typename?: "IamUser";
      id: string;
      email: string;
      name?: string | null;
      status: string;
      role?: string | null;
      lastLoginAt?: any | null;
      createdAt: any;
    } | null;
  };
};

export type AdminSellerQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type AdminSellerQuery = {
  __typename?: "Query";
  adminSeller?: {
    __typename?: "SellerListItem";
    id: string;
    name: string;
    status: string;
    plan: string;
    marketplaces: Array<string>;
    createdAt: string;
  } | null;
};

export type AmazonAdminAuthSessionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AmazonAdminAuthSessionQuery = {
  __typename?: "Query";
  amazonAdminAuthSession: {
    __typename?: "AmazonAuthSessionPayload";
    url: string;
  };
};

export type AmazonProductTypeSchemaDigestQueryVariables = Exact<{
  input: AmazonProductTypeSchemaDigestInput;
}>;

export type AmazonProductTypeSchemaDigestQuery = {
  __typename?: "Query";
  amazonProductTypeSchemaDigest: {
    __typename?: "AmazonProductTypeSchemaDigestPayload";
    aiResponse: any;
    canonicalSchemaPayload: any;
  };
};

export type AmazonSearchProductTypesQueryVariables = Exact<{
  input: AmazonSearchProductTypesInput;
}>;

export type AmazonSearchProductTypesQuery = {
  __typename?: "Query";
  amazonSearchProductTypes: {
    __typename?: "AmazonSearchProductTypesPayload";
    productTypes: Array<{
      __typename?: "AmazonProductTypeSearchItem";
      name: string;
      displayName?: string | null;
      synced: boolean;
    }>;
  };
};

export type AmazonSystemCredentialQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AmazonSystemCredentialQuery = {
  __typename?: "Query";
  amazonSystemCredential: {
    __typename?: "AmazonSystemCredentialStatus";
    configured: boolean;
    authorizedAt?: any | null;
    authorizedBy?: string | null;
  };
};

export type AttributeReviewFieldMappingsQueryVariables = Exact<{
  sessionId: Scalars["ID"]["input"];
  includeFinished?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AttributeReviewFieldMappingsQuery = {
  __typename?: "Query";
  attributeReviewFieldMappings?: {
    __typename?: "AttributeReviewFieldMappingsPayload";
    mappingSessionId: string;
    marketplace: string;
    marketplaceId?: string | null;
    productType: string;
    schemaVersion: string;
    totalFields: number;
    mappedFields: number;
    needReviewFields: number;
    llmSkipped: boolean;
    llmSkipReason?: string | null;
    llmRequiredFieldsCount: number;
    llmMappedFieldsCount: number;
    kindOptions: Array<{
      __typename?: "AttributeReviewKindOption";
      kind: string;
      folder: string;
      productField: boolean;
    }>;
    finishedEdit?: {
      __typename?: "AttributeReviewFinishedEdit";
      allowed: boolean;
      reason?: string | null;
    } | null;
    items: Array<{
      __typename?: "AttributeReviewFieldMappingItem";
      sourceFieldId: string;
      sourceLabel?: string | null;
      marketplaceRawJson: any;
      canonicalPath?: string | null;
      aiBand?: string | null;
      registryStatus?: string | null;
      mappingSource?: string | null;
      provenance?: string | null;
      status: string;
      requirementLevel: string;
      lowConfidenceReason?: string | null;
      reviewReason?: string | null;
      reviewDetail?: string | null;
      answers?: any | null;
      llmReasoning?: string | null;
      arrayIndex?: number | null;
      canonicalDatatype?: string | null;
      sourceEnumValues: Array<string>;
      sourceEnumValueLabels: any;
      sourceEnumValueCount: number;
      enumMappings: any;
      enumMappingCount: number;
      valueApprovals: any;
      valueApprovalCount: number;
      proposedDomainKey?: string | null;
      proposedDomainRationale?: string | null;
      domainKey?: string | null;
      domainSource?: string | null;
      domainExists: boolean;
      unresolvedValueCount: number;
      valueResolutionStatus: any;
      valueResolutionSources: any;
      enumDetailsTruncated: boolean;
      pendingCanonicalExpansion: boolean;
      canonicalExpansionRequestId?: string | null;
      duplicateCanonicalPath: boolean;
      requiresReReview: boolean;
      needsReview: boolean;
      kind?: string | null;
      folder?: string | null;
      leaf?: string | null;
      leafSource?: string | null;
      pathPreview?: string | null;
      pool?: any | null;
      values?: any | null;
      warnings?: Array<string> | null;
      leafRejection?: any | null;
      remapped?: any | null;
      path?: string | null;
      pathType?: string | null;
      ownPath?: string | null;
      link: boolean;
      linkOwner?: string | null;
      linkField?: string | null;
      hidden: boolean;
      pastAnswer: boolean;
      copyOf?: string | null;
      showKind?: string | null;
      review?: string | null;
      suggested: Array<string>;
      gateVerdict?: {
        __typename?: "AttributeReviewGateVerdict";
        status: string;
        reason?: string | null;
        suggestedHome?: string | null;
      } | null;
      agent?: {
        __typename?: "AgentAnswers";
        agreed: boolean;
        answers: Array<{
          __typename?: "AgentAnswer";
          model: string;
          path?: string | null;
          copy?: string | null;
          kind?: string | null;
          twin?: string | null;
          confidence?: number | null;
        }>;
      } | null;
    }>;
  } | null;
};

export type AttributeReviewSessionsUnderReviewQueryVariables = Exact<{
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  productType?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AttributeReviewSessionsUnderReviewQuery = {
  __typename?: "Query";
  attributeReviewSessionsUnderReview: Array<{
    __typename?: "AttributeReviewSessionSummary";
    mappingSessionId: string;
    marketplace: string;
    productType: string;
    displayName: string;
    needReviewFields: number;
    status: string;
  }>;
};

export type AttributeReviewValueDomainSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AttributeReviewValueDomainSearchQuery = {
  __typename?: "Query";
  attributeReviewValueDomainSearch: {
    __typename?: "AttributeReviewValueDomainSearchPayload";
    items: Array<{
      __typename?: "AttributeReviewValueDomainSearchItem";
      domainKey: string;
    }>;
  };
};

export type CoupangCategoryRecommendQueryVariables = Exact<{
  input: CoupangCategoryRecommendInput;
}>;

export type CoupangCategoryRecommendQuery = {
  __typename?: "Query";
  coupangCategoryRecommend: {
    __typename?: "CoupangCategoryRecommendPayload";
    categories: Array<{
      __typename?: "CoupangCategoryRecommendItem";
      categoryId: string;
      categoryName: string;
      resultType: string;
    }>;
  };
};

export type CoupangCategorySchemaDigestQueryVariables = Exact<{
  input: CoupangCategorySchemaDigestInput;
}>;

export type CoupangCategorySchemaDigestQuery = {
  __typename?: "Query";
  coupangCategorySchemaDigest: {
    __typename?: "CoupangCategorySchemaDigestPayload";
    displayCategoryCode: string;
    canonicalSchemaPayload: any;
  };
};

export type EbayCategorySchemaDigestQueryVariables = Exact<{
  input: EbayCategorySchemaDigestInput;
}>;

export type EbayCategorySchemaDigestQuery = {
  __typename?: "Query";
  ebayCategorySchemaDigest: {
    __typename?: "EbayCategorySchemaDigestPayload";
    categoryTreeId: string;
    categoryId: string;
    categoryName?: string | null;
    canonicalSchemaPayload: any;
  };
};

export type EbayCategorySearchQueryVariables = Exact<{
  input: EbayCategorySearchInput;
}>;

export type EbayCategorySearchQuery = {
  __typename?: "Query";
  ebayCategorySearch: {
    __typename?: "EbayCategorySearchPayload";
    categoryTreeId?: string | null;
    categories: Array<{
      __typename?: "EbayCategoryMatch";
      categoryId: string;
      categoryName: string;
      fullPath: string;
    }>;
  };
};

export type FlipkartVerticalSchemaDigestQueryVariables = Exact<{
  input: FlipkartVerticalSchemaDigestInput;
}>;

export type FlipkartVerticalSchemaDigestQuery = {
  __typename?: "Query";
  flipkartVerticalSchemaDigest: {
    __typename?: "FlipkartVerticalSchemaDigestPayload";
    vertical: string;
    canonicalSchemaPayload: any;
    raw: any;
  };
};

export type FormVersionLagQueryVariables = Exact<{ [key: string]: never }>;

export type FormVersionLagQuery = {
  __typename?: "Query";
  formVersionLag: Array<{
    __typename?: "FormVersionLag";
    marketplace: string;
    productType: string;
    stamp: string;
    stamped: number;
    behind: number;
  }>;
};

export type LeafImpactQueryVariables = Exact<{
  path: Scalars["String"]["input"];
}>;

export type LeafImpactQuery = {
  __typename?: "Query";
  leafImpact: { __typename?: "LeafImpact"; products: number; sellers: number };
};

export type LeafUsersQueryVariables = Exact<{
  path: Scalars["String"]["input"];
}>;

export type LeafUsersQuery = {
  __typename?: "Query";
  leafUsers: Array<{
    __typename?: "FieldUserRow";
    marketplace: string;
    productType: string;
    productTypeName: string;
    label: string;
  }>;
};

export type LeavesQueryVariables = Exact<{
  query?: InputMaybe<Scalars["String"]["input"]>;
  folder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LeavesQuery = {
  __typename?: "Query";
  leaves: Array<{
    __typename?: "Leaf";
    path: string;
    folder: string;
    leaf: string;
    description?: string | null;
    status: string;
    perStore: boolean;
    alwaysRequired: boolean;
    usedBy: number;
    usedByStores: any;
    anchor?: string | null;
    label?: string | null;
    inputType?: string | null;
    helpText?: string | null;
  }>;
};

export type MarketplaceCategorySearchQueryVariables = Exact<{
  input: MarketplaceCategorySearchInput;
}>;

export type MarketplaceCategorySearchQuery = {
  __typename?: "Query";
  marketplaceCategorySearch: {
    __typename?: "MarketplaceCategorySearchPayload";
    categories: Array<{
      __typename?: "MarketplaceCategoryHit";
      categoryId: string;
      categoryName: string;
      fullPath: string;
    }>;
  };
};

export type MarketplaceFacilitatorStatusQueryVariables = Exact<{
  workspaceId: Scalars["ID"]["input"];
}>;

export type MarketplaceFacilitatorStatusQuery = {
  __typename?: "Query";
  marketplaceFacilitatorStatus: Array<{
    __typename?: "MarketplaceFacilitatorStatus";
    marketplaceCode: string;
    marketplaceName: string;
    markedId?: string | null;
    connected: boolean;
    linkedProducts: number;
    openOrders: number;
    sellers: number;
  }>;
};

export type MarketplaceMappingSessionApprovalSyncQueryVariables = Exact<{
  mappingSessionId: Scalars["ID"]["input"];
}>;

export type MarketplaceMappingSessionApprovalSyncQuery = {
  __typename?: "Query";
  marketplaceMappingSession?: {
    __typename?: "MarketplaceMappingSessionDetail";
    approvalSync: {
      __typename?: "MarketplaceMappingSessionApprovalSync";
      status?: string | null;
      error?: string | null;
      errorDetails?: any | null;
    };
  } | null;
};

export type MarketplaceMappingSessionsQueryVariables = Exact<{
  input?: InputMaybe<MarketplaceMappingSessionsInput>;
}>;

export type MarketplaceMappingSessionsQuery = {
  __typename?: "Query";
  marketplaceMappingSessions: {
    __typename?: "MarketplaceMappingSessionsPayload";
    marketplaces: Array<string>;
    items: Array<{
      __typename?: "MarketplaceMappingSession";
      id: string;
      marketplace: string;
      productType: string;
      displayName: string;
      canonicalCategory?: string | null;
      status: string;
      approvalSyncRetryable: boolean;
      mappedAt?: string | null;
      mappedBy?: string | null;
      confidence?: number | null;
      totalBlocked?: number | null;
      mappingSessionId?: string | null;
      createdAt: string;
      updatedAt: string;
    }>;
    counts: {
      __typename?: "MarketplaceMappingSessionCounts";
      total: number;
      mapped: number;
      pending: number;
      needsReview: number;
      failed: number;
    };
    pageInfo: {
      __typename?: "MarketplaceMappingSessionsPageInfo";
      page: number;
      pageSize: number;
      total: number;
      totalPages: number;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type MarketplacesQueryVariables = Exact<{ [key: string]: never }>;

export type MarketplacesQuery = {
  __typename?: "Query";
  marketplaces: Array<{
    __typename?: "Marketplace";
    id: string;
    code: string;
    name: string;
    status: string;
    syncStatus: string;
    lastSyncedAt?: any | null;
    websiteUrl?: string | null;
    syncConfig?: any | null;
  }>;
};

export type MeeshoProductTypeSchemaDigestQueryVariables = Exact<{
  input: MeeshoProductTypeSchemaDigestInput;
}>;

export type MeeshoProductTypeSchemaDigestQuery = {
  __typename?: "Query";
  meeshoProductTypeSchemaDigest: {
    __typename?: "MeeshoProductTypeSchemaDigestPayload";
    sscatId: string;
    productType: string;
    categoryPath?: string | null;
    canonicalSchemaPayload: any;
    aiResponse: any;
  };
};

export type MeeshoSearchProductTypesQueryVariables = Exact<{
  input: MeeshoSearchProductTypesInput;
}>;

export type MeeshoSearchProductTypesQuery = {
  __typename?: "Query";
  meeshoSearchProductTypes: {
    __typename?: "MeeshoSearchProductTypesPayload";
    productTypes: Array<{
      __typename?: "MeeshoProductTypeSearchItem";
      name: string;
      displayName?: string | null;
      synced: boolean;
    }>;
  };
};

export type PublishRejectionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type PublishRejectionsQuery = {
  __typename?: "Query";
  publishRejections: Array<{
    __typename?: "PublishRejection";
    id: string;
    marketplace: string;
    productType?: string | null;
    error: string;
    failedAt: string;
  }>;
};

export type ShopifyProductTypeSchemaDigestQueryVariables = Exact<{
  input: ShopifyProductTypeSchemaDigestInput;
}>;

export type ShopifyProductTypeSchemaDigestQuery = {
  __typename?: "Query";
  shopifyProductTypeSchemaDigest: {
    __typename?: "ShopifyProductTypeSchemaDigestPayload";
    aiResponse: any;
    canonicalSchemaPayload: any;
  };
};

export type ShopifySearchProductTypesQueryVariables = Exact<{
  input: ShopifySearchProductTypesInput;
}>;

export type ShopifySearchProductTypesQuery = {
  __typename?: "Query";
  shopifySearchProductTypes: {
    __typename?: "ShopifySearchProductTypesPayload";
    productTypes: Array<{
      __typename?: "ShopifyProductTypeSearchItem";
      name: string;
      synced: boolean;
    }>;
  };
};

export type SnapdealCategorySchemaDigestQueryVariables = Exact<{
  input: SnapdealCategorySchemaDigestInput;
}>;

export type SnapdealCategorySchemaDigestQuery = {
  __typename?: "Query";
  snapdealCategorySchemaDigest: {
    __typename?: "SnapdealCategorySchemaDigestPayload";
    categoryId: string;
    canonicalSchemaPayload: any;
    raw: any;
  };
};

export type SnapdealCategorySearchQueryVariables = Exact<{
  input: SnapdealCategorySearchInput;
}>;

export type SnapdealCategorySearchQuery = {
  __typename?: "Query";
  snapdealCategorySearch: {
    __typename?: "SnapdealCategorySearchPayload";
    categories: Array<{
      __typename?: "SnapdealCategory";
      categoryId: string;
      categoryName: string;
      fullPath: string;
      leaf: boolean;
    }>;
  };
};

export type TaxonomyApprovalPipelineJobQueryVariables = Exact<{
  syncJobId: Scalars["ID"]["input"];
}>;

export type TaxonomyApprovalPipelineJobQuery = {
  __typename?: "Query";
  taxonomyApprovalPipelineJob?: {
    __typename?: "TaxonomyApprovalPipelineJobDetail";
    job: {
      __typename?: "TaxonomyApprovalPipelineJob";
      syncJobId: string;
      mappingSessionId: string;
      resourceLockKey: string;
      status: string;
      retryable: boolean;
      error?: string | null;
      errorType?: string | null;
      message?: string | null;
      attemptCount: number;
      pipelineId?: string | null;
      taxonomyJobId?: string | null;
      taxonomyStatus?: string | null;
      approvedBy?: string | null;
      notes?: string | null;
      fieldDecisionCount: number;
      canonicalValueDecisionCount: number;
      marketplaceSpecificValueDecisionCount: number;
      queuedAt: string;
      startedAt?: string | null;
      dispatchedAt?: string | null;
      completedAt?: string | null;
      failedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      payload?: any | null;
      lastLedgerEventType?: string | null;
      lastLedgerAt?: string | null;
      availableActions: Array<string>;
    };
    ledger: Array<{
      __typename?: "TaxonomyApprovalPipelineLedgerEntry";
      id: string;
      syncJobId?: string | null;
      status: string;
      eventType?: string | null;
      error?: string | null;
      retryable?: boolean | null;
      payload?: any | null;
      createdAt: string;
    }>;
  } | null;
};

export type TaxonomyApprovalPipelineJobsQueryVariables = Exact<{
  input?: InputMaybe<TaxonomyApprovalPipelineJobsInput>;
}>;

export type TaxonomyApprovalPipelineJobsQuery = {
  __typename?: "Query";
  taxonomyApprovalPipelineJobs: {
    __typename?: "TaxonomyApprovalPipelineJobsPayload";
    items: Array<{
      __typename?: "TaxonomyApprovalPipelineJob";
      syncJobId: string;
      mappingSessionId: string;
      resourceLockKey: string;
      status: string;
      retryable: boolean;
      error?: string | null;
      errorType?: string | null;
      message?: string | null;
      attemptCount: number;
      pipelineId?: string | null;
      taxonomyJobId?: string | null;
      taxonomyStatus?: string | null;
      approvedBy?: string | null;
      notes?: string | null;
      fieldDecisionCount: number;
      canonicalValueDecisionCount: number;
      marketplaceSpecificValueDecisionCount: number;
      queuedAt: string;
      startedAt?: string | null;
      dispatchedAt?: string | null;
      completedAt?: string | null;
      failedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      lastLedgerEventType?: string | null;
      lastLedgerAt?: string | null;
      availableActions: Array<string>;
    }>;
  };
};

export type TaxonomyCategoriesSearchQueryVariables = Exact<{
  q: Scalars["String"]["input"];
}>;

export type TaxonomyCategoriesSearchQuery = {
  __typename?: "Query";
  taxonomyCategoriesSearch: Array<{
    __typename?: "TaxonomyCategorySearchItem";
    path: string;
    score?: number | null;
  }>;
};

export type TaxonomyCategoriesSuggestQueryVariables = Exact<{
  q: Scalars["String"]["input"];
  hints?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  productType?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TaxonomyCategoriesSuggestQuery = {
  __typename?: "Query";
  taxonomyCategoriesSuggest: Array<{
    __typename?: "TaxonomyCategorySuggestItem";
    categoryPath: string;
    score?: number | null;
    mappedTo?: {
      __typename?: "TaxonomyCategoryMappedTo";
      productType: string;
      marketplaceCategoryId?: string | null;
      status: string;
      lastSyncFailed: boolean;
    } | null;
  }>;
};

export type TaxonomyIngestionRunQueryVariables = Exact<{
  runId: Scalars["ID"]["input"];
}>;

export type TaxonomyIngestionRunQuery = {
  __typename?: "Query";
  taxonomyIngestionRun?: {
    __typename?: "TaxonomyIngestionRun";
    runId: string;
    marketplace: string;
    productType: string;
    displayName: string;
    workspaceId?: string | null;
    status: string;
    progressPercent?: number | null;
    stageKey?: string | null;
    stageLabel?: string | null;
    userMessage?: string | null;
    technicalMessage?: string | null;
    approxRemainingLabel?: string | null;
    mappingSessionId?: string | null;
    externalSessionId?: string | null;
    startedAt: string;
    updatedAt: string;
    completedAt?: string | null;
    terminal: boolean;
  } | null;
};

export type TaxonomyIngestionRunsQueryVariables = Exact<{
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  includeCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type TaxonomyIngestionRunsQuery = {
  __typename?: "Query";
  taxonomyIngestionRuns: Array<{
    __typename?: "TaxonomyIngestionRun";
    runId: string;
    marketplace: string;
    productType: string;
    displayName: string;
    workspaceId?: string | null;
    status: string;
    progressPercent?: number | null;
    stageKey?: string | null;
    stageLabel?: string | null;
    userMessage?: string | null;
    technicalMessage?: string | null;
    approxRemainingLabel?: string | null;
    mappingSessionId?: string | null;
    externalSessionId?: string | null;
    startedAt: string;
    updatedAt: string;
    completedAt?: string | null;
    terminal: boolean;
  }>;
};

export type TaxonomyResolutionTasksQueryVariables = Exact<{
  marketplace?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TaxonomyResolutionTasksQuery = {
  __typename?: "Query";
  taxonomyResolutionTasks: Array<{
    __typename?: "TaxonomyResolutionTask";
    id: string;
    marketplace: string;
    productType: string;
    status: string;
    totalBlocked: number;
    resolvedAt?: string | null;
  }>;
};

export type TaxonomySupportedCategoriesQueryVariables = Exact<{
  marketplace: Scalars["String"]["input"];
}>;

export type TaxonomySupportedCategoriesQuery = {
  __typename?: "Query";
  taxonomySupportedCategories: Array<{
    __typename?: "TaxonomySupportedCategory";
    marketplace: string;
    productType: string;
    canonicalCategoryId: string;
    canonicalCategoryName?: string | null;
    canonicalCategoryParent?: string | null;
    canonicalCategoryLevel?: number | null;
    mappedFields: number;
    status: string;
  }>;
};

export type TaxonomySupportedMarketplacesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TaxonomySupportedMarketplacesQuery = {
  __typename?: "Query";
  taxonomySupportedMarketplaces: Array<{
    __typename?: "TaxonomySupportedMarketplace";
    marketplace: string;
    categoryCount: number;
  }>;
};

export type ViewerBootstrapQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerBootstrapQuery = {
  __typename?: "Query";
  viewerBootstrap: {
    __typename?: "ViewerBootstrapPayload";
    workspace?: {
      __typename?: "WorkspaceBootstrap";
      id: string;
      name: string;
      marketplaceConnections: Array<{
        __typename?: "WorkspaceMarketplaceConnectionSnapshot";
        id: string;
        provider: MarketplaceProvider;
        status: MarketplaceConnectionStatus;
        externalSellerId: string;
      }>;
    } | null;
  };
};

export type TaxonomyApprovalPipelineSubscriptionVariables = Exact<{
  syncJobId: Scalars["ID"]["input"];
}>;

export type TaxonomyApprovalPipelineSubscription = {
  __typename?: "Subscription";
  taxonomyApprovalPipeline: {
    __typename?: "TaxonomyApprovalPipelineUpdate";
    eventId: string;
    eventType: string;
    syncJobId: string;
    taxonomyJobId?: string | null;
    pipelineId?: string | null;
    mappingSessionId: string;
    resourceLockKey: string;
    status: string;
    taxonomyStatus?: string | null;
    retryable?: boolean | null;
    message?: string | null;
    errorType?: string | null;
    error?: string | null;
    errorDetails?: any | null;
    affected?: any | null;
    fieldResults?: any | null;
    valueResults?: any | null;
    payload?: any | null;
    terminal: boolean;
    occurredAt: string;
  };
};

export type TaxonomyIngestionSessionSubscriptionVariables = Exact<{
  runId: Scalars["ID"]["input"];
}>;

export type TaxonomyIngestionSessionSubscription = {
  __typename?: "Subscription";
  taxonomyIngestionSession: {
    __typename?: "TaxonomyIngestionEvent";
    eventId: string;
    eventType: string;
    runId: string;
    marketplace: string;
    productType: string;
    workspaceId?: string | null;
    status: string;
    progressPercent?: number | null;
    stageKey?: string | null;
    stageLabel?: string | null;
    userMessage?: string | null;
    technicalMessage?: string | null;
    approxRemainingLabel?: string | null;
    mappingSessionId?: string | null;
    externalSessionId?: string | null;
    payload: any;
    occurredAt: string;
    elapsedMs: number;
    terminal: boolean;
  };
};

export type TaxonomyMappingSessionSubscriptionVariables = Exact<{
  sessionId: Scalars["ID"]["input"];
}>;

export type TaxonomyMappingSessionSubscription = {
  __typename?: "Subscription";
  taxonomyMappingSession: {
    __typename?: "TaxonomyMappingSessionUpdate";
    sessionId: string;
    status?: string | null;
    progress?: number | null;
    payload: any;
  };
};

export const AdminLoginDocument = `
    mutation AdminLogin($email: String!, $password: String!) {
  adminLogin(input: {email: $email, password: $password}) {
    accessToken
    refreshToken
    loginTicket
    maskedEmail
    user {
      id
      email
      name
      status
      role
      lastLoginAt
      createdAt
    }
  }
}
    `;

export const useAdminLoginMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AdminLoginMutation,
    TError,
    AdminLoginMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AdminLoginMutation,
    TError,
    AdminLoginMutationVariables,
    TContext
  >({
    mutationKey: ["AdminLogin"],
    mutationFn: (variables?: AdminLoginMutationVariables) =>
      fetcher<AdminLoginMutation, AdminLoginMutationVariables>(
        AdminLoginDocument,
        variables,
      )(),
    ...options,
  });
};

useAdminLoginMutation.getKey = () => ["AdminLogin"];

export const AttributeReviewApproveSelectedDocument = `
    mutation AttributeReviewApproveSelected($input: AttributeReviewApproveSelectedInput!) {
  attributeReviewApproveSelected(input: $input) {
    mappingSessionId
    syncJobId
    pipelineId
    status
    queued
    retryable
    approvedFieldCount
    skippedFieldCount
    failedFieldCount
    approvedValueCount
    marketplaceSpecificValueCount
    skippedValueCount
    failedValueCount
    fieldResults {
      inputIndex
      sourceFieldId
      status
      code
      message
    }
    valueResults {
      inputIndex
      sourceFieldId
      valueApprovalId
      canonicalPath
      marketplaceValue
      decision
      status
      code
      message
      marketplaceSpecificKey
    }
  }
}
    `;

export const useAttributeReviewApproveSelectedMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AttributeReviewApproveSelectedMutation,
    TError,
    AttributeReviewApproveSelectedMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AttributeReviewApproveSelectedMutation,
    TError,
    AttributeReviewApproveSelectedMutationVariables,
    TContext
  >({
    mutationKey: ["AttributeReviewApproveSelected"],
    mutationFn: (variables?: AttributeReviewApproveSelectedMutationVariables) =>
      fetcher<
        AttributeReviewApproveSelectedMutation,
        AttributeReviewApproveSelectedMutationVariables
      >(AttributeReviewApproveSelectedDocument, variables)(),
    ...options,
  });
};

useAttributeReviewApproveSelectedMutation.getKey = () => [
  "AttributeReviewApproveSelected",
];

export const AttributeReviewApproveSessionDocument = `
    mutation AttributeReviewApproveSession($input: AttributeReviewApproveInput!) {
  attributeReviewApproveSession(input: $input) {
    mappingSessionId
    decision
    syncJobId
  }
}
    `;

export const useAttributeReviewApproveSessionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AttributeReviewApproveSessionMutation,
    TError,
    AttributeReviewApproveSessionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AttributeReviewApproveSessionMutation,
    TError,
    AttributeReviewApproveSessionMutationVariables,
    TContext
  >({
    mutationKey: ["AttributeReviewApproveSession"],
    mutationFn: (variables?: AttributeReviewApproveSessionMutationVariables) =>
      fetcher<
        AttributeReviewApproveSessionMutation,
        AttributeReviewApproveSessionMutationVariables
      >(AttributeReviewApproveSessionDocument, variables)(),
    ...options,
  });
};

useAttributeReviewApproveSessionMutation.getKey = () => [
  "AttributeReviewApproveSession",
];

export const CancelTaxonomyApprovalPipelineJobDocument = `
    mutation CancelTaxonomyApprovalPipelineJob($input: TaxonomyApprovalPipelineJobActionInput!) {
  cancelTaxonomyApprovalPipelineJob(input: $input) {
    message
    job {
      syncJobId
      mappingSessionId
      resourceLockKey
      status
      retryable
      error
      errorType
      message
      attemptCount
      pipelineId
      taxonomyJobId
      taxonomyStatus
      approvedBy
      notes
      fieldDecisionCount
      canonicalValueDecisionCount
      marketplaceSpecificValueDecisionCount
      queuedAt
      startedAt
      dispatchedAt
      completedAt
      failedAt
      createdAt
      updatedAt
      lastLedgerEventType
      lastLedgerAt
      availableActions
    }
  }
}
    `;

export const useCancelTaxonomyApprovalPipelineJobMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CancelTaxonomyApprovalPipelineJobMutation,
    TError,
    CancelTaxonomyApprovalPipelineJobMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CancelTaxonomyApprovalPipelineJobMutation,
    TError,
    CancelTaxonomyApprovalPipelineJobMutationVariables,
    TContext
  >({
    mutationKey: ["CancelTaxonomyApprovalPipelineJob"],
    mutationFn: (
      variables?: CancelTaxonomyApprovalPipelineJobMutationVariables,
    ) =>
      fetcher<
        CancelTaxonomyApprovalPipelineJobMutation,
        CancelTaxonomyApprovalPipelineJobMutationVariables
      >(CancelTaxonomyApprovalPipelineJobDocument, variables)(),
    ...options,
  });
};

useCancelTaxonomyApprovalPipelineJobMutation.getKey = () => [
  "CancelTaxonomyApprovalPipelineJob",
];

export const CreateMarketplaceFacilitatorDocument = `
    mutation CreateMarketplaceFacilitator($input: CreateMarketplaceFacilitatorInput!) {
  createMarketplaceFacilitator(input: $input) {
    id
  }
}
    `;

export const useCreateMarketplaceFacilitatorMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateMarketplaceFacilitatorMutation,
    TError,
    CreateMarketplaceFacilitatorMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateMarketplaceFacilitatorMutation,
    TError,
    CreateMarketplaceFacilitatorMutationVariables,
    TContext
  >({
    mutationKey: ["CreateMarketplaceFacilitator"],
    mutationFn: (variables?: CreateMarketplaceFacilitatorMutationVariables) =>
      fetcher<
        CreateMarketplaceFacilitatorMutation,
        CreateMarketplaceFacilitatorMutationVariables
      >(CreateMarketplaceFacilitatorDocument, variables)(),
    ...options,
  });
};

useCreateMarketplaceFacilitatorMutation.getKey = () => [
  "CreateMarketplaceFacilitator",
];

export const DeleteMappingSessionDocument = `
    mutation DeleteMappingSession($input: DeleteMappingSessionInput!) {
  deleteMappingSession(input: $input) {
    sessionId
    deleted
  }
}
    `;

export const useDeleteMappingSessionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteMappingSessionMutation,
    TError,
    DeleteMappingSessionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteMappingSessionMutation,
    TError,
    DeleteMappingSessionMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteMappingSession"],
    mutationFn: (variables?: DeleteMappingSessionMutationVariables) =>
      fetcher<
        DeleteMappingSessionMutation,
        DeleteMappingSessionMutationVariables
      >(DeleteMappingSessionDocument, variables)(),
    ...options,
  });
};

useDeleteMappingSessionMutation.getKey = () => ["DeleteMappingSession"];

export const IamLogoutDocument = `
    mutation IamLogout {
  iamLogout {
    message
  }
}
    `;

export const useIamLogoutMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    IamLogoutMutation,
    TError,
    IamLogoutMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    IamLogoutMutation,
    TError,
    IamLogoutMutationVariables,
    TContext
  >({
    mutationKey: ["IamLogout"],
    mutationFn: (variables?: IamLogoutMutationVariables) =>
      fetcher<IamLogoutMutation, IamLogoutMutationVariables>(
        IamLogoutDocument,
        variables,
      )(),
    ...options,
  });
};

useIamLogoutMutation.getKey = () => ["IamLogout"];

export const IamRefreshTokenDocument = `
    mutation IamRefreshToken($refreshToken: String!) {
  iamRefreshToken(input: {refreshToken: $refreshToken}) {
    accessToken
  }
}
    `;

export const useIamRefreshTokenMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    IamRefreshTokenMutation,
    TError,
    IamRefreshTokenMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    IamRefreshTokenMutation,
    TError,
    IamRefreshTokenMutationVariables,
    TContext
  >({
    mutationKey: ["IamRefreshToken"],
    mutationFn: (variables?: IamRefreshTokenMutationVariables) =>
      fetcher<IamRefreshTokenMutation, IamRefreshTokenMutationVariables>(
        IamRefreshTokenDocument,
        variables,
      )(),
    ...options,
  });
};

useIamRefreshTokenMutation.getKey = () => ["IamRefreshToken"];

export const AttributeReviewMapRowValuesDocument = `
    mutation AttributeReviewMapRowValues($sessionId: ID!, $sourceFieldId: String!, $path: String) {
  attributeReviewMapRowValues(
    sessionId: $sessionId
    sourceFieldId: $sourceFieldId
    path: $path
  )
}
    `;

export const useAttributeReviewMapRowValuesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AttributeReviewMapRowValuesMutation,
    TError,
    AttributeReviewMapRowValuesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AttributeReviewMapRowValuesMutation,
    TError,
    AttributeReviewMapRowValuesMutationVariables,
    TContext
  >({
    mutationKey: ["AttributeReviewMapRowValues"],
    mutationFn: (variables?: AttributeReviewMapRowValuesMutationVariables) =>
      fetcher<
        AttributeReviewMapRowValuesMutation,
        AttributeReviewMapRowValuesMutationVariables
      >(AttributeReviewMapRowValuesDocument, variables)(),
    ...options,
  });
};

useAttributeReviewMapRowValuesMutation.getKey = () => [
  "AttributeReviewMapRowValues",
];

export const MarkTaxonomyApprovalPipelineJobFailedDocument = `
    mutation MarkTaxonomyApprovalPipelineJobFailed($input: TaxonomyApprovalPipelineJobActionInput!) {
  markTaxonomyApprovalPipelineJobFailed(input: $input) {
    message
    job {
      syncJobId
      mappingSessionId
      resourceLockKey
      status
      retryable
      error
      errorType
      message
      attemptCount
      pipelineId
      taxonomyJobId
      taxonomyStatus
      approvedBy
      notes
      fieldDecisionCount
      canonicalValueDecisionCount
      marketplaceSpecificValueDecisionCount
      queuedAt
      startedAt
      dispatchedAt
      completedAt
      failedAt
      createdAt
      updatedAt
      lastLedgerEventType
      lastLedgerAt
      availableActions
    }
  }
}
    `;

export const useMarkTaxonomyApprovalPipelineJobFailedMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    MarkTaxonomyApprovalPipelineJobFailedMutation,
    TError,
    MarkTaxonomyApprovalPipelineJobFailedMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    MarkTaxonomyApprovalPipelineJobFailedMutation,
    TError,
    MarkTaxonomyApprovalPipelineJobFailedMutationVariables,
    TContext
  >({
    mutationKey: ["MarkTaxonomyApprovalPipelineJobFailed"],
    mutationFn: (
      variables?: MarkTaxonomyApprovalPipelineJobFailedMutationVariables,
    ) =>
      fetcher<
        MarkTaxonomyApprovalPipelineJobFailedMutation,
        MarkTaxonomyApprovalPipelineJobFailedMutationVariables
      >(MarkTaxonomyApprovalPipelineJobFailedDocument, variables)(),
    ...options,
  });
};

useMarkTaxonomyApprovalPipelineJobFailedMutation.getKey = () => [
  "MarkTaxonomyApprovalPipelineJobFailed",
];

export const RefreshFlipkartVerticalsDocument = `
    mutation RefreshFlipkartVerticals($input: RefreshFlipkartVerticalsInput!) {
  refreshFlipkartVerticals(input: $input) {
    version
    count
  }
}
    `;

export const useRefreshFlipkartVerticalsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RefreshFlipkartVerticalsMutation,
    TError,
    RefreshFlipkartVerticalsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RefreshFlipkartVerticalsMutation,
    TError,
    RefreshFlipkartVerticalsMutationVariables,
    TContext
  >({
    mutationKey: ["RefreshFlipkartVerticals"],
    mutationFn: (variables?: RefreshFlipkartVerticalsMutationVariables) =>
      fetcher<
        RefreshFlipkartVerticalsMutation,
        RefreshFlipkartVerticalsMutationVariables
      >(RefreshFlipkartVerticalsDocument, variables)(),
    ...options,
  });
};

useRefreshFlipkartVerticalsMutation.getKey = () => ["RefreshFlipkartVerticals"];

export const RefreshProductTypeMappingDocument = `
    mutation RefreshProductTypeMapping($marketplace: String!, $productType: String!) {
  refreshProductTypeMapping(marketplace: $marketplace, productType: $productType) {
    sessionId
    marketplace
    productType
  }
}
    `;

export const useRefreshProductTypeMappingMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RefreshProductTypeMappingMutation,
    TError,
    RefreshProductTypeMappingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RefreshProductTypeMappingMutation,
    TError,
    RefreshProductTypeMappingMutationVariables,
    TContext
  >({
    mutationKey: ["RefreshProductTypeMapping"],
    mutationFn: (variables?: RefreshProductTypeMappingMutationVariables) =>
      fetcher<
        RefreshProductTypeMappingMutation,
        RefreshProductTypeMappingMutationVariables
      >(RefreshProductTypeMappingDocument, variables)(),
    ...options,
  });
};

useRefreshProductTypeMappingMutation.getKey = () => [
  "RefreshProductTypeMapping",
];

export const ResendLoginCodeDocument = `
    mutation ResendLoginCode($loginTicket: String!) {
  resendLoginCode(loginTicket: $loginTicket) {
    retryAfterSec
  }
}
    `;

export const useResendLoginCodeMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ResendLoginCodeMutation,
    TError,
    ResendLoginCodeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ResendLoginCodeMutation,
    TError,
    ResendLoginCodeMutationVariables,
    TContext
  >({
    mutationKey: ["ResendLoginCode"],
    mutationFn: (variables?: ResendLoginCodeMutationVariables) =>
      fetcher<ResendLoginCodeMutation, ResendLoginCodeMutationVariables>(
        ResendLoginCodeDocument,
        variables,
      )(),
    ...options,
  });
};

useResendLoginCodeMutation.getKey = () => ["ResendLoginCode"];

export const ResumeTaxonomyApprovalPipelineQueueDocument = `
    mutation ResumeTaxonomyApprovalPipelineQueue($input: ResumeTaxonomyApprovalPipelineQueueInput!) {
  resumeTaxonomyApprovalPipelineQueue(input: $input) {
    message
    resumedSyncJobId
    resourceLockKey
    job {
      syncJobId
      mappingSessionId
      resourceLockKey
      status
      retryable
      error
      errorType
      message
      attemptCount
      pipelineId
      taxonomyJobId
      taxonomyStatus
      approvedBy
      notes
      fieldDecisionCount
      canonicalValueDecisionCount
      marketplaceSpecificValueDecisionCount
      queuedAt
      startedAt
      dispatchedAt
      completedAt
      failedAt
      createdAt
      updatedAt
      lastLedgerEventType
      lastLedgerAt
      availableActions
    }
  }
}
    `;

export const useResumeTaxonomyApprovalPipelineQueueMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ResumeTaxonomyApprovalPipelineQueueMutation,
    TError,
    ResumeTaxonomyApprovalPipelineQueueMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ResumeTaxonomyApprovalPipelineQueueMutation,
    TError,
    ResumeTaxonomyApprovalPipelineQueueMutationVariables,
    TContext
  >({
    mutationKey: ["ResumeTaxonomyApprovalPipelineQueue"],
    mutationFn: (
      variables?: ResumeTaxonomyApprovalPipelineQueueMutationVariables,
    ) =>
      fetcher<
        ResumeTaxonomyApprovalPipelineQueueMutation,
        ResumeTaxonomyApprovalPipelineQueueMutationVariables
      >(ResumeTaxonomyApprovalPipelineQueueDocument, variables)(),
    ...options,
  });
};

useResumeTaxonomyApprovalPipelineQueueMutation.getKey = () => [
  "ResumeTaxonomyApprovalPipelineQueue",
];

export const RetryTaxonomyApprovalPipelineJobDocument = `
    mutation RetryTaxonomyApprovalPipelineJob($input: TaxonomyApprovalPipelineJobActionInput!) {
  retryTaxonomyApprovalPipelineJob(input: $input) {
    message
    job {
      syncJobId
      mappingSessionId
      resourceLockKey
      status
      retryable
      error
      errorType
      message
      attemptCount
      pipelineId
      taxonomyJobId
      taxonomyStatus
      approvedBy
      notes
      fieldDecisionCount
      canonicalValueDecisionCount
      marketplaceSpecificValueDecisionCount
      queuedAt
      startedAt
      dispatchedAt
      completedAt
      failedAt
      createdAt
      updatedAt
      lastLedgerEventType
      lastLedgerAt
      availableActions
    }
  }
}
    `;

export const useRetryTaxonomyApprovalPipelineJobMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RetryTaxonomyApprovalPipelineJobMutation,
    TError,
    RetryTaxonomyApprovalPipelineJobMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RetryTaxonomyApprovalPipelineJobMutation,
    TError,
    RetryTaxonomyApprovalPipelineJobMutationVariables,
    TContext
  >({
    mutationKey: ["RetryTaxonomyApprovalPipelineJob"],
    mutationFn: (
      variables?: RetryTaxonomyApprovalPipelineJobMutationVariables,
    ) =>
      fetcher<
        RetryTaxonomyApprovalPipelineJobMutation,
        RetryTaxonomyApprovalPipelineJobMutationVariables
      >(RetryTaxonomyApprovalPipelineJobDocument, variables)(),
    ...options,
  });
};

useRetryTaxonomyApprovalPipelineJobMutation.getKey = () => [
  "RetryTaxonomyApprovalPipelineJob",
];

export const SetLeafFlagsDocument = `
    mutation SetLeafFlags($path: String!, $alwaysRequired: Boolean, $perStore: Boolean, $label: String, $inputType: String, $helpText: String) {
  setLeafFlags(
    path: $path
    alwaysRequired: $alwaysRequired
    perStore: $perStore
    label: $label
    inputType: $inputType
    helpText: $helpText
  ) {
    path
    alwaysRequired
    perStore
    label
    inputType
    helpText
  }
}
    `;

export const useSetLeafFlagsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetLeafFlagsMutation,
    TError,
    SetLeafFlagsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetLeafFlagsMutation,
    TError,
    SetLeafFlagsMutationVariables,
    TContext
  >({
    mutationKey: ["SetLeafFlags"],
    mutationFn: (variables?: SetLeafFlagsMutationVariables) =>
      fetcher<SetLeafFlagsMutation, SetLeafFlagsMutationVariables>(
        SetLeafFlagsDocument,
        variables,
      )(),
    ...options,
  });
};

useSetLeafFlagsMutation.getKey = () => ["SetLeafFlags"];

export const SetPoolSellerTypingDocument = `
    mutation SetPoolSellerTyping($pool: String!, $allowed: Boolean!) {
  setPoolSellerTyping(pool: $pool, allowed: $allowed)
}
    `;

export const useSetPoolSellerTypingMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetPoolSellerTypingMutation,
    TError,
    SetPoolSellerTypingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetPoolSellerTypingMutation,
    TError,
    SetPoolSellerTypingMutationVariables,
    TContext
  >({
    mutationKey: ["SetPoolSellerTyping"],
    mutationFn: (variables?: SetPoolSellerTypingMutationVariables) =>
      fetcher<
        SetPoolSellerTypingMutation,
        SetPoolSellerTypingMutationVariables
      >(SetPoolSellerTypingDocument, variables)(),
    ...options,
  });
};

useSetPoolSellerTypingMutation.getKey = () => ["SetPoolSellerTyping"];

export const StartProductTypeSyncDocument = `
    mutation StartProductTypeSync($marketplace: String!, $productType: String!, $sessionId: ID!) {
  startProductTypeSync(
    marketplace: $marketplace
    productType: $productType
    sessionId: $sessionId
  ) {
    sessionId
    marketplace
    productType
  }
}
    `;

export const useStartProductTypeSyncMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    StartProductTypeSyncMutation,
    TError,
    StartProductTypeSyncMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    StartProductTypeSyncMutation,
    TError,
    StartProductTypeSyncMutationVariables,
    TContext
  >({
    mutationKey: ["StartProductTypeSync"],
    mutationFn: (variables?: StartProductTypeSyncMutationVariables) =>
      fetcher<
        StartProductTypeSyncMutation,
        StartProductTypeSyncMutationVariables
      >(StartProductTypeSyncDocument, variables)(),
    ...options,
  });
};

useStartProductTypeSyncMutation.getKey = () => ["StartProductTypeSync"];

export const TaxonomySaveProductTypeMappingDocument = `
    mutation TaxonomySaveProductTypeMapping($input: TaxonomySaveProductTypeMappingInput!) {
  taxonomySaveProductTypeMapping(input: $input)
}
    `;

export const useTaxonomySaveProductTypeMappingMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    TaxonomySaveProductTypeMappingMutation,
    TError,
    TaxonomySaveProductTypeMappingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TaxonomySaveProductTypeMappingMutation,
    TError,
    TaxonomySaveProductTypeMappingMutationVariables,
    TContext
  >({
    mutationKey: ["TaxonomySaveProductTypeMapping"],
    mutationFn: (variables?: TaxonomySaveProductTypeMappingMutationVariables) =>
      fetcher<
        TaxonomySaveProductTypeMappingMutation,
        TaxonomySaveProductTypeMappingMutationVariables
      >(TaxonomySaveProductTypeMappingDocument, variables)(),
    ...options,
  });
};

useTaxonomySaveProductTypeMappingMutation.getKey = () => [
  "TaxonomySaveProductTypeMapping",
];

export const UpdateMarketplaceFacilitatorDocument = `
    mutation UpdateMarketplaceFacilitator($input: UpdateMarketplaceFacilitatorInput!) {
  updateMarketplaceFacilitator(input: $input) {
    id
  }
}
    `;

export const useUpdateMarketplaceFacilitatorMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateMarketplaceFacilitatorMutation,
    TError,
    UpdateMarketplaceFacilitatorMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateMarketplaceFacilitatorMutation,
    TError,
    UpdateMarketplaceFacilitatorMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateMarketplaceFacilitator"],
    mutationFn: (variables?: UpdateMarketplaceFacilitatorMutationVariables) =>
      fetcher<
        UpdateMarketplaceFacilitatorMutation,
        UpdateMarketplaceFacilitatorMutationVariables
      >(UpdateMarketplaceFacilitatorDocument, variables)(),
    ...options,
  });
};

useUpdateMarketplaceFacilitatorMutation.getKey = () => [
  "UpdateMarketplaceFacilitator",
];

export const AttributeReviewUsePastAnswersDocument = `
    mutation AttributeReviewUsePastAnswers($sessionId: ID!) {
  attributeReviewUsePastAnswers(sessionId: $sessionId)
}
    `;

export const useAttributeReviewUsePastAnswersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AttributeReviewUsePastAnswersMutation,
    TError,
    AttributeReviewUsePastAnswersMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AttributeReviewUsePastAnswersMutation,
    TError,
    AttributeReviewUsePastAnswersMutationVariables,
    TContext
  >({
    mutationKey: ["AttributeReviewUsePastAnswers"],
    mutationFn: (variables?: AttributeReviewUsePastAnswersMutationVariables) =>
      fetcher<
        AttributeReviewUsePastAnswersMutation,
        AttributeReviewUsePastAnswersMutationVariables
      >(AttributeReviewUsePastAnswersDocument, variables)(),
    ...options,
  });
};

useAttributeReviewUsePastAnswersMutation.getKey = () => [
  "AttributeReviewUsePastAnswers",
];

export const VerifyLoginCodeDocument = `
    mutation VerifyLoginCode($loginTicket: String!, $code: String!) {
  verifyLoginCode(
    input: {loginTicket: $loginTicket, code: $code, rememberDevice: false}
  ) {
    accessToken
    refreshToken
    user {
      id
      email
      name
      status
      role
      lastLoginAt
      createdAt
    }
  }
}
    `;

export const useVerifyLoginCodeMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    VerifyLoginCodeMutation,
    TError,
    VerifyLoginCodeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VerifyLoginCodeMutation,
    TError,
    VerifyLoginCodeMutationVariables,
    TContext
  >({
    mutationKey: ["VerifyLoginCode"],
    mutationFn: (variables?: VerifyLoginCodeMutationVariables) =>
      fetcher<VerifyLoginCodeMutation, VerifyLoginCodeMutationVariables>(
        VerifyLoginCodeDocument,
        variables,
      )(),
    ...options,
  });
};

useVerifyLoginCodeMutation.getKey = () => ["VerifyLoginCode"];

export const AdminSellerDocument = `
    query AdminSeller($id: String!) {
  adminSeller(id: $id) {
    id
    name
    status
    plan
    marketplaces
    createdAt
  }
}
    `;

export const useAdminSellerQuery = <TData = AdminSellerQuery, TError = unknown>(
  variables: AdminSellerQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminSellerQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminSellerQuery, TError, TData>["queryKey"];
  },
) => {
  return useQuery<AdminSellerQuery, TError, TData>({
    queryKey: ["AdminSeller", variables],
    queryFn: fetcher<AdminSellerQuery, AdminSellerQueryVariables>(
      AdminSellerDocument,
      variables,
    ),
    ...options,
  });
};

useAdminSellerQuery.getKey = (variables: AdminSellerQueryVariables) => [
  "AdminSeller",
  variables,
];

export const AmazonAdminAuthSessionDocument = `
    query AmazonAdminAuthSession {
  amazonAdminAuthSession {
    url
  }
}
    `;

export const useAmazonAdminAuthSessionQuery = <
  TData = AmazonAdminAuthSessionQuery,
  TError = unknown,
>(
  variables?: AmazonAdminAuthSessionQueryVariables,
  options?: Omit<
    UseQueryOptions<AmazonAdminAuthSessionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AmazonAdminAuthSessionQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<AmazonAdminAuthSessionQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AmazonAdminAuthSession"]
        : ["AmazonAdminAuthSession", variables],
    queryFn: fetcher<
      AmazonAdminAuthSessionQuery,
      AmazonAdminAuthSessionQueryVariables
    >(AmazonAdminAuthSessionDocument, variables),
    ...options,
  });
};

useAmazonAdminAuthSessionQuery.getKey = (
  variables?: AmazonAdminAuthSessionQueryVariables,
) =>
  variables === undefined
    ? ["AmazonAdminAuthSession"]
    : ["AmazonAdminAuthSession", variables];

export const AmazonProductTypeSchemaDigestDocument = `
    query AmazonProductTypeSchemaDigest($input: AmazonProductTypeSchemaDigestInput!) {
  amazonProductTypeSchemaDigest(input: $input) {
    aiResponse
    canonicalSchemaPayload
  }
}
    `;

export const useAmazonProductTypeSchemaDigestQuery = <
  TData = AmazonProductTypeSchemaDigestQuery,
  TError = unknown,
>(
  variables: AmazonProductTypeSchemaDigestQueryVariables,
  options?: Omit<
    UseQueryOptions<AmazonProductTypeSchemaDigestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AmazonProductTypeSchemaDigestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<AmazonProductTypeSchemaDigestQuery, TError, TData>({
    queryKey: ["AmazonProductTypeSchemaDigest", variables],
    queryFn: fetcher<
      AmazonProductTypeSchemaDigestQuery,
      AmazonProductTypeSchemaDigestQueryVariables
    >(AmazonProductTypeSchemaDigestDocument, variables),
    ...options,
  });
};

useAmazonProductTypeSchemaDigestQuery.getKey = (
  variables: AmazonProductTypeSchemaDigestQueryVariables,
) => ["AmazonProductTypeSchemaDigest", variables];

export const AmazonSearchProductTypesDocument = `
    query AmazonSearchProductTypes($input: AmazonSearchProductTypesInput!) {
  amazonSearchProductTypes(input: $input) {
    productTypes {
      name
      displayName
      synced
    }
  }
}
    `;

export const useAmazonSearchProductTypesQuery = <
  TData = AmazonSearchProductTypesQuery,
  TError = unknown,
>(
  variables: AmazonSearchProductTypesQueryVariables,
  options?: Omit<
    UseQueryOptions<AmazonSearchProductTypesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AmazonSearchProductTypesQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<AmazonSearchProductTypesQuery, TError, TData>({
    queryKey: ["AmazonSearchProductTypes", variables],
    queryFn: fetcher<
      AmazonSearchProductTypesQuery,
      AmazonSearchProductTypesQueryVariables
    >(AmazonSearchProductTypesDocument, variables),
    ...options,
  });
};

useAmazonSearchProductTypesQuery.getKey = (
  variables: AmazonSearchProductTypesQueryVariables,
) => ["AmazonSearchProductTypes", variables];

export const AmazonSystemCredentialDocument = `
    query AmazonSystemCredential {
  amazonSystemCredential {
    configured
    authorizedAt
    authorizedBy
  }
}
    `;

export const useAmazonSystemCredentialQuery = <
  TData = AmazonSystemCredentialQuery,
  TError = unknown,
>(
  variables?: AmazonSystemCredentialQueryVariables,
  options?: Omit<
    UseQueryOptions<AmazonSystemCredentialQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AmazonSystemCredentialQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<AmazonSystemCredentialQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AmazonSystemCredential"]
        : ["AmazonSystemCredential", variables],
    queryFn: fetcher<
      AmazonSystemCredentialQuery,
      AmazonSystemCredentialQueryVariables
    >(AmazonSystemCredentialDocument, variables),
    ...options,
  });
};

useAmazonSystemCredentialQuery.getKey = (
  variables?: AmazonSystemCredentialQueryVariables,
) =>
  variables === undefined
    ? ["AmazonSystemCredential"]
    : ["AmazonSystemCredential", variables];

export const AttributeReviewFieldMappingsDocument = `
    query AttributeReviewFieldMappings($sessionId: ID!, $includeFinished: Boolean) {
  attributeReviewFieldMappings(
    sessionId: $sessionId
    includeEnumDetails: false
    includeFinished: $includeFinished
  ) {
    mappingSessionId
    marketplace
    marketplaceId
    productType
    schemaVersion
    totalFields
    mappedFields
    needReviewFields
    llmSkipped
    llmSkipReason
    llmRequiredFieldsCount
    llmMappedFieldsCount
    kindOptions {
      kind
      folder
      productField
    }
    finishedEdit {
      allowed
      reason
    }
    items {
      sourceFieldId
      sourceLabel
      marketplaceRawJson
      canonicalPath
      aiBand
      gateVerdict {
        status
        reason
        suggestedHome
      }
      registryStatus
      mappingSource
      provenance
      status
      requirementLevel
      lowConfidenceReason
      reviewReason
      reviewDetail
      answers
      llmReasoning
      arrayIndex
      canonicalDatatype
      sourceEnumValues
      sourceEnumValueLabels
      sourceEnumValueCount
      enumMappings
      enumMappingCount
      valueApprovals
      valueApprovalCount
      proposedDomainKey
      proposedDomainRationale
      domainKey
      domainSource
      domainExists
      unresolvedValueCount
      valueResolutionStatus
      valueResolutionSources
      enumDetailsTruncated
      pendingCanonicalExpansion
      canonicalExpansionRequestId
      duplicateCanonicalPath
      requiresReReview
      needsReview
      kind
      folder
      leaf
      leafSource
      pathPreview
      pool
      values
      warnings
      leafRejection
      remapped
      path
      pathType
      ownPath
      link
      linkOwner
      linkField
      hidden
      pastAnswer
      copyOf
      showKind
      review
      suggested
      agent {
        agreed
        answers {
          model
          path
          copy
          kind
          twin
          confidence
        }
      }
    }
  }
}
    `;

export const useAttributeReviewFieldMappingsQuery = <
  TData = AttributeReviewFieldMappingsQuery,
  TError = unknown,
>(
  variables: AttributeReviewFieldMappingsQueryVariables,
  options?: Omit<
    UseQueryOptions<AttributeReviewFieldMappingsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AttributeReviewFieldMappingsQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<AttributeReviewFieldMappingsQuery, TError, TData>({
    queryKey: ["AttributeReviewFieldMappings", variables],
    queryFn: fetcher<
      AttributeReviewFieldMappingsQuery,
      AttributeReviewFieldMappingsQueryVariables
    >(AttributeReviewFieldMappingsDocument, variables),
    ...options,
  });
};

useAttributeReviewFieldMappingsQuery.getKey = (
  variables: AttributeReviewFieldMappingsQueryVariables,
) => ["AttributeReviewFieldMappings", variables];

export const AttributeReviewSessionsUnderReviewDocument = `
    query AttributeReviewSessionsUnderReview($marketplace: String, $productType: String) {
  attributeReviewSessionsUnderReview(
    marketplace: $marketplace
    productType: $productType
  ) {
    mappingSessionId
    marketplace
    productType
    displayName
    needReviewFields
    status
  }
}
    `;

export const useAttributeReviewSessionsUnderReviewQuery = <
  TData = AttributeReviewSessionsUnderReviewQuery,
  TError = unknown,
>(
  variables?: AttributeReviewSessionsUnderReviewQueryVariables,
  options?: Omit<
    UseQueryOptions<AttributeReviewSessionsUnderReviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AttributeReviewSessionsUnderReviewQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<AttributeReviewSessionsUnderReviewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AttributeReviewSessionsUnderReview"]
        : ["AttributeReviewSessionsUnderReview", variables],
    queryFn: fetcher<
      AttributeReviewSessionsUnderReviewQuery,
      AttributeReviewSessionsUnderReviewQueryVariables
    >(AttributeReviewSessionsUnderReviewDocument, variables),
    ...options,
  });
};

useAttributeReviewSessionsUnderReviewQuery.getKey = (
  variables?: AttributeReviewSessionsUnderReviewQueryVariables,
) =>
  variables === undefined
    ? ["AttributeReviewSessionsUnderReview"]
    : ["AttributeReviewSessionsUnderReview", variables];

export const AttributeReviewValueDomainSearchDocument = `
    query AttributeReviewValueDomainSearch($query: String, $limit: Int) {
  attributeReviewValueDomainSearch(query: $query, limit: $limit) {
    items {
      domainKey
    }
  }
}
    `;

export const useAttributeReviewValueDomainSearchQuery = <
  TData = AttributeReviewValueDomainSearchQuery,
  TError = unknown,
>(
  variables?: AttributeReviewValueDomainSearchQueryVariables,
  options?: Omit<
    UseQueryOptions<AttributeReviewValueDomainSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AttributeReviewValueDomainSearchQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<AttributeReviewValueDomainSearchQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AttributeReviewValueDomainSearch"]
        : ["AttributeReviewValueDomainSearch", variables],
    queryFn: fetcher<
      AttributeReviewValueDomainSearchQuery,
      AttributeReviewValueDomainSearchQueryVariables
    >(AttributeReviewValueDomainSearchDocument, variables),
    ...options,
  });
};

useAttributeReviewValueDomainSearchQuery.getKey = (
  variables?: AttributeReviewValueDomainSearchQueryVariables,
) =>
  variables === undefined
    ? ["AttributeReviewValueDomainSearch"]
    : ["AttributeReviewValueDomainSearch", variables];

export const CoupangCategoryRecommendDocument = `
    query CoupangCategoryRecommend($input: CoupangCategoryRecommendInput!) {
  coupangCategoryRecommend(input: $input) {
    categories {
      categoryId
      categoryName
      resultType
    }
  }
}
    `;

export const useCoupangCategoryRecommendQuery = <
  TData = CoupangCategoryRecommendQuery,
  TError = unknown,
>(
  variables: CoupangCategoryRecommendQueryVariables,
  options?: Omit<
    UseQueryOptions<CoupangCategoryRecommendQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      CoupangCategoryRecommendQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<CoupangCategoryRecommendQuery, TError, TData>({
    queryKey: ["CoupangCategoryRecommend", variables],
    queryFn: fetcher<
      CoupangCategoryRecommendQuery,
      CoupangCategoryRecommendQueryVariables
    >(CoupangCategoryRecommendDocument, variables),
    ...options,
  });
};

useCoupangCategoryRecommendQuery.getKey = (
  variables: CoupangCategoryRecommendQueryVariables,
) => ["CoupangCategoryRecommend", variables];

export const CoupangCategorySchemaDigestDocument = `
    query CoupangCategorySchemaDigest($input: CoupangCategorySchemaDigestInput!) {
  coupangCategorySchemaDigest(input: $input) {
    displayCategoryCode
    canonicalSchemaPayload
  }
}
    `;

export const useCoupangCategorySchemaDigestQuery = <
  TData = CoupangCategorySchemaDigestQuery,
  TError = unknown,
>(
  variables: CoupangCategorySchemaDigestQueryVariables,
  options?: Omit<
    UseQueryOptions<CoupangCategorySchemaDigestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      CoupangCategorySchemaDigestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<CoupangCategorySchemaDigestQuery, TError, TData>({
    queryKey: ["CoupangCategorySchemaDigest", variables],
    queryFn: fetcher<
      CoupangCategorySchemaDigestQuery,
      CoupangCategorySchemaDigestQueryVariables
    >(CoupangCategorySchemaDigestDocument, variables),
    ...options,
  });
};

useCoupangCategorySchemaDigestQuery.getKey = (
  variables: CoupangCategorySchemaDigestQueryVariables,
) => ["CoupangCategorySchemaDigest", variables];

export const EbayCategorySchemaDigestDocument = `
    query EbayCategorySchemaDigest($input: EbayCategorySchemaDigestInput!) {
  ebayCategorySchemaDigest(input: $input) {
    categoryTreeId
    categoryId
    categoryName
    canonicalSchemaPayload
  }
}
    `;

export const useEbayCategorySchemaDigestQuery = <
  TData = EbayCategorySchemaDigestQuery,
  TError = unknown,
>(
  variables: EbayCategorySchemaDigestQueryVariables,
  options?: Omit<
    UseQueryOptions<EbayCategorySchemaDigestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      EbayCategorySchemaDigestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<EbayCategorySchemaDigestQuery, TError, TData>({
    queryKey: ["EbayCategorySchemaDigest", variables],
    queryFn: fetcher<
      EbayCategorySchemaDigestQuery,
      EbayCategorySchemaDigestQueryVariables
    >(EbayCategorySchemaDigestDocument, variables),
    ...options,
  });
};

useEbayCategorySchemaDigestQuery.getKey = (
  variables: EbayCategorySchemaDigestQueryVariables,
) => ["EbayCategorySchemaDigest", variables];

export const EbayCategorySearchDocument = `
    query EbayCategorySearch($input: EbayCategorySearchInput!) {
  ebayCategorySearch(input: $input) {
    categoryTreeId
    categories {
      categoryId
      categoryName
      fullPath
    }
  }
}
    `;

export const useEbayCategorySearchQuery = <
  TData = EbayCategorySearchQuery,
  TError = unknown,
>(
  variables: EbayCategorySearchQueryVariables,
  options?: Omit<
    UseQueryOptions<EbayCategorySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      EbayCategorySearchQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<EbayCategorySearchQuery, TError, TData>({
    queryKey: ["EbayCategorySearch", variables],
    queryFn: fetcher<EbayCategorySearchQuery, EbayCategorySearchQueryVariables>(
      EbayCategorySearchDocument,
      variables,
    ),
    ...options,
  });
};

useEbayCategorySearchQuery.getKey = (
  variables: EbayCategorySearchQueryVariables,
) => ["EbayCategorySearch", variables];

export const FlipkartVerticalSchemaDigestDocument = `
    query FlipkartVerticalSchemaDigest($input: FlipkartVerticalSchemaDigestInput!) {
  flipkartVerticalSchemaDigest(input: $input) {
    vertical
    canonicalSchemaPayload
    raw
  }
}
    `;

export const useFlipkartVerticalSchemaDigestQuery = <
  TData = FlipkartVerticalSchemaDigestQuery,
  TError = unknown,
>(
  variables: FlipkartVerticalSchemaDigestQueryVariables,
  options?: Omit<
    UseQueryOptions<FlipkartVerticalSchemaDigestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      FlipkartVerticalSchemaDigestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<FlipkartVerticalSchemaDigestQuery, TError, TData>({
    queryKey: ["FlipkartVerticalSchemaDigest", variables],
    queryFn: fetcher<
      FlipkartVerticalSchemaDigestQuery,
      FlipkartVerticalSchemaDigestQueryVariables
    >(FlipkartVerticalSchemaDigestDocument, variables),
    ...options,
  });
};

useFlipkartVerticalSchemaDigestQuery.getKey = (
  variables: FlipkartVerticalSchemaDigestQueryVariables,
) => ["FlipkartVerticalSchemaDigest", variables];

export const FormVersionLagDocument = `
    query FormVersionLag {
  formVersionLag {
    marketplace
    productType
    stamp
    stamped
    behind
  }
}
    `;

export const useFormVersionLagQuery = <
  TData = FormVersionLagQuery,
  TError = unknown,
>(
  variables?: FormVersionLagQueryVariables,
  options?: Omit<
    UseQueryOptions<FormVersionLagQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<FormVersionLagQuery, TError, TData>["queryKey"];
  },
) => {
  return useQuery<FormVersionLagQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["FormVersionLag"]
        : ["FormVersionLag", variables],
    queryFn: fetcher<FormVersionLagQuery, FormVersionLagQueryVariables>(
      FormVersionLagDocument,
      variables,
    ),
    ...options,
  });
};

useFormVersionLagQuery.getKey = (variables?: FormVersionLagQueryVariables) =>
  variables === undefined ? ["FormVersionLag"] : ["FormVersionLag", variables];

export const LeafImpactDocument = `
    query LeafImpact($path: String!) {
  leafImpact(path: $path) {
    products
    sellers
  }
}
    `;

export const useLeafImpactQuery = <TData = LeafImpactQuery, TError = unknown>(
  variables: LeafImpactQueryVariables,
  options?: Omit<
    UseQueryOptions<LeafImpactQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<LeafImpactQuery, TError, TData>["queryKey"];
  },
) => {
  return useQuery<LeafImpactQuery, TError, TData>({
    queryKey: ["LeafImpact", variables],
    queryFn: fetcher<LeafImpactQuery, LeafImpactQueryVariables>(
      LeafImpactDocument,
      variables,
    ),
    ...options,
  });
};

useLeafImpactQuery.getKey = (variables: LeafImpactQueryVariables) => [
  "LeafImpact",
  variables,
];

export const LeafUsersDocument = `
    query LeafUsers($path: String!) {
  leafUsers(path: $path) {
    marketplace
    productType
    productTypeName
    label
  }
}
    `;

export const useLeafUsersQuery = <TData = LeafUsersQuery, TError = unknown>(
  variables: LeafUsersQueryVariables,
  options?: Omit<UseQueryOptions<LeafUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<LeafUsersQuery, TError, TData>["queryKey"];
  },
) => {
  return useQuery<LeafUsersQuery, TError, TData>({
    queryKey: ["LeafUsers", variables],
    queryFn: fetcher<LeafUsersQuery, LeafUsersQueryVariables>(
      LeafUsersDocument,
      variables,
    ),
    ...options,
  });
};

useLeafUsersQuery.getKey = (variables: LeafUsersQueryVariables) => [
  "LeafUsers",
  variables,
];

export const LeavesDocument = `
    query Leaves($query: String, $folder: String) {
  leaves(query: $query, folder: $folder) {
    path
    folder
    leaf
    description
    status
    perStore
    alwaysRequired
    usedBy
    usedByStores
    anchor
    label
    inputType
    helpText
  }
}
    `;

export const useLeavesQuery = <TData = LeavesQuery, TError = unknown>(
  variables?: LeavesQueryVariables,
  options?: Omit<UseQueryOptions<LeavesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<LeavesQuery, TError, TData>["queryKey"];
  },
) => {
  return useQuery<LeavesQuery, TError, TData>({
    queryKey: variables === undefined ? ["Leaves"] : ["Leaves", variables],
    queryFn: fetcher<LeavesQuery, LeavesQueryVariables>(
      LeavesDocument,
      variables,
    ),
    ...options,
  });
};

useLeavesQuery.getKey = (variables?: LeavesQueryVariables) =>
  variables === undefined ? ["Leaves"] : ["Leaves", variables];

export const MarketplaceCategorySearchDocument = `
    query MarketplaceCategorySearch($input: MarketplaceCategorySearchInput!) {
  marketplaceCategorySearch(input: $input) {
    categories {
      categoryId
      categoryName
      fullPath
    }
  }
}
    `;

export const useMarketplaceCategorySearchQuery = <
  TData = MarketplaceCategorySearchQuery,
  TError = unknown,
>(
  variables: MarketplaceCategorySearchQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceCategorySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MarketplaceCategorySearchQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<MarketplaceCategorySearchQuery, TError, TData>({
    queryKey: ["MarketplaceCategorySearch", variables],
    queryFn: fetcher<
      MarketplaceCategorySearchQuery,
      MarketplaceCategorySearchQueryVariables
    >(MarketplaceCategorySearchDocument, variables),
    ...options,
  });
};

useMarketplaceCategorySearchQuery.getKey = (
  variables: MarketplaceCategorySearchQueryVariables,
) => ["MarketplaceCategorySearch", variables];

export const MarketplaceFacilitatorStatusDocument = `
    query MarketplaceFacilitatorStatus($workspaceId: ID!) {
  marketplaceFacilitatorStatus(workspaceId: $workspaceId) {
    marketplaceCode
    marketplaceName
    markedId
    connected
    linkedProducts
    openOrders
    sellers
  }
}
    `;

export const useMarketplaceFacilitatorStatusQuery = <
  TData = MarketplaceFacilitatorStatusQuery,
  TError = unknown,
>(
  variables: MarketplaceFacilitatorStatusQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceFacilitatorStatusQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MarketplaceFacilitatorStatusQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<MarketplaceFacilitatorStatusQuery, TError, TData>({
    queryKey: ["MarketplaceFacilitatorStatus", variables],
    queryFn: fetcher<
      MarketplaceFacilitatorStatusQuery,
      MarketplaceFacilitatorStatusQueryVariables
    >(MarketplaceFacilitatorStatusDocument, variables),
    ...options,
  });
};

useMarketplaceFacilitatorStatusQuery.getKey = (
  variables: MarketplaceFacilitatorStatusQueryVariables,
) => ["MarketplaceFacilitatorStatus", variables];

export const MarketplaceMappingSessionApprovalSyncDocument = `
    query MarketplaceMappingSessionApprovalSync($mappingSessionId: ID!) {
  marketplaceMappingSession(mappingSessionId: $mappingSessionId) {
    approvalSync {
      status
      error
      errorDetails
    }
  }
}
    `;

export const useMarketplaceMappingSessionApprovalSyncQuery = <
  TData = MarketplaceMappingSessionApprovalSyncQuery,
  TError = unknown,
>(
  variables: MarketplaceMappingSessionApprovalSyncQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceMappingSessionApprovalSyncQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MarketplaceMappingSessionApprovalSyncQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<MarketplaceMappingSessionApprovalSyncQuery, TError, TData>({
    queryKey: ["MarketplaceMappingSessionApprovalSync", variables],
    queryFn: fetcher<
      MarketplaceMappingSessionApprovalSyncQuery,
      MarketplaceMappingSessionApprovalSyncQueryVariables
    >(MarketplaceMappingSessionApprovalSyncDocument, variables),
    ...options,
  });
};

useMarketplaceMappingSessionApprovalSyncQuery.getKey = (
  variables: MarketplaceMappingSessionApprovalSyncQueryVariables,
) => ["MarketplaceMappingSessionApprovalSync", variables];

export const MarketplaceMappingSessionsDocument = `
    query MarketplaceMappingSessions($input: MarketplaceMappingSessionsInput) {
  marketplaceMappingSessions(input: $input) {
    items {
      id
      marketplace
      productType
      displayName
      canonicalCategory
      status
      approvalSyncRetryable
      mappedAt
      mappedBy
      confidence
      totalBlocked
      mappingSessionId
      createdAt
      updatedAt
    }
    counts {
      total
      mapped
      pending
      needsReview
      failed
    }
    pageInfo {
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPreviousPage
    }
    marketplaces
  }
}
    `;

export const useMarketplaceMappingSessionsQuery = <
  TData = MarketplaceMappingSessionsQuery,
  TError = unknown,
>(
  variables?: MarketplaceMappingSessionsQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceMappingSessionsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MarketplaceMappingSessionsQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<MarketplaceMappingSessionsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["MarketplaceMappingSessions"]
        : ["MarketplaceMappingSessions", variables],
    queryFn: fetcher<
      MarketplaceMappingSessionsQuery,
      MarketplaceMappingSessionsQueryVariables
    >(MarketplaceMappingSessionsDocument, variables),
    ...options,
  });
};

useMarketplaceMappingSessionsQuery.getKey = (
  variables?: MarketplaceMappingSessionsQueryVariables,
) =>
  variables === undefined
    ? ["MarketplaceMappingSessions"]
    : ["MarketplaceMappingSessions", variables];

export const MarketplacesDocument = `
    query Marketplaces {
  marketplaces {
    id
    code
    name
    status
    syncStatus
    lastSyncedAt
    websiteUrl
    syncConfig
  }
}
    `;

export const useMarketplacesQuery = <
  TData = MarketplacesQuery,
  TError = unknown,
>(
  variables?: MarketplacesQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplacesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplacesQuery, TError, TData>["queryKey"];
  },
) => {
  return useQuery<MarketplacesQuery, TError, TData>({
    queryKey:
      variables === undefined ? ["Marketplaces"] : ["Marketplaces", variables],
    queryFn: fetcher<MarketplacesQuery, MarketplacesQueryVariables>(
      MarketplacesDocument,
      variables,
    ),
    ...options,
  });
};

useMarketplacesQuery.getKey = (variables?: MarketplacesQueryVariables) =>
  variables === undefined ? ["Marketplaces"] : ["Marketplaces", variables];

export const MeeshoProductTypeSchemaDigestDocument = `
    query MeeshoProductTypeSchemaDigest($input: MeeshoProductTypeSchemaDigestInput!) {
  meeshoProductTypeSchemaDigest(input: $input) {
    sscatId
    productType
    categoryPath
    canonicalSchemaPayload
    aiResponse
  }
}
    `;

export const useMeeshoProductTypeSchemaDigestQuery = <
  TData = MeeshoProductTypeSchemaDigestQuery,
  TError = unknown,
>(
  variables: MeeshoProductTypeSchemaDigestQueryVariables,
  options?: Omit<
    UseQueryOptions<MeeshoProductTypeSchemaDigestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MeeshoProductTypeSchemaDigestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<MeeshoProductTypeSchemaDigestQuery, TError, TData>({
    queryKey: ["MeeshoProductTypeSchemaDigest", variables],
    queryFn: fetcher<
      MeeshoProductTypeSchemaDigestQuery,
      MeeshoProductTypeSchemaDigestQueryVariables
    >(MeeshoProductTypeSchemaDigestDocument, variables),
    ...options,
  });
};

useMeeshoProductTypeSchemaDigestQuery.getKey = (
  variables: MeeshoProductTypeSchemaDigestQueryVariables,
) => ["MeeshoProductTypeSchemaDigest", variables];

export const MeeshoSearchProductTypesDocument = `
    query MeeshoSearchProductTypes($input: MeeshoSearchProductTypesInput!) {
  meeshoSearchProductTypes(input: $input) {
    productTypes {
      name
      displayName
      synced
    }
  }
}
    `;

export const useMeeshoSearchProductTypesQuery = <
  TData = MeeshoSearchProductTypesQuery,
  TError = unknown,
>(
  variables: MeeshoSearchProductTypesQueryVariables,
  options?: Omit<
    UseQueryOptions<MeeshoSearchProductTypesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MeeshoSearchProductTypesQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<MeeshoSearchProductTypesQuery, TError, TData>({
    queryKey: ["MeeshoSearchProductTypes", variables],
    queryFn: fetcher<
      MeeshoSearchProductTypesQuery,
      MeeshoSearchProductTypesQueryVariables
    >(MeeshoSearchProductTypesDocument, variables),
    ...options,
  });
};

useMeeshoSearchProductTypesQuery.getKey = (
  variables: MeeshoSearchProductTypesQueryVariables,
) => ["MeeshoSearchProductTypes", variables];

export const PublishRejectionsDocument = `
    query PublishRejections($limit: Int) {
  publishRejections(limit: $limit) {
    id
    marketplace
    productType
    error
    failedAt
  }
}
    `;

export const usePublishRejectionsQuery = <
  TData = PublishRejectionsQuery,
  TError = unknown,
>(
  variables?: PublishRejectionsQueryVariables,
  options?: Omit<
    UseQueryOptions<PublishRejectionsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      PublishRejectionsQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<PublishRejectionsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["PublishRejections"]
        : ["PublishRejections", variables],
    queryFn: fetcher<PublishRejectionsQuery, PublishRejectionsQueryVariables>(
      PublishRejectionsDocument,
      variables,
    ),
    ...options,
  });
};

usePublishRejectionsQuery.getKey = (
  variables?: PublishRejectionsQueryVariables,
) =>
  variables === undefined
    ? ["PublishRejections"]
    : ["PublishRejections", variables];

export const ShopifyProductTypeSchemaDigestDocument = `
    query ShopifyProductTypeSchemaDigest($input: ShopifyProductTypeSchemaDigestInput!) {
  shopifyProductTypeSchemaDigest(input: $input) {
    aiResponse
    canonicalSchemaPayload
  }
}
    `;

export const useShopifyProductTypeSchemaDigestQuery = <
  TData = ShopifyProductTypeSchemaDigestQuery,
  TError = unknown,
>(
  variables: ShopifyProductTypeSchemaDigestQueryVariables,
  options?: Omit<
    UseQueryOptions<ShopifyProductTypeSchemaDigestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      ShopifyProductTypeSchemaDigestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<ShopifyProductTypeSchemaDigestQuery, TError, TData>({
    queryKey: ["ShopifyProductTypeSchemaDigest", variables],
    queryFn: fetcher<
      ShopifyProductTypeSchemaDigestQuery,
      ShopifyProductTypeSchemaDigestQueryVariables
    >(ShopifyProductTypeSchemaDigestDocument, variables),
    ...options,
  });
};

useShopifyProductTypeSchemaDigestQuery.getKey = (
  variables: ShopifyProductTypeSchemaDigestQueryVariables,
) => ["ShopifyProductTypeSchemaDigest", variables];

export const ShopifySearchProductTypesDocument = `
    query ShopifySearchProductTypes($input: ShopifySearchProductTypesInput!) {
  shopifySearchProductTypes(input: $input) {
    productTypes {
      name
      synced
    }
  }
}
    `;

export const useShopifySearchProductTypesQuery = <
  TData = ShopifySearchProductTypesQuery,
  TError = unknown,
>(
  variables: ShopifySearchProductTypesQueryVariables,
  options?: Omit<
    UseQueryOptions<ShopifySearchProductTypesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      ShopifySearchProductTypesQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<ShopifySearchProductTypesQuery, TError, TData>({
    queryKey: ["ShopifySearchProductTypes", variables],
    queryFn: fetcher<
      ShopifySearchProductTypesQuery,
      ShopifySearchProductTypesQueryVariables
    >(ShopifySearchProductTypesDocument, variables),
    ...options,
  });
};

useShopifySearchProductTypesQuery.getKey = (
  variables: ShopifySearchProductTypesQueryVariables,
) => ["ShopifySearchProductTypes", variables];

export const SnapdealCategorySchemaDigestDocument = `
    query SnapdealCategorySchemaDigest($input: SnapdealCategorySchemaDigestInput!) {
  snapdealCategorySchemaDigest(input: $input) {
    categoryId
    canonicalSchemaPayload
    raw
  }
}
    `;

export const useSnapdealCategorySchemaDigestQuery = <
  TData = SnapdealCategorySchemaDigestQuery,
  TError = unknown,
>(
  variables: SnapdealCategorySchemaDigestQueryVariables,
  options?: Omit<
    UseQueryOptions<SnapdealCategorySchemaDigestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      SnapdealCategorySchemaDigestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<SnapdealCategorySchemaDigestQuery, TError, TData>({
    queryKey: ["SnapdealCategorySchemaDigest", variables],
    queryFn: fetcher<
      SnapdealCategorySchemaDigestQuery,
      SnapdealCategorySchemaDigestQueryVariables
    >(SnapdealCategorySchemaDigestDocument, variables),
    ...options,
  });
};

useSnapdealCategorySchemaDigestQuery.getKey = (
  variables: SnapdealCategorySchemaDigestQueryVariables,
) => ["SnapdealCategorySchemaDigest", variables];

export const SnapdealCategorySearchDocument = `
    query SnapdealCategorySearch($input: SnapdealCategorySearchInput!) {
  snapdealCategorySearch(input: $input) {
    categories {
      categoryId
      categoryName
      fullPath
      leaf
    }
  }
}
    `;

export const useSnapdealCategorySearchQuery = <
  TData = SnapdealCategorySearchQuery,
  TError = unknown,
>(
  variables: SnapdealCategorySearchQueryVariables,
  options?: Omit<
    UseQueryOptions<SnapdealCategorySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      SnapdealCategorySearchQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<SnapdealCategorySearchQuery, TError, TData>({
    queryKey: ["SnapdealCategorySearch", variables],
    queryFn: fetcher<
      SnapdealCategorySearchQuery,
      SnapdealCategorySearchQueryVariables
    >(SnapdealCategorySearchDocument, variables),
    ...options,
  });
};

useSnapdealCategorySearchQuery.getKey = (
  variables: SnapdealCategorySearchQueryVariables,
) => ["SnapdealCategorySearch", variables];

export const TaxonomyApprovalPipelineJobDocument = `
    query TaxonomyApprovalPipelineJob($syncJobId: ID!) {
  taxonomyApprovalPipelineJob(syncJobId: $syncJobId) {
    job {
      syncJobId
      mappingSessionId
      resourceLockKey
      status
      retryable
      error
      errorType
      message
      attemptCount
      pipelineId
      taxonomyJobId
      taxonomyStatus
      approvedBy
      notes
      fieldDecisionCount
      canonicalValueDecisionCount
      marketplaceSpecificValueDecisionCount
      queuedAt
      startedAt
      dispatchedAt
      completedAt
      failedAt
      createdAt
      updatedAt
      payload
      lastLedgerEventType
      lastLedgerAt
      availableActions
    }
    ledger {
      id
      syncJobId
      status
      eventType
      error
      retryable
      payload
      createdAt
    }
  }
}
    `;

export const useTaxonomyApprovalPipelineJobQuery = <
  TData = TaxonomyApprovalPipelineJobQuery,
  TError = unknown,
>(
  variables: TaxonomyApprovalPipelineJobQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomyApprovalPipelineJobQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomyApprovalPipelineJobQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomyApprovalPipelineJobQuery, TError, TData>({
    queryKey: ["TaxonomyApprovalPipelineJob", variables],
    queryFn: fetcher<
      TaxonomyApprovalPipelineJobQuery,
      TaxonomyApprovalPipelineJobQueryVariables
    >(TaxonomyApprovalPipelineJobDocument, variables),
    ...options,
  });
};

useTaxonomyApprovalPipelineJobQuery.getKey = (
  variables: TaxonomyApprovalPipelineJobQueryVariables,
) => ["TaxonomyApprovalPipelineJob", variables];

export const TaxonomyApprovalPipelineJobsDocument = `
    query TaxonomyApprovalPipelineJobs($input: TaxonomyApprovalPipelineJobsInput) {
  taxonomyApprovalPipelineJobs(input: $input) {
    items {
      syncJobId
      mappingSessionId
      resourceLockKey
      status
      retryable
      error
      errorType
      message
      attemptCount
      pipelineId
      taxonomyJobId
      taxonomyStatus
      approvedBy
      notes
      fieldDecisionCount
      canonicalValueDecisionCount
      marketplaceSpecificValueDecisionCount
      queuedAt
      startedAt
      dispatchedAt
      completedAt
      failedAt
      createdAt
      updatedAt
      lastLedgerEventType
      lastLedgerAt
      availableActions
    }
  }
}
    `;

export const useTaxonomyApprovalPipelineJobsQuery = <
  TData = TaxonomyApprovalPipelineJobsQuery,
  TError = unknown,
>(
  variables?: TaxonomyApprovalPipelineJobsQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomyApprovalPipelineJobsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomyApprovalPipelineJobsQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomyApprovalPipelineJobsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["TaxonomyApprovalPipelineJobs"]
        : ["TaxonomyApprovalPipelineJobs", variables],
    queryFn: fetcher<
      TaxonomyApprovalPipelineJobsQuery,
      TaxonomyApprovalPipelineJobsQueryVariables
    >(TaxonomyApprovalPipelineJobsDocument, variables),
    ...options,
  });
};

useTaxonomyApprovalPipelineJobsQuery.getKey = (
  variables?: TaxonomyApprovalPipelineJobsQueryVariables,
) =>
  variables === undefined
    ? ["TaxonomyApprovalPipelineJobs"]
    : ["TaxonomyApprovalPipelineJobs", variables];

export const TaxonomyCategoriesSearchDocument = `
    query TaxonomyCategoriesSearch($q: String!) {
  taxonomyCategoriesSearch(q: $q) {
    path
    score
  }
}
    `;

export const useTaxonomyCategoriesSearchQuery = <
  TData = TaxonomyCategoriesSearchQuery,
  TError = unknown,
>(
  variables: TaxonomyCategoriesSearchQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomyCategoriesSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomyCategoriesSearchQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomyCategoriesSearchQuery, TError, TData>({
    queryKey: ["TaxonomyCategoriesSearch", variables],
    queryFn: fetcher<
      TaxonomyCategoriesSearchQuery,
      TaxonomyCategoriesSearchQueryVariables
    >(TaxonomyCategoriesSearchDocument, variables),
    ...options,
  });
};

useTaxonomyCategoriesSearchQuery.getKey = (
  variables: TaxonomyCategoriesSearchQueryVariables,
) => ["TaxonomyCategoriesSearch", variables];

export const TaxonomyCategoriesSuggestDocument = `
    query TaxonomyCategoriesSuggest($q: String!, $hints: [String!], $limit: Int, $marketplace: String, $productType: String) {
  taxonomyCategoriesSuggest(
    q: $q
    hints: $hints
    limit: $limit
    marketplace: $marketplace
    productType: $productType
  ) {
    categoryPath
    score
    mappedTo {
      productType
      marketplaceCategoryId
      status
      lastSyncFailed
    }
  }
}
    `;

export const useTaxonomyCategoriesSuggestQuery = <
  TData = TaxonomyCategoriesSuggestQuery,
  TError = unknown,
>(
  variables: TaxonomyCategoriesSuggestQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomyCategoriesSuggestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomyCategoriesSuggestQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomyCategoriesSuggestQuery, TError, TData>({
    queryKey: ["TaxonomyCategoriesSuggest", variables],
    queryFn: fetcher<
      TaxonomyCategoriesSuggestQuery,
      TaxonomyCategoriesSuggestQueryVariables
    >(TaxonomyCategoriesSuggestDocument, variables),
    ...options,
  });
};

useTaxonomyCategoriesSuggestQuery.getKey = (
  variables: TaxonomyCategoriesSuggestQueryVariables,
) => ["TaxonomyCategoriesSuggest", variables];

export const TaxonomyIngestionRunDocument = `
    query TaxonomyIngestionRun($runId: ID!) {
  taxonomyIngestionRun(runId: $runId) {
    runId
    marketplace
    productType
    displayName
    workspaceId
    status
    progressPercent
    stageKey
    stageLabel
    userMessage
    technicalMessage
    approxRemainingLabel
    mappingSessionId
    externalSessionId
    startedAt
    updatedAt
    completedAt
    terminal
  }
}
    `;

export const useTaxonomyIngestionRunQuery = <
  TData = TaxonomyIngestionRunQuery,
  TError = unknown,
>(
  variables: TaxonomyIngestionRunQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomyIngestionRunQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomyIngestionRunQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomyIngestionRunQuery, TError, TData>({
    queryKey: ["TaxonomyIngestionRun", variables],
    queryFn: fetcher<
      TaxonomyIngestionRunQuery,
      TaxonomyIngestionRunQueryVariables
    >(TaxonomyIngestionRunDocument, variables),
    ...options,
  });
};

useTaxonomyIngestionRunQuery.getKey = (
  variables: TaxonomyIngestionRunQueryVariables,
) => ["TaxonomyIngestionRun", variables];

export const TaxonomyIngestionRunsDocument = `
    query TaxonomyIngestionRuns($marketplace: String, $statuses: [String!], $includeCompleted: Boolean, $limit: Int) {
  taxonomyIngestionRuns(
    marketplace: $marketplace
    statuses: $statuses
    includeCompleted: $includeCompleted
    limit: $limit
  ) {
    runId
    marketplace
    productType
    displayName
    workspaceId
    status
    progressPercent
    stageKey
    stageLabel
    userMessage
    technicalMessage
    approxRemainingLabel
    mappingSessionId
    externalSessionId
    startedAt
    updatedAt
    completedAt
    terminal
  }
}
    `;

export const useTaxonomyIngestionRunsQuery = <
  TData = TaxonomyIngestionRunsQuery,
  TError = unknown,
>(
  variables?: TaxonomyIngestionRunsQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomyIngestionRunsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomyIngestionRunsQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomyIngestionRunsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["TaxonomyIngestionRuns"]
        : ["TaxonomyIngestionRuns", variables],
    queryFn: fetcher<
      TaxonomyIngestionRunsQuery,
      TaxonomyIngestionRunsQueryVariables
    >(TaxonomyIngestionRunsDocument, variables),
    ...options,
  });
};

useTaxonomyIngestionRunsQuery.getKey = (
  variables?: TaxonomyIngestionRunsQueryVariables,
) =>
  variables === undefined
    ? ["TaxonomyIngestionRuns"]
    : ["TaxonomyIngestionRuns", variables];

export const TaxonomyResolutionTasksDocument = `
    query TaxonomyResolutionTasks($marketplace: String, $status: String) {
  taxonomyResolutionTasks(marketplace: $marketplace, status: $status) {
    id
    marketplace
    productType
    status
    totalBlocked
    resolvedAt
  }
}
    `;

export const useTaxonomyResolutionTasksQuery = <
  TData = TaxonomyResolutionTasksQuery,
  TError = unknown,
>(
  variables?: TaxonomyResolutionTasksQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomyResolutionTasksQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomyResolutionTasksQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomyResolutionTasksQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["TaxonomyResolutionTasks"]
        : ["TaxonomyResolutionTasks", variables],
    queryFn: fetcher<
      TaxonomyResolutionTasksQuery,
      TaxonomyResolutionTasksQueryVariables
    >(TaxonomyResolutionTasksDocument, variables),
    ...options,
  });
};

useTaxonomyResolutionTasksQuery.getKey = (
  variables?: TaxonomyResolutionTasksQueryVariables,
) =>
  variables === undefined
    ? ["TaxonomyResolutionTasks"]
    : ["TaxonomyResolutionTasks", variables];

export const TaxonomySupportedCategoriesDocument = `
    query TaxonomySupportedCategories($marketplace: String!) {
  taxonomySupportedCategories(marketplace: $marketplace) {
    marketplace
    productType
    canonicalCategoryId
    canonicalCategoryName
    canonicalCategoryParent
    canonicalCategoryLevel
    mappedFields
    status
  }
}
    `;

export const useTaxonomySupportedCategoriesQuery = <
  TData = TaxonomySupportedCategoriesQuery,
  TError = unknown,
>(
  variables: TaxonomySupportedCategoriesQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomySupportedCategoriesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomySupportedCategoriesQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomySupportedCategoriesQuery, TError, TData>({
    queryKey: ["TaxonomySupportedCategories", variables],
    queryFn: fetcher<
      TaxonomySupportedCategoriesQuery,
      TaxonomySupportedCategoriesQueryVariables
    >(TaxonomySupportedCategoriesDocument, variables),
    ...options,
  });
};

useTaxonomySupportedCategoriesQuery.getKey = (
  variables: TaxonomySupportedCategoriesQueryVariables,
) => ["TaxonomySupportedCategories", variables];

export const TaxonomySupportedMarketplacesDocument = `
    query TaxonomySupportedMarketplaces {
  taxonomySupportedMarketplaces {
    marketplace
    categoryCount
  }
}
    `;

export const useTaxonomySupportedMarketplacesQuery = <
  TData = TaxonomySupportedMarketplacesQuery,
  TError = unknown,
>(
  variables?: TaxonomySupportedMarketplacesQueryVariables,
  options?: Omit<
    UseQueryOptions<TaxonomySupportedMarketplacesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      TaxonomySupportedMarketplacesQuery,
      TError,
      TData
    >["queryKey"];
  },
) => {
  return useQuery<TaxonomySupportedMarketplacesQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["TaxonomySupportedMarketplaces"]
        : ["TaxonomySupportedMarketplaces", variables],
    queryFn: fetcher<
      TaxonomySupportedMarketplacesQuery,
      TaxonomySupportedMarketplacesQueryVariables
    >(TaxonomySupportedMarketplacesDocument, variables),
    ...options,
  });
};

useTaxonomySupportedMarketplacesQuery.getKey = (
  variables?: TaxonomySupportedMarketplacesQueryVariables,
) =>
  variables === undefined
    ? ["TaxonomySupportedMarketplaces"]
    : ["TaxonomySupportedMarketplaces", variables];

export const ViewerBootstrapDocument = `
    query ViewerBootstrap {
  viewerBootstrap {
    workspace {
      id
      name
      marketplaceConnections {
        id
        provider
        status
        externalSellerId
      }
    }
  }
}
    `;

export const useViewerBootstrapQuery = <
  TData = ViewerBootstrapQuery,
  TError = unknown,
>(
  variables?: ViewerBootstrapQueryVariables,
  options?: Omit<
    UseQueryOptions<ViewerBootstrapQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<ViewerBootstrapQuery, TError, TData>["queryKey"];
  },
) => {
  return useQuery<ViewerBootstrapQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ViewerBootstrap"]
        : ["ViewerBootstrap", variables],
    queryFn: fetcher<ViewerBootstrapQuery, ViewerBootstrapQueryVariables>(
      ViewerBootstrapDocument,
      variables,
    ),
    ...options,
  });
};

useViewerBootstrapQuery.getKey = (variables?: ViewerBootstrapQueryVariables) =>
  variables === undefined
    ? ["ViewerBootstrap"]
    : ["ViewerBootstrap", variables];

export const TaxonomyApprovalPipelineDocument = `
    subscription TaxonomyApprovalPipeline($syncJobId: ID!) {
  taxonomyApprovalPipeline(syncJobId: $syncJobId) {
    eventId
    eventType
    syncJobId
    taxonomyJobId
    pipelineId
    mappingSessionId
    resourceLockKey
    status
    taxonomyStatus
    retryable
    message
    errorType
    error
    errorDetails
    affected
    fieldResults
    valueResults
    payload
    terminal
    occurredAt
  }
}
    `;
export const TaxonomyIngestionSessionDocument = `
    subscription TaxonomyIngestionSession($runId: ID!) {
  taxonomyIngestionSession(runId: $runId) {
    eventId
    eventType
    runId
    marketplace
    productType
    workspaceId
    status
    progressPercent
    stageKey
    stageLabel
    userMessage
    technicalMessage
    approxRemainingLabel
    mappingSessionId
    externalSessionId
    payload
    occurredAt
    elapsedMs
    terminal
  }
}
    `;
export const TaxonomyMappingSessionDocument = `
    subscription TaxonomyMappingSession($sessionId: ID!) {
  taxonomyMappingSession(sessionId: $sessionId) {
    sessionId
    status
    progress
    payload
  }
}
    `;
